/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps */
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import axios from "axios";
import "./style.css";
import InputMask from "../../components/InputMask/index.js";
import { NumericFormat } from "react-number-format";
import { useForm } from "react-hook-form";
import { TbDoorExit } from "react-icons/tb";
import { jwtDecode } from "jwt-decode";
import { API_ENDPOINTS, API_BASE_URL } from "../../../js/api.js";
import { toDateInputValue } from "../../../js/dateHelpers.js";
import {
  buildAnexosObrigatoriosIds,
  buildAnexosObrigatoriosBodyPatch,
  parseAnexosObrigatoriosFromError,
  hydrateAnexosFilesFromPayload,
} from "../../js/anexosObrigatorios.js";
import { invalidarCacheListaAcompanhamento } from "../Acompanhamento/utils/session.js";
import { getLimiteHorasAprendizagem } from "../TCA/index.js";
import FormReview from "../../components/Compos Validation/index.js";
import MissingFieldsAlert from "../../components/Fill-inAlert/index.js";
import ToastContainer from "../../components/Toast/ToastContainer.js";
import useToast from "../../hooks/useToast.js";
import useConfirm from "../../hooks/useConfirm.js";
import DocumentUploadForm from "../../components/DocumentUploadForm/index.js";
import SuccessSubmitModal from "../../components/SuccessSubmitModal/index.js";
import {
  Check,
  CheckCircle2,
  AlertCircle,
  Circle,
  Upload,
  Paperclip,
  Home,
  GraduationCap,
  IdCard,
  FileText,
  Trash2,
} from "lucide-react";

export const LINK_DOCUSIGN_TCA_CIEEMG_FALLBACK =
  "https://na2.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=332d1eb3-e52c-497a-bcf9-da18ae0d0234&env=na2&acct=272fb0e3-8eca-4797-ac82-b4ba543c625f&v=2";

export const CAMPOS_APRENDIZ_BLOQUEADOS_EMPRESA = new Set([
  "nome_mae",
  "cpf_mae",
  "telefone_mae",
  "email_mae",
  "data_nascimento_mae",
  "naturalidade_mae",
  "estado_civil_mae",
  "logradouro",
  "numero_endereco",
  "complemento",
  "bairro",
  "cep",
  "cidade",
  "estado_endereco",
  "pais",
  "telefone_02",
  "grau_instrucao",
  "curso_escolaridade",
  "instituicao_ensino",
  "conclusao",
  "pis",
  "rg",
  "data_emissao_rg",
  "orgao_emissor_rg",
  "estado_rg",
  "titulo_eleitor",
  "zona",
  "secao",
  "data_emissao_titulo",
  "banco_pagamento",
  "agencia",
  "div1",
  "conta",
  "div2",
  "trabalhou_ambiente_insalubre",
  "risco_exposto",
  "endereco_residencial_vt",
  "servicos_meios_transporte",
  "qtd_dia_pratica",
  "linha_pratica_ida_1",
  "tarifa_pratica_ida_1",
  "linha_pratica_ida_2",
  "tarifa_pratica_ida_2",
  "linha_pratica_volta_1",
  "tarifa_pratica_volta_1",
  "linha_pratica_volta_2",
  "tarifa_pratica_volta_2",
  "qtd_dia_teorica",
  "linha_teorica_ida__1",
  "tarifa_teorica_ida_1",
  "linha_teorica_ida_2",
  "tarifa_teorica_ida_2",
  "linha_teorica_volta_1",
  "tarifa_teorica_volta_1",
  "linha_teorica_volta_2",
  "tarifa_teorica_volta_2",
  "deseja_vale_transporte",
  "possui_dependentes",
  "nome_declarante_ir",
  "cpf_declarante_ir",
  "estado_civil_ir",
  "doc_comprovante_endereco",
  "doc_declaracao_escolar",
  "doc_identificacao_documento_indetificacao",
  "doc_pis",
  "doc_tipo_sanguineo",
  "doc_certificado_reservista",
  "doc_certidao_casamento",
  "doc_titulo_eleitor",
  "doc_curriculum",
  "doc_curso_qualificacao",
  "doc_foto_3x4",
]);

for (let i = 1; i <= 10; i += 1) {
  [
    "nome",
    "cpf",
    "data_nascimento",
    "idade",
    "sexo",
    "grau_parentesco",
    "naturalidade",
  ].forEach((sufixo) => {
    CAMPOS_APRENDIZ_BLOQUEADOS_EMPRESA.add(`dependente_${i}_${sufixo}`);
  });
}

export const STATUS_CORES = {
  PENDENTE: "#3b82f6",
  APROVADO: "#1e3a8a",
  RECUSADO: "#dc2626",
};

export const formatDateBR = (dateString) => {
  if (!dateString) return "";
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return dateString;
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
};

export const formatarCnpjCpf = (valor) => {
  if (!valor) return "";

  const nums = valor.replace(/\D/g, "").slice(0, 14);
  if (nums.length === 0) return "";
  if (nums.length <= 11) {
    return nums
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  } else {
    return nums
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
  }
};

export const isTelefonePlaceholder = (valor) => {
  if (!valor) return false;
  const nums = String(valor).replace(/\D/g, "");
  if (nums.length < 8) return false;
  return /^(\d)\1+$/.test(nums);
};

export const sanitizeTelefone = (valor) => {
  if (!valor) return "";
  if (isTelefonePlaceholder(valor)) return "";
  return String(valor);
};

export const parseSalario = (val) => {
  if (val === null || val === undefined) return 0;
  if (typeof val === "number") return val;
  const cleaned = String(val)
    .replace("R$", "")
    .replace(/\s/g, "")
    .replace(/\./g, "")
    .replace(",", ".");
  const num = parseFloat(cleaned);
  return isNaN(num) ? 0 : num;
};

const TcaCieemgEmpregador = () => {
  const navigate = useNavigate();
  const submittingRef = useRef(false);
  const matrizEnderecoTeoricoRef = useRef("");
  const matrizEnderecoRef = useRef({});
  const carregarTcaExistenteRef = useRef(null);
  const tcaCarregadoEmRef = useRef(0);
  const tcaForm = useForm({ mode: "onSubmit" });
  const { handleSubmit: rhfHandleSubmit, setValue: setTcaFormValue } = tcaForm;
  const user = useMemo(() => {
    try {
      const raw = localStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }, []);
  const [autorizado, setAutorizado] = useState(false);

  const calcularPermissao = useCallback(() => {
    const nivel = Number(user?.acesso_autorizacao ?? 0);
    return {
      podeEditarEmpresa: [0, 2, 3, 4].includes(nivel),
      podeEditarEstudante: [1, 2, 3, 4].includes(nivel),
      podeEditarTudo: [2, 3, 4].includes(nivel),
      podeAprovar: [3, 4].includes(nivel),
      somenteLeituraEstudante: [0].includes(nivel),
    };
  }, [user]);

  const [permissao, setPermissao] = useState(calcularPermissao);
  const [autorizacaoTca, setAutorizacaoTca] = useState(null);
  const [modoEdicao, setModoEdicao] = useState(false);
  const [tcaId, setTcaId] = useState(null);
  const [tcaStatus, setTcaStatus] = useState(null);
  const [datasVigenciaFuturas, setDatasVigenciaFuturas] = useState([]);
  const [cursosFiltrados, setCursosFiltrados] = useState([]);
  const [tcaHistorico, setTcaHistorico] = useState([]);
  const [showReview, setShowReview] = useState(false);
  const [reviewRole, setReviewRole] = useState("empresa");
  const [missingFieldsAlert, setMissingFieldsAlert] = useState([]);
  const [salarioMinimoVigente, setSalarioMinimoVigente] = useState(1621.0);
  const [unidadesCieemg, setUnidadesCieemg] = useState([]);
  const [horariosTeoricos, setHorariosTeoricos] = useState([]);

  const [horario, setHorario] = useState({
    tipo: "fixo",
    diasSelecionados: ["Segunda", "Terça", "Quarta", "Quinta", "Sexta"],
    fixo: {
      entrada: "",
      saida: "",
      intervaloInicio: "",
      intervaloFim: "",
    },
    alternado: {
      segunda: {
        entrada: "",
        saida: "",
        intervaloInicio: "",
        intervaloFim: "",
      },
      terca: { entrada: "", saida: "", intervaloInicio: "", intervaloFim: "" },
      quarta: { entrada: "", saida: "", intervaloInicio: "", intervaloFim: "" },
      quinta: { entrada: "", saida: "", intervaloInicio: "", intervaloFim: "" },
      sexta: { entrada: "", saida: "", intervaloInicio: "", intervaloFim: "" },
      sabado: { entrada: "", saida: "", intervaloInicio: "", intervaloFim: "" },
      domingo: {
        entrada: "",
        saida: "",
        intervaloInicio: "",
        intervaloFim: "",
      },
    },
  });

  useEffect(() => {
    let entrada = "";
    let saida = "";
    if (horario.tipo === "fixo") {
      entrada = horario.fixo.entrada;
      saida = horario.fixo.saida;
    } else {
      const dias = [
        "segunda",
        "terca",
        "quarta",
        "quinta",
        "sexta",
        "sabado",
        "domingo",
      ];
      for (const d of dias) {
        if (
          horario.alternado[d] &&
          horario.alternado[d].entrada &&
          horario.alternado[d].saida
        ) {
          entrada = horario.alternado[d].entrada;
          saida = horario.alternado[d].saida;
          break;
        }
      }
    }

    setFormData((prev) => {
      let next = { ...prev };
      if (entrada) {
        const [h, m] = entrada.split(":");
        next.horario_inicio_horas = h || "";
        next.horario_inicio_minutos = m || "";
      }

      if (saida) {
        const [h, m] = saida.split(":");
        next.horario_fim_horas = h || "";
        next.horario_fim_minutos = m || "";
      }
      return next;
    });
  }, [horario]);

  function horasDecimais(
    entrada,
    saida,
    intervaloInicio = "",
    intervaloFim = "",
  ) {
    if (!entrada || !saida) return 0;
    const [eh, em] = entrada.split(":").map(Number);
    const [sh, sm] = saida.split(":").map(Number);
    let totalMin = sh * 60 + sm - (eh * 60 + em);
    if (totalMin < 0) totalMin += 24 * 60;
    if (intervaloInicio && intervaloFim) {
      const [ih, im] = intervaloInicio.split(":").map(Number);
      const [fh, fm] = intervaloFim.split(":").map(Number);
      let intervaloMin = fh * 60 + fm - (ih * 60 + im);
      if (intervaloMin < 0) intervaloMin += 24 * 60;
      totalMin -= intervaloMin;
    }
    return totalMin / 60;
  }

  function validarHorarios(horarioObj) {
    const errors = [];
    let totalSemanal = 0;
    if (horarioObj.tipo === "fixo") {
      const f = horarioObj.fixo;
      if (f.entrada && f.saida) {
        const horas = horasDecimais(
          f.entrada,
          f.saida,
          f.intervaloInicio,
          f.intervaloFim,
        );
        if (horas > 6)
          errors.push("Carga horária diária não pode ultrapassar 6h");
        if (horas >= 6 && (!f.intervaloInicio || !f.intervaloFim)) {
          errors.push("Intervalo obrigatório para jornada de 6h");
        }
        totalSemanal = horas * horarioObj.diasSelecionados.length;
      }
    } else if (horarioObj.tipo === "alternado") {
      const diasMap = {
        segunda: "Segunda",
        terca: "Terça",
        quarta: "Quarta",
        quinta: "Quinta",
        sexta: "Sexta",
        sabado: "Sábado",
        domingo: "Domingo",
      };
      Object.keys(horarioObj.alternado).forEach((key) => {
        const h = horarioObj.alternado[key];
        if (h.entrada && h.saida) {
          const horas = horasDecimais(
            h.entrada,
            h.saida,
            h.intervaloInicio,
            h.intervaloFim,
          );
          if (horas > 6)
            errors.push(`${diasMap[key]}: carga horária superior a 6h`);
          totalSemanal += horas;
        }
      });
    }
    if (totalSemanal > 30)
      errors.push(
        `Carga horária semanal (${totalSemanal.toFixed(1)}h) superior ao limite de 30h`,
      );
    return { errors, totalSemanal };
  }
  const [dependentesList, setDependentesList] = useState([1]);
  const [mostrarDeclaracaoDependentes, setMostrarDeclaracaoDependentes] =
    useState(false);
  const [cienteDeclaracaoDependentes, setCienteDeclaracaoDependentes] =
    useState(false);
  const {
    toasts,
    error: toastError,
    success: toastSuccess,
    warning: toastWarning,
    removeToast,
  } = useToast();
  const {
    confirm,
    prompt: promptUser,
    confirmDialog: confirmDialogEmpregador,
  } = useConfirm();

  const ANEXOS_SCHEMA_TCA_EMPREGADOR = [
    {
      id: "doc_comprovante_endereco",
      label: "Comprovante de Endereço",
      icon: "Home",
      required: true,
    },
    {
      id: "doc_declaracao_escolar",
      label: "Declaração escolar / histórico Ensino Médio",
      hint: "Até 30 dias de emissão",
      icon: "GraduationCap",
      required: true,
    },
    {
      id: "doc_identificacao_documento_indetificacao",
      label: "Documento de Identificação",
      icon: "IdCard",
      required: true,
    },
    {
      id: "doc_pis",
      label: "Nº do PIS",
      icon: "CreditCard",
      required: true,
    },
    {
      id: "doc_tipo_sanguineo",
      label: "Comprovante tipo sanguíneo",
      icon: "Droplet",
      required: true,
    },
    {
      id: "doc_certificado_reservista",
      label: "Certificado de Reservista",
      icon: "Shield",
      required: true,
    },
    {
      id: "doc_certidao_casamento",
      label: "Certidão de Casamento",
      icon: "FileText",
      required: true,
    },
    {
      id: "doc_titulo_eleitor",
      label: "Título de Eleitor",
      icon: "Vote",
      required: true,
    },
    {
      id: "doc_curriculum",
      label: "Currículo atualizado",
      icon: "User",
      required: true,
    },
    {
      id: "doc_curso_qualificacao",
      label: "Curso(s) de qualificação",
      icon: "Award",
      required: true,
    },
    {
      id: "doc_foto_3x4",
      label: "Foto 3x4 recente",
      icon: "Camera",
      required: true,
    },
  ];

  const getAnexosObrigatoriosFaltandoEmpregador = () => {
    if (!isEstudante) return [];
    return ANEXOS_SCHEMA_TCA_EMPREGADOR.filter((doc) => {
      if (!doc.required) return false;
      const entry = anexosFiles[doc.id];
      if (!entry) return true;
      const isFilePicked = entry instanceof File || !!entry.file;
      const isPersisted = entry.persisted === true;
      const hasFilename = !!entry.filename;
      return !(isFilePicked || isPersisted) || !hasFilename;
    });
  };

  const [formData, setFormData] = useState({
    nome_filial: "",
    razao_social: "",
    cnpj_ou_cpf: "",
    telefone_empresa: "",
    email_empresa: "",
    nome_representante_legal: "",
    cargo_representante_legal: "",
    telefone_representante_legal: "",
    email_representante_legal: "",
    data_inicio_contrato: "",
    salario: "",
    tutor_aprendiz_empresa: "",
    cargo_tutor: "",
    nome_tutor: "",
    email_tutor: "",
    endereco_aprendizagem_pratica: "",
    endereco_aprendizagem_teorica: "",
    carga_horaria_diaria: "",
    curso: "",
    horario_pratica_inicio: "",
    horario_pratica_fim: "",
    horario_teorica_inicio: "",
    horario_teorica_fim: "",
    nome_completo: "",
    nome_social: "",
    estado_natal: "",
    naturalidade: "",
    nacionalidade: "",
    data_nascimento: "",
    sexo: "",
    nome_aprendiz_menor_idade: "",
    telefone_aprendiz_menor_idade: "",
    email_aprendiz_menor_idade: "",
    cpf_aprendiz_menor_idade: "",
    tipo_sanguineo: "",
    cor: "",
    fumante: false,
    estado_civil: "",
    nome_mae: "",
    email_mae: "",
    telefone_mae: "",
    cpf_mae: "",
    data_nascimento_mae: "",
    naturalidade_mae: "",
    estado_civil_mae: "",
    logradouro: "",
    local_realizacao_atividades: "",
    numero_endereco: "",
    complemento: "",
    bairro: "",
    cep: "",
    regiao: "",
    cidade: "",
    estado_endereco: "",
    pais: "",
    telefone_01: "",
    telefone_02: "",
    email_pessoal: "",
    grau_instrucao: "",
    curso_escolaridade: "",
    instituicao_ensino: "",
    conclusao: "",
    cpf: "",
    pis: "",
    rg: "",
    data_emissao_rg: "",
    orgao_emissor_rg: "",
    estado_rg: "",
    titulo_eleitor: "",
    zona: "",
    secao: "",
    data_emissao_titulo: "",
    estado_titulo: "",
    numero_certificado_reservista: "",
    data_emissao_certificado: "",
    orgao_expedicao: "",
    situacao_militar: "",
    banco_pagamento: "Bradesco 237",
    agencia: "",
    div1: "",
    conta: "",
    div2: "",
    trabalhou_ambiente_insalubre: false,
    risco_exposto: "",
    endereco_residencial_vt: "",
    endereco_vt_logradouro: "",
    endereco_vt_numero: "",
    endereco_vt_complemento: "",
    endereco_vt_bairro: "",
    endereco_vt_cep: "",
    endereco_vt_cidade: "",
    endereco_vt_uf: "",
    enderecoFilial_bairro: "",
    enderecoFilial_municipio: "",
    enderecoFilial_uf: "",
    servicos_meios_transporte: "",
    qtd_dia_pratica: "",
    linha_pratica: "",
    tarifa_pratica: "",
    qtd_dia_teorica: "",
    linha_teorica: "",
    tarifa_teorica: "",
    transportes_pratica_ida: [{ id: 1, linha: "", tarifa: "" }],
    transportes_pratica_volta: [{ id: 1, linha: "", tarifa: "" }],
    transportes_teoria_ida: [{ id: 1, linha: "", tarifa: "" }],
    transportes_teoria_volta: [{ id: 1, linha: "", tarifa: "" }],
    deseja_vale_transporte: false,
    nome_declarante_ir: "",
    cpf_declarante_ir: "",
    estado_civil_ir: "",
    dependente_1_nome: "",
    dependente_1_cpf: "",
    dependente_1_data_nascimento: "",
    dependente_1_idade: "",
    dependente_1_sexo: "",
    dependente_1_grau_parentesco: "",
    dependente_1_naturalidade: "",
    dependente_2_nome: "",
    dependente_2_cpf: "",
    dependente_2_data_nascimento: "",
    dependente_2_idade: "",
    dependente_2_sexo: "",
    dependente_2_grau_parentesco: "",
    dependente_2_naturalidade: "",
    dependente_3_nome: "",
    dependente_3_cpf: "",
    dependente_3_data_nascimento: "",
    dependente_3_idade: "",
    dependente_3_sexo: "",
    dependente_3_grau_parentesco: "",
    dependente_3_naturalidade: "",
    doc_comprovante_endereco: false,
    doc_declaracao_escolar: false,
    doc_identificacao_documento_indetificacao: false,
    doc_pis: false,
    doc_tipo_sanguineo: false,
    doc_certificado_reservista: false,
    doc_certidao_casamento: false,
    doc_titulo_eleitor: false,
    doc_curriculum: false,
    doc_curso_qualificacao: false,
    doc_foto_3x4: false,
    observacoes_ajuste_contrato: "",
    inserir_observacoes: false,
    atividades_aprendiz: "",
    data_fim_contrato: "",
    horario_inicio_horas: "",
    horario_inicio_minutos: "",
    horario_fim_horas: "",
    horario_fim_minutos: "",
    horario_teorico_id: "",
  });

  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [successModalData, setSuccessModalData] = useState({
    isOpen: false,
    tceId: null,
    role: "empresa",
  });
  const [error, setError] = useState("");
  const [filiais, setFiliais] = useState([]);
  const [mostrarFiliais, setMostrarFiliais] = useState(false);
  const [localAtividade, setLocalAtividade] = useState("");
  const [filialLoading, setFilialLoading] = useState(false);
  const [anexosFiles, setAnexosFiles] = useState({});
  const [anexosProgress, setAnexosProgress] = useState({});
  const [anexosStatus, setAnexosStatus] = useState({});
  const [anexosObrigatoriosDestacar, setAnexosObrigatoriosDestacar] =
    useState([]);
  const inputRef = useRef(null);
  const [idadeCalculada, setIdadeCalculada] = useState(null);
  const [estudanteNaoEncontrado, setEstudanteNaoEncontrado] = useState(false);
  const [cienteCadastro, setCienteCadastro] = useState(false);

  const [atividadesFiltradas, setAtividadesFiltradas] = useState([]);
  const [erroHorarioAprendizagem, setErroHorarioAprendizagem] = useState(null);
  const [horarioBloqueado, setHorarioBloqueado] = useState({
    horario_inicio_horas: false,
    horario_inicio_minutos: false,
    horario_fim_horas: false,
    horario_fim_minutos: false,
  });
  const horarioValidoAlertadoRef = useRef(false);

  const findCurso = (cursoVal) => {
    if (!cursoVal) return null;
    return cursosFiltrados.find((c) => {
      const fullDesc = `${c.valorObj.curso} — ${c.valorObj.carga_horaria} (${c.valorObj.modalidade})`;
      return (
        fullDesc === cursoVal ||
        c.valorObj.curso === cursoVal ||
        String(c.id) === String(cursoVal)
      );
    });
  };

  const filtrarHorarioParcial = (campo, valorAtual, valorDigitado) => {
    if (formData.carga_horaria_diaria !== "4 horas diárias") {
      return { valor: valorDigitado, bloqueado: false };
    }
    const soDigitos = String(valorDigitado).replace(/\\D/g, "");
    if (!soDigitos) return { valor: "", bloqueado: false };
    const valoresValidos = {
      horario_inicio_horas: ["07", "13"],
      horario_inicio_minutos: ["30"],
      horario_fim_horas: ["11", "17"],
      horario_fim_minutos: ["30"],
    };
    const permitidos = valoresValidos[campo] || [];
    const valorAtualLimpo = String(valorAtual || "").replace(/\\D/g, "");
    let novoValor = "";
    let tentouInvalido = false;
    for (const digito of soDigitos) {
      const tentativa = novoValor + digito;
      const aindaValido = permitidos.some(
        (v) => v.startsWith(tentativa) || tentativa.startsWith(v),
      );
      if (!aindaValido) {
        tentouInvalido = true;
        continue;
      }
      const algumPermiteExato = permitidos.includes(tentativa);
      const algumPermitePrefixo = permitidos.some((v) =>
        v.startsWith(tentativa),
      );
      if (algumPermiteExato || algumPermitePrefixo) {
        novoValor = tentativa;
      } else {
        tentouInvalido = true;
      }
    }
    novoValor = novoValor.slice(0, 2);
    if (
      novoValor.length === 2 &&
      !permitidos.includes(novoValor) &&
      !permitidos.some((v) => v.startsWith(novoValor))
    ) {
      novoValor = valorAtualLimpo.slice(0, 2);
      tentouInvalido = true;
    }
    return { valor: novoValor, bloqueado: tentouInvalido };
  };

  const HORARIOS_DIARIOS = { "4 horas diárias": 4, "6 horas diárias": 6 };
  const HORARIOS_PADRAO_PRATICA = {
    manha4h: { inicio: "07:30", fim: "11:30" },
    tarde4h: { inicio: "13:30", fim: "17:30" },
  };
  const formatarHorario = (horas, minutos) =>
    `${String(horas).padStart(2, "0")}:${String(minutos).padStart(2, "0")}`;

  const validarHorarioAprendizagem = () => {
    const camposVazios =
      !formData.horario_inicio_horas ||
      !formData.horario_inicio_minutos ||
      !formData.horario_fim_horas ||
      !formData.horario_fim_minutos;
    if (camposVazios) return null;
    const horaIni = Number(formData.horario_inicio_horas);
    const minIni = Number(formData.horario_inicio_minutos);
    const horaFim = Number(formData.horario_fim_horas);
    const minFim = Number(formData.horario_fim_minutos);
    if (
      Number.isNaN(horaIni) ||
      Number.isNaN(minIni) ||
      Number.isNaN(horaFim) ||
      Number.isNaN(minFim)
    )
      return "Preencha horário de início e fim válidos para a aprendizagem prática.";
    if (horaIni > 23 || minIni > 59 || horaFim > 23 || minFim > 59)
      return "Horário inválido. Use valores entre 00:00 e 23:59.";
    const inicioMinutos = horaIni * 60 + minIni;
    const fimMinutos = horaFim * 60 + minFim;
    if (fimMinutos <= inicioMinutos)
      return "O horário final da aprendizagem prática deve ser maior que o horário inicial.";
    const duracaoMinutos = fimMinutos - inicioMinutos;
    const duracaoHoras = duracaoMinutos / 60;
    const inicioFormatado = formatarHorario(horaIni, minIni);
    const fimFormatado = formatarHorario(horaFim, minFim);
    if (formData.carga_horaria_diaria === "4 horas diárias") {
      const ehValido = Object.values(HORARIOS_PADRAO_PRATICA).some(
        (h) => h.inicio === inicioFormatado && h.fim === fimFormatado,
      );
      if (!ehValido)
        return "Informe o horário exato referente ao curso: 07:30 às 11:30 ou 13:30 às 17:30.";
      return null;
    }
    const horasDiariasPermitidas =
      HORARIOS_DIARIOS[formData.carga_horaria_diaria] || 6;
    if (duracaoHoras !== horasDiariasPermitidas) {
      const horasFormatadas = duracaoHoras
        .toFixed(2)
        .replace(".", ",")
        .replace(/,(\d)0$/, ",$1")
        .replace(/,00$/, "");
      return `A duração da aprendizagem prática (${horasFormatadas}h) deve ser exatamente igual a ${horasDiariasPermitidas}h por dia.`;
    }
    return null;
  };

  const buscarDadosDoAprendiz = async (cpfDigitado) => {
    if (!cpfDigitado) return;
    const cpfLimpo = String(cpfDigitado).replace(/\D/g, "");

    if (cpfLimpo.length !== 11) return;

    try {
      setEstudanteNaoEncontrado(false);
      setCienteCadastro(false);
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_BASE_URL}/estudantes/cpf/${cpfLimpo}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const dadosDoEstudante = response.data;
      console.log(
        "=== DADOS DO ESTUDANTE RETORNADOS PELA API ===",
        dadosDoEstudante,
      );

      if (dadosDoEstudante) {
        const blocoDadosAprendiz = {
          nome_completo: dadosDoEstudante.nome_completo || "",
          nome_social: dadosDoEstudante.nome_social || "",
          estado_natal: dadosDoEstudante.uf_naturalidade || "",
          naturalidade: dadosDoEstudante.naturalidade || "",
          nacionalidade: dadosDoEstudante.nacionalidade || "",
          data_nascimento:
            dadosDoEstudante.dt_nascimento ||
            dadosDoEstudante.data_nascimento ||
            "",
          sexo: dadosDoEstudante.sexo || "",
          estado_civil: dadosDoEstudante.estadocivil || "",
          telefone_01: dadosDoEstudante.telefone || "",
          email_pessoal: dadosDoEstudante.email || "",
        };

        const blocoResponsabilidadeAprendiz = {
          nome_mae: dadosDoEstudante.nomemae || "",
          cpf_mae: dadosDoEstudante.cpf_mae || "",
          logradouro: dadosDoEstudante.logradouro || "",
          numero_endereco: dadosDoEstudante.numero || "",
          complemento: dadosDoEstudante.complemento || "",
          bairro: dadosDoEstudante.bairro || "",
          cep: dadosDoEstudante.cep || "",
          cidade: dadosDoEstudante.cidade || "",
          estado_endereco: dadosDoEstudante.uf || "",
          endereco_vt_logradouro: dadosDoEstudante.logradouro || "",
          endereco_vt_numero: dadosDoEstudante.numero || "",
          endereco_vt_complemento: dadosDoEstudante.complemento || "",
          endereco_vt_bairro: dadosDoEstudante.bairro || "",
          endereco_vt_cep: dadosDoEstudante.cep || "",
          endereco_vt_cidade: dadosDoEstudante.cidade || "",
          endereco_vt_uf: dadosDoEstudante.uf || "",
          telefone_02: dadosDoEstudante.telefone2 || "",
          curso_escolaridade:
            dadosDoEstudante.curso_id || dadosDoEstudante.curso_nome || "",
          instituicao_ensino:
            dadosDoEstudante.escola_id || dadosDoEstudante.escola_nome || "",
          conclusao:
            dadosDoEstudante.previsaoformatura ||
            dadosDoEstudante.previsao_formatura ||
            "",
          rg: dadosDoEstudante.rg || "",
          orgao_emissor_rg: dadosDoEstudante.orgaoexpedidor || "",
        };

        setFormData((prev) => ({
          ...prev,
          ...blocoDadosAprendiz,
          ...blocoResponsabilidadeAprendiz,
          nome_aprendiz_menor_idade:
            dadosDoEstudante.nomemae ||
            dadosDoEstudante.mae ||
            prev.nome_aprendiz_menor_idade ||
            "",
        }));
      }
    } catch (error) {
      console.log("Estudante não encontrado ou erro na busca", error);
      const backendError =
        error.response?.data?.errors?.[0] ||
        error.response?.data?.message ||
        "Erro desconhecido ao buscar o estudante.";
      toastError(`Falha ao buscar aprendiz: ${backendError}`);
      setEstudanteNaoEncontrado(true);
      setCienteCadastro(false);
      setFormData((prev) => ({
        ...prev,
        nome_completo: "",
        telefone_01: "",
        email_pessoal: "",
        data_nascimento: "",
      }));
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const authHeader = { Authorization: `Bearer ${token}` };

    const ensureCursos = async () => {
      if (cursosFiltrados.length > 0) return cursosFiltrados;
      const r = await axios.get(`${API_BASE_URL}/tca-configuracoes/cursos`, {
        headers: authHeader,
      });
      const cursos = r.data || [];
      setCursosFiltrados(cursos);
      return cursos;
    };

    (async () => {
      try {
        const cursos = await ensureCursos();

        if (!formData.curso) {
          setAtividadesFiltradas([]);
          setFormData((prev) => {
            if (prev.atividades_aprendiz !== "")
              return { ...prev, atividades_aprendiz: "" };
            return prev;
          });
          return;
        }

        const resolveCursoId = (cursosList) => {
          const achou = cursosList.find((c) => {
            const fullDesc = `${c.valorObj.curso} — ${c.valorObj.carga_horaria} (${c.valorObj.modalidade})`;
            return (
              fullDesc === formData.curso ||
              c.valorObj.curso === formData.curso ||
              String(c.id) === String(formData.curso)
            );
          });
          return achou?.id;
        };

        const cursoId = resolveCursoId(cursos);
        if (!cursoId) {
          setAtividadesFiltradas([]);
          return;
        }
        let atividades = [];
        try {
          const r = await axios.get(
            `${API_BASE_URL}/tca-configuracoes/atividades?curso_id=${encodeURIComponent(cursoId)}`,
            { headers: authHeader },
          );
          atividades = r.data || [];
        } catch (err) {
          if (err?.response?.status !== 404) throw err;
          try {
            const r2 = await axios.get(
              `${API_BASE_URL}/tca-configuracoes/atividades`,
              { headers: authHeader },
            );
            const todas = r2.data || [];
            atividades = todas.filter(
              (a) => String(a.curso_id) === String(cursoId),
            );
          } catch (err2) {
            if (err2?.response?.status !== 404) throw err2;
            atividades = [];
          }
        }
        setAtividadesFiltradas(atividades);
      } catch (err) {
        console.warn("Erro ao carregar atividades:", err?.message);
        setAtividadesFiltradas([]);
      }
    })();
  }, [formData.curso, cursosFiltrados.length]);

  useEffect(() => {
    const erro =
      typeof validarHorarioAprendizagem === "function"
        ? validarHorarioAprendizagem()
        : null;
    setErroHorarioAprendizagem(erro);
    if (erro === null) {
      if (
        formData.curso &&
        formData.carga_horaria_diaria &&
        formData.horario_inicio_horas &&
        formData.horario_inicio_minutos &&
        formData.horario_fim_horas &&
        formData.horario_fim_minutos &&
        !horarioValidoAlertadoRef.current
      ) {
        toastSuccess(
          "Horário da aprendizagem prática preenchido corretamente!",
        );
        horarioValidoAlertadoRef.current = true;
      }
    } else {
      horarioValidoAlertadoRef.current = false;
    }
  }, [
    formData.curso,
    formData.carga_horaria_diaria,
    formData.horario_inicio_horas,
    formData.horario_inicio_minutos,
    formData.horario_fim_horas,
    formData.horario_fim_minutos,
    cursosFiltrados,
  ]);

  useEffect(() => {
    if (formData.curso && cursosFiltrados.length > 0) {
      const cursoObj = findCurso(formData.curso);
      if (cursoObj && cursoObj.valorObj.carga_horaria) {
        const ch = String(cursoObj.valorObj.carga_horaria).replace(/\D/g, "");
        let targetHours = "";
        if (ch === "4" || ch === "1936" || ch === "1900") {
          targetHours = "4 horas diárias";
        } else if (ch === "6" || ch === "2230" || ch === "2000") {
          targetHours = "6 horas diárias";
        } else {
          const numHours = parseInt(ch, 10);
          if (!isNaN(numHours)) {
            targetHours =
              numHours <= 1936 ? "4 horas diárias" : "6 horas diárias";
          }
        }
        if (targetHours && formData.carga_horaria_diaria !== targetHours) {
          setFormData((prev) => ({
            ...prev,
            carga_horaria_diaria: targetHours,
          }));
        }
      }
    }
  }, [formData.curso, cursosFiltrados]);

  useEffect(() => {
    if (tcaCarregadoEmRef.current) {
      const elapsed = Date.now() - tcaCarregadoEmRef.current;
      if (elapsed < 3000) return;
      tcaCarregadoEmRef.current = 0;
    }

    const timer = setTimeout(() => {
      const cpfValue = formData.cpf || "";
      const cpfLimpo = String(cpfValue).replace(/\D/g, "");

      if (cpfLimpo.length < 11) {
        setEstudanteNaoEncontrado(false);
        if (cpfLimpo.length === 0) {
          setFormData((prev) => {
            if (
              prev.nome_completo ||
              prev.telefone_01 ||
              prev.email_pessoal ||
              prev.data_nascimento
            ) {
              return {
                ...prev,
                nome_completo: "",
                telefone_01: "",
                email_pessoal: "",
                data_nascimento: "",
              };
            }
            return prev;
          });
        }
        return;
      }

      buscarDadosDoAprendiz(cpfValue);
    }, 1000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.cpf, user?.acesso_autorizacao]);

  const handleAnexoChange = (key) => (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const allowed = ["application/pdf", "image/png", "image/jpeg"];
    if (!allowed.includes(file.type)) {
      toastWarning("Formato inválido. Use PDF, PNG ou JPG.");
      e.target.value = "";
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      toastWarning("Arquivo maior que 10MB.");
      e.target.value = "";
      return;
    }

    setAnexosFiles((prev) => ({ ...prev, [key]: file }));
    setAnexosStatus((prev) => ({ ...prev, [key]: "uploading" }));
    setAnexosProgress((prev) => ({ ...prev, [key]: 0 }));

    try {
      const token = localStorage.getItem("token");
      const fd = new FormData();
      fd.append("file", file);

      axios
        .post(`${API_BASE_URL}/upload`, fd, {
          headers: { Authorization: `Bearer ${token}` },
          onUploadProgress: (ev) => {
            if (ev.total) {
              const real = Math.round((ev.loaded * 100) / ev.total);
              setAnexosProgress((prev) => ({ ...prev, [key]: real }));
              if (real >= 100) {
                setAnexosStatus((prev) => ({ ...prev, [key]: "done" }));
              }
            }
          },
        })
        .then((res) => {
          const foto = res?.data?.foto || res?.data || {};
          setAnexosFiles((prev) => {
            const prevFile = prev[key];
            const base =
              prevFile instanceof File ? { file: prevFile } : prevFile || {};
            return {
              ...prev,
              [key]: {
                ...base,
                filename: foto.filename,
                originalname: foto.originalname,
                tipo_documento: foto.tipo_documento,
              },
            };
          });
        })
        .catch((err) => {
          console.error("Erro upload:", err);
          setAnexosStatus((prev) => ({ ...prev, [key]: "error" }));
          toastError("Erro ao enviar arquivo. Tente novamente.");
        });
    } catch (err) {
      console.error("Erro inesperado no upload:", err);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token || !user) {
      window.location.href = "/";
      return;
    }
    const nivel = Number(user.acesso_autorizacao ?? 0);
    const niveisPermitidos = [0, 1, 2, 3, 4];
    if (!niveisPermitidos.includes(nivel)) {
      window.location.href = "/sem-permissao";
      return;
    }
    setPermissao(calcularPermissao());
    setAutorizado(true);
  }, [user, calcularPermissao]);

  const isEmpresaReadOnly = [0].includes(Number(user?.acesso_autorizacao));
  const isCampoBloqueadoParaEmpresa = (name) => {
    if (!name) return false;
    if (Number(user?.acesso_autorizacao) !== 0) return false;
    return CAMPOS_APRENDIZ_BLOQUEADOS_EMPRESA.has(name);
  };

  const isEstudante = Number(user?.acesso_autorizacao) === 1;

  const horariosReadOnly = isEstudante;
  const horariosDisabled = isEstudante || !permissao?.podeEditarEmpresa;

  useEffect(() => {
    let mounted = true;

    async function load() {
      try {
        const token = localStorage.getItem("token");
        const user = JSON.parse(localStorage.getItem("user"));
        const empresaId = user?.empresa_id;

        const params = new URLSearchParams(window.location.search);
        const editingId = params.get("id");
        if (editingId) {
          if (mounted) setLoading(false);
          return;
        }

        if (empresaId) {
          const respEmp = await axios.get(`${API_BASE_URL}/tca/dados-empresa`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const enderecoTeorico =
            respEmp.data.endereco_aprendizagem_teorica ||
            respEmp.data.endereco_atividade_teorica ||
            respEmp.data.unidadeTeorica?.endereco ||
            "";
          matrizEnderecoTeoricoRef.current = enderecoTeorico;
          if (respEmp.data.regiao) {
            setFormData((prev) =>
              prev.regiao
                ? prev
                : {
                    ...prev,
                    regiao: respEmp.data.regiao,
                  },
            );
          }
          console.log(
            "[TcaEmpregador] load(): enderecoTeorico (fallback) = ",
            enderecoTeorico,
            "regiao =",
            respEmp.data.regiao,
          );

          setFormData((prev) => ({
            ...prev,
            empresa_id: empresaId,
            razao_social: prev.razao_social || respEmp.data.razao_social || "",
            cnpj_ou_cpf: prev.cnpj_ou_cpf || respEmp.data.cnpj_ou_cpf || "",
            telefone_empresa:
              prev.telefone_empresa ||
              respEmp.data.telefone_empresa_primario ||
              "",
            email_empresa:
              prev.email_empresa ||
              respEmp.data.email ||
              respEmp.data.email_empresa ||
              "",
            endereco_aprendizagem_teorica:
              prev.endereco_aprendizagem_teorica || enderecoTeorico,
          }));

          const respAut = await axios.get(
            `${API_BASE_URL}/tca/empresa/${empresaId}/autorizacao`,
            { headers: { Authorization: `Bearer ${token}` } },
          );
          setAutorizacaoTca(respAut.data);

          const respFiliais = await axios.get(`${API_BASE_URL}/tca/filiais`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (respFiliais.data.possuiFiliais) {
            setFiliais(respFiliais.data.opcoes);
            setMostrarFiliais(true);
          }
        }
      } catch (err) {
        if (mounted) setError("Erro ao carregar dados.");
      } finally {
        if (mounted) setLoading(false);
      }
    }
    load();
  }, []);

  const podeAprovar = permissao?.podeAprovar === true;

  useEffect(() => {

    if (loading) return;

    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    if (id) {
      setModoEdicao(true);
      setTcaId(id);
      if (carregarTcaExistenteRef.current) {
        carregarTcaExistenteRef.current(id);
      }
      return;
    }

    const acesso = Number(user?.acesso_autorizacao ?? -1);
    if (acesso !== 1) {
      return;
    }

    let aborted = false;
    (async () => {
      const token = localStorage.getItem("token");
      if (!token) return;
      try {
        const resp = await axios.get(`${API_BASE_URL}/tca-empregador`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (aborted) return;
        const lista = Array.isArray(resp.data)
          ? resp.data
          : Array.isArray(resp.data?.items)
            ? resp.data.items
            : Array.isArray(resp.data?.results)
              ? resp.data.results
              : Array.isArray(resp.data?.data)
                ? resp.data.data
                : [];
        if (lista.length === 0) return;

        const STATUS_FINALIZADOS = new Set([
          "FINALIZADO",
          "CONTRATO_FINALIZADO",
          "CONCLUIDO",
          "CONCLUÍDO",
          "CANCELADO",
          "REPROVADO",
        ]);
        const candidato =
          lista.find((item) => {
            const s = String(item?.status || "").toUpperCase();
            return s && !STATUS_FINALIZADOS.has(s);
          }) || lista[0];

        const tcaIdAuto =
          candidato?.id ??
          candidato?.tca_id ??
          candidato?.tcaEmpregadorId ??
          null;
        if (!tcaIdAuto) return;

        setModoEdicao(true);
        setTcaId(tcaIdAuto);
        if (carregarTcaExistenteRef.current) {
          carregarTcaExistenteRef.current(tcaIdAuto);
        }
      } catch (err) {

        console.warn(
          "[TcaEmpregador] Falha ao descobrir TCA existente:",
          err?.response?.status || err?.message,
        );
      }
    })();

    return () => {
      aborted = true;
    };
  }, [loading]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      axios
        .get(`${API_BASE_URL}/admin-unidades`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((r) => setUnidadesCieemg(r.data || []))
        .catch(console.error);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    axios
      .get(`${API_BASE_URL}/tca-configuracoes/horarios-teoricos`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((r) => setHorariosTeoricos(r.data || []))
      .catch((err) => {
        const status = err?.response?.status;
        if (status === 404 || status === 405) return;
        console.warn(
          "[TcaEmpregador] Falha ao carregar horários teóricos:",
          status || "sem status",
          err?.response?.data || err?.message,
        );
      });
  }, []);

  useEffect(() => {
    if (!formData.data_nascimento) {
      setIdadeCalculada(null);
      return;
    }

    const hoje = new Date();
    const nasc = new Date(formData.data_nascimento);
    let idade = hoje.getFullYear() - nasc.getFullYear();
    const m = hoje.getMonth() - nasc.getMonth();
    if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) {
      idade--;
    }
    setIdadeCalculada(idade);

    if (idade >= 18) {
      setFormData((prev) => {
        const temAlgoMenor =
          prev.nome_aprendiz_menor_idade ||
          prev.telefone_aprendiz_menor_idade ||
          prev.email_aprendiz_menor_idade ||
          prev.cpf_aprendiz_menor_idade ||
          prev.rg_aprendiz_menor_idade ||
          prev.orgao_emissor_aprendiz_menor_idade ||
          prev.profissao_aprendiz_menor_idade;
        if (!temAlgoMenor) return prev;
        return {
          ...prev,
          nome_aprendiz_menor_idade: "",
          telefone_aprendiz_menor_idade: "",
          email_aprendiz_menor_idade: "",
          cpf_aprendiz_menor_idade: "",
          rg_aprendiz_menor_idade: "",
          orgao_emissor_aprendiz_menor_idade: "",
          profissao_aprendiz_menor_idade: "",
        };
      });
    }
  }, [formData.data_nascimento]);

  useEffect(() => {
    if (modoEdicao) return;

    const local = formData.local_realizacao_atividades || "";

    if (local === "") {
      setFormData((prev) => ({
        ...prev,
        endereco_aprendizagem_teorica: "",
      }));
      setTcaFormValue("endereco_aprendizagem_teorica", "", {
        shouldDirty: false,
        shouldTouch: false,
      });
      return;
    }

    if (local === "MATRIZ") {
      let enderecoMatriz = "";
      console.log(
        "[MÁGICA MATRIZ] Disparado! regiao=",
        formData.regiao,
        "unidades.length=",
        unidadesCieemg.length,
      );

      console.log(
        "[MÁGICA MATRIZ] Disparado! regiao=",
        formData.regiao,
        "unidades.length=",
        unidadesCieemg.length,
      );

      if (formData.regiao && unidadesCieemg.length > 0) {
        const unidadeEncontrada = unidadesCieemg.find(
          (u) => String(u.codigo) === String(formData.regiao),
        );
        if (unidadeEncontrada) {
          enderecoMatriz = unidadeEncontrada.endereco;
          console.log("[MÁGICA MATRIZ] Encontrado via regiao:", enderecoMatriz);
        }
      }

      if (!enderecoMatriz && matrizEnderecoTeoricoRef.current) {
        enderecoMatriz = matrizEnderecoTeoricoRef.current;
        console.log(
          "[MÁGICA MATRIZ] Usando fallback (matrizEnderecoTeoricoRef):",
          enderecoMatriz,
        );
      }

      if (enderecoMatriz) {
        console.log("[MÁGICA MATRIZ] Setando form data com:", enderecoMatriz);
        setFormData((prev) => ({
          ...prev,
          endereco_aprendizagem_teorica: enderecoMatriz,
        }));
        setTcaFormValue("endereco_aprendizagem_teorica", enderecoMatriz, {
          shouldDirty: false,
          shouldTouch: false,
        });
      } else {
        console.log(
          "[MÁGICA MATRIZ] Nenhum endereço teórico encontrado (fallback vazio).",
        );
      }
    }
  }, [formData.regiao, unidadesCieemg, formData.local_realizacao_atividades]);

  useEffect(() => {
    const filialId = String(localAtividade || "").trim();
    console.log(
      "[Filial] useEffect disparado. localAtividade =",
      JSON.stringify(localAtividade),
      "filialId =",
      filialId,
    );
    if (!filialId || filialId === "MATRIZ" || isNaN(Number(filialId))) {
      console.log("[Filial] ignorado (vazio / MATRIZ / não-numérico)");
      const camposFilial = [
        "cpfCnpj",
        "cepFilial",
        "enderecoFilial",
        "telefones",
        "telefones2",
        "emailContratos",
        "emailFinanceiro",
        "representadaPor",
        "cargoRepresentante",
        "emailRepresentante",
        "responsavelSupervisor",
        "cargoSupervisor",
        "emailSupervisor",
      ];
      let enderecoMatriz = matrizEnderecoTeoricoRef.current || "";
      if (!enderecoMatriz && formData.regiao && unidadesCieemg.length > 0) {
        const unidadeEncontrada = unidadesCieemg.find(
          (u) =>
            Number(u.codigo) === Number(formData.regiao) ||
            String(u.codigo) === String(formData.regiao) ||
            String(u.id) === String(formData.regiao) ||
            String(u.codigo_unidade) === String(formData.regiao),
        );
        if (unidadeEncontrada) {
          enderecoMatriz = unidadeEncontrada.endereco;
        }
      }
      console.log("[TcaEmpregador] Magica da Matriz:", {
        regiao: formData.regiao,
        enderecoMatriz,
      });

      setFormData((prev) => {
        const next = { ...prev };
        camposFilial.forEach((c) => {
          next[c] = "";
        });
        if (matrizEnderecoTeoricoRef.current) {
          next.endereco_aprendizagem_teorica = matrizEnderecoTeoricoRef.current;
        }
        return next;
      });
      camposFilial.forEach((c) =>
        setTcaFormValue(c, "", { shouldDirty: false, shouldTouch: false }),
      );
      if (matrizEnderecoTeoricoRef.current) {
        setTcaFormValue(
          "endereco_aprendizagem_teorica",
          matrizEnderecoTeoricoRef.current,
          { shouldDirty: false, shouldTouch: false },
        );
      }
      return;
    }

    let cancelled = false;

    const carregarFilial = async () => {
      setFilialLoading(true);
      try {
        const token = localStorage.getItem("token");
        const url = API_ENDPOINTS.filial_id(filialId);
        console.log("[Filial] GET", url);
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        console.log("[Filial] resposta:", response.status, response.data);

        if (cancelled) return;

        const dados = response.data || {};

        const enderecoCompletoFilial = [
          dados.endereco,
          dados.bairro,
          dados.cidade,
          dados.uf,
          dados.cep ? `CEP: ${dados.cep}` : "",
        ]
          .filter(Boolean)
          .join(", ");

        const mapeamento = [
          ["nome_filial", dados.nome_filial],
          ["cpfCnpj", dados.cnpj],
          ["cepFilial", dados.cep],
          ["enderecoFilial", dados.endereco],
          ["telefones", dados.telefone_1],
          ["telefones2", dados.telefone_2],
          [
            "endereco_aprendizagem_teorica",
            dados.unidadeTeorica ? dados.unidadeTeorica.endereco : "",
          ],
          ["enderecoFilial_bairro", dados.bairro],
          ["enderecoFilial_municipio", dados.cidade],
          ["enderecoFilial_uf", dados.uf],
          ["emailContratos", dados.email_contratos],
          ["emailFinanceiro", dados.email_financeiro],
          ["representadaPor", dados.representante_nome],
          ["cargoRepresentante", dados.representante_cargo],
          ["emailRepresentante", dados.representante_email],
          ["responsavelSupervisor", dados.supervisor_nome],
          ["cargoSupervisor", dados.supervisor_cargo],
          ["emailSupervisor", dados.supervisor_email],
        ];

        setFormData((prev) => {
          const next = { ...prev };
          mapeamento.forEach(([campo, valor]) => {
            if (valor !== undefined && valor !== null) {
              next[campo] = valor;
            }
          });
          return next;
        });

        mapeamento.forEach(([campo, valor]) => {
          if (valor !== undefined && valor !== null) {
            setTcaFormValue(campo, valor, {
              shouldDirty: false,
              shouldTouch: false,
            });
          }
        });

        toastSuccess("Dados da filial carregados.");
      } catch (err) {
        if (cancelled) return;
        const status = err.response?.status;
        const backendMsg =
          (Array.isArray(err.response?.data?.errors) &&
            err.response.data.errors.join(", ")) ||
          err.response?.data?.message ||
          err.response?.data?.error ||
          err.message ||
          null;
        console.error(
          `[Filial] erro ao carregar filial id=${filialId} status=${status}:`,
          err.response?.data,
        );

        const fFallback = filiais.find(
          (f) => String(f.id) === String(filialId),
        );
        if (
          fFallback &&
          (status === 404 || status >= 500 || status === 401 || status === 403)
        ) {
          console.log(
            "[Filial] Usando fallback local para preencher filial:",
            fFallback,
          );
          const fallbackMapeamento = [
            [
              "nome_filial",
              fFallback.nome_filial ||
                fFallback.razao_social ||
                fFallback.nome ||
                "",
            ],
            [
              "cpfCnpj",
              fFallback.cnpj ||
                fFallback.cnpj_ou_cpf ||
                fFallback.cpfCnpj ||
                "",
            ],
            ["cepFilial", fFallback.cep || ""],
            ["enderecoFilial", fFallback.endereco || ""],
            // ⚠️ Usar nomes únicos (enderecoFilial_*) para não colidir
            // com os campos do aprendiz.
            ["enderecoFilial_bairro", fFallback.bairro || ""],
            [
              "enderecoFilial_municipio",
              fFallback.cidade || fFallback.municipio || "",
            ],
            ["enderecoFilial_uf", fFallback.uf || ""],
            [
              "telefones",
              fFallback.telefone_1 ||
                fFallback.telefone ||
                fFallback.telefones ||
                "",
            ],
            [
              "emailContratos",
              fFallback.email_contratos ||
                fFallback.email ||
                fFallback.emailContratos ||
                "",
            ],
          ];
          setFormData((prev) => {
            const next = { ...prev };
            fallbackMapeamento.forEach(([campo, valor]) => {
              if (valor !== undefined && valor !== null) next[campo] = valor;
            });
            return next;
          });
          fallbackMapeamento.forEach(([campo, valor]) => {
            if (valor !== undefined && valor !== null) {
              setTcaFormValue(campo, valor, {
                shouldDirty: false,
                shouldTouch: false,
              });
            }
          });
          toastWarning(
            "Os dados completos da filial não puderam ser carregados. Algumas informações básicas foram preenchidas.",
          );
          return;
        }

        if (status === 404) {
          toastError(
            backendMsg
              ? `Filial não encontrada: ${backendMsg}`
              : "Filial não encontrada",
          );
        } else if (status >= 500) {
          toastError(
            backendMsg
              ? `Erro no servidor ao buscar filial: ${backendMsg}`
              : "Erro no servidor ao buscar filial",
          );
        } else if (status === 401 || status === 403) {
          toastError("Sessão expirada ou sem permissão. Faça login novamente.");
        } else {
          toastError(
            backendMsg
              ? `Erro ao carregar filial: ${backendMsg}`
              : "Erro ao carregar dados da filial",
          );
        }
      } finally {
        if (!cancelled) setFilialLoading(false);
      }
    };

    carregarFilial();
    return () => {
      cancelled = true;
    };
  }, [
    localAtividade,
    setTcaFormValue,
    toastError,
    toastSuccess,
    formData.regiao,
    unidadesCieemg,
  ]);

  const handleCepFilialBlur = async (e) => {
    const cepVal = String(e.target.value || "").replace(/\D/g, "");
    if (cepVal.length === 8) {
      try {
        const response = await axios.get(
          `https://viacep.com.br/ws/${cepVal}/json/`,
        );
        if (!response.data.erro) {
          setFormData((prev) => ({
            ...prev,
            enderecoFilial: response.data.logradouro || "",
            enderecoFilial_bairro: response.data.bairro || "",
            enderecoFilial_municipio: response.data.localidade || "",
            enderecoFilial_uf: response.data.uf || "",
          }));
          setTcaFormValue("enderecoFilial", response.data.logradouro || "");
          setTcaFormValue("bairro", response.data.bairro || "");
          setTcaFormValue("municipio", response.data.localidade || "");
          setTcaFormValue("uf", response.data.uf || "");
          toastSuccess("Endereço preenchido automaticamente.");
        } else {
          toastWarning("CEP não encontrado no ViaCEP.");
        }
      } catch (err) {
        toastError("Erro ao buscar CEP no ViaCEP.");
      }
    }
  };

  const handleCepAprendizBlur = async (e) => {
    const cepVal = String(e.target.value || "").replace(/\D/g, "");
    if (cepVal.length === 8) {
      try {
        const response = await axios.get(
          `https://viacep.com.br/ws/${cepVal}/json/`,
        );
        if (!response.data.erro) {
          setFormData((prev) => ({
            ...prev,
            logradouro: response.data.logradouro
              ? response.data.logradouro.toUpperCase()
              : "",
            bairro: response.data.bairro
              ? response.data.bairro.toUpperCase()
              : "",
            cidade: response.data.localidade
              ? response.data.localidade.toUpperCase()
              : "",
            estado_endereco: response.data.uf
              ? response.data.uf.toUpperCase()
              : "",
          }));
          setTcaFormValue(
            "logradouro",
            response.data.logradouro
              ? response.data.logradouro.toUpperCase()
              : "",
          );
          setTcaFormValue(
            "bairro",
            response.data.bairro ? response.data.bairro.toUpperCase() : "",
          );
          setTcaFormValue(
            "cidade",
            response.data.localidade
              ? response.data.localidade.toUpperCase()
              : "",
          );
          setTcaFormValue(
            "estado_endereco",
            response.data.uf ? response.data.uf.toUpperCase() : "",
          );
          toastSuccess("Endereço Principal preenchido automaticamente.");
        } else {
          toastWarning("CEP do Aprendiz não encontrado no ViaCEP.");
        }
      } catch (err) {
        toastError("Erro ao buscar CEP do Aprendiz.");
      }
    }
  };

  const handleCepVTBlur = async (e) => {
    const cepVal = String(e.target.value || "").replace(/\D/g, "");
    if (cepVal.length === 8) {
      try {
        const response = await axios.get(
          `https://viacep.com.br/ws/${cepVal}/json/`,
        );
        if (!response.data.erro) {
          setFormData((prev) => ({
            ...prev,
            endereco_vt_logradouro: response.data.logradouro
              ? response.data.logradouro.toUpperCase()
              : "",
            endereco_vt_bairro: response.data.bairro
              ? response.data.bairro.toUpperCase()
              : "",
            endereco_vt_cidade: response.data.localidade
              ? response.data.localidade.toUpperCase()
              : "",
            endereco_vt_uf: response.data.uf
              ? response.data.uf.toUpperCase()
              : "",
            estado_endereco: response.data.uf
              ? response.data.uf.toUpperCase()
              : "",
          }));
          setTcaFormValue(
            "endereco_vt_logradouro",
            response.data.logradouro
              ? response.data.logradouro.toUpperCase()
              : "",
          );
          setTcaFormValue(
            "endereco_vt_bairro",
            response.data.bairro ? response.data.bairro.toUpperCase() : "",
          );
          setTcaFormValue(
            "endereco_vt_cidade",
            response.data.localidade
              ? response.data.localidade.toUpperCase()
              : "",
          );
          setTcaFormValue(
            "endereco_vt_uf",
            response.data.uf ? response.data.uf.toUpperCase() : "",
          );
          setTcaFormValue(
            "estado_endereco",
            response.data.uf ? response.data.uf.toUpperCase() : "",
          );
          toastSuccess("Endereço Residencial preenchido automaticamente.");
        } else {
          toastWarning("CEP Residencial não encontrado no ViaCEP.");
        }
      } catch (err) {
        toastError("Erro ao buscar CEP Residencial.");
      }
    }
  };

  useEffect(() => {
    const carregarOpcoes = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${API_BASE_URL}/tca-configuracoes/datas-vigencia`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        const ordenadas = (response.data || []).slice().sort((a, b) => {
          const da = a?.valorObj?.data || "";
          const db = b?.valorObj?.data || "";
          return da.localeCompare(db);
        });
        setDatasVigenciaFuturas(ordenadas);
      } catch (err) {
        console.error("Erro ao carregar datas de vigência:", err);
      }
    };
    const buscarSalarioMinimo = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${API_BASE_URL}/tca-configuracoes/salario-minimo`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        if (
          response.data &&
          response.data.vigente &&
          response.data.vigente.valor
        ) {
          setSalarioMinimoVigente(Number(response.data.vigente.valor));
        } else if (Array.isArray(response.data) && response.data.length > 0) {
          setSalarioMinimoVigente(
            Number(response.data[response.data.length - 1].valor),
          );
        } else if (response.data && response.data.valor) {
          setSalarioMinimoVigente(Number(response.data.valor));
        }
      } catch (err) {
        console.warn("Erro ao buscar salário mínimo:", err);
      }
    };
    carregarOpcoes();
    buscarSalarioMinimo();
  }, []);

  const prevSalarioCalculadoRef = useRef(null);

  // Calcula o salário proporcional automaticamente com base na carga horária diária
  useEffect(() => {
    let horasDiarias = 0;
    const chd = String(formData.carga_horaria_diaria || "").replace(/\D/g, "");
    if (chd === "4" || formData.carga_horaria_diaria === "4 horas diárias") {
      horasDiarias = 4;
    } else if (
      chd === "6" ||
      formData.carga_horaria_diaria === "6 horas diárias"
    ) {
      horasDiarias = 6;
    }

    if (horasDiarias === 4 || horasDiarias === 6) {
      const valorHora = Math.round((salarioMinimoVigente / 220) * 100) / 100;
      const horasSemanais = horasDiarias * 5;
      const valorSemanal = valorHora * horasSemanais;
      const salarioCalculado =
        Math.round(((valorSemanal * 4.4285 * 7) / 6) * 100) / 100;

      const currentSal = parseSalario(formData.salario);
      if (
        !currentSal ||
        currentSal < salarioCalculado ||
        currentSal === prevSalarioCalculadoRef.current
      ) {
        setFormData((prev) => ({
          ...prev,
          salario: salarioCalculado.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
          }),
        }));
      }

      prevSalarioCalculadoRef.current = salarioCalculado;
    }
  }, [formData.carga_horaria_diaria, salarioMinimoVigente]);

  useEffect(() => {
    if (modoEdicao) return;

    if (localAtividade === "") {
      setFormData((prev) => ({
        ...prev,
        endereco_aprendizagem_teorica: "",
      }));
      return;
    }

    if (localAtividade === "MATRIZ") {
      if (formData.regiao && unidadesCieemg.length > 0) {
        const unidadeEncontrada = unidadesCieemg.find(
          (u) => String(u.codigo) === String(formData.regiao),
        );

        if (unidadeEncontrada) {
          setFormData((prev) => ({
            ...prev,
            endereco_aprendizagem_teorica: unidadeEncontrada.endereco,
          }));
        }
      }
    }
  }, [formData.regiao, unidadesCieemg, localAtividade, modoEdicao]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = value;

    if (isCampoBloqueadoParaEmpresa(name)) {
      toastWarning(
        "Este campo é de responsabilidade do estudante e não pode ser alterado pela empresa.",
      );
      return;
    }

    if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
      return;
    }

    if (name === "data_inicio_contrato") {
    }

    const emojiRegex = /[\p{Extended_Pictographic}]/gu;
    const camposSemEmoji = [
      "cnpj_ou_cpf",
      "cpf",
      "cpf_mae",
      "cpf_declarante_ir",
      "dependente_1_cpf",
      "dependente_2_cpf",
      "dependente_3_cpf",
      "telefone_empresa",
      "telefone_representante_legal",
      "telefone_mae",
      "telefone_01",
      "telefone_02",
      "rg",
      "pis",
      "titulo_eleitor",
      "zona",
      "secao",
      "numero_certificado_reservista",
      "agencia",
      "div1",
      "conta",
      "div2",
      "cep",
      "data_nascimento",
      "data_nascimento_mae",
      "data_emissao_rg",
      "data_emissao_titulo",
      "data_emissao_certificado",
      "dependente_1_data_nascimento",
      "dependente_2_data_nascimento",
      "dependente_3_data_nascimento",
      "data_inicio_contrato",
      "carga_horaria_diaria",
      "salario",
      "horario_pratica_inicio",
      "horario_pratica_fim",
      "horario_teorica_inicio",
      "horario_teorica_fim",
    ];
    if (!camposSemEmoji.includes(name)) {
      newValue = newValue.replace(emojiRegex, "");
    }

    const regexLetras = /[^0-9a-zA-ZÀ-ÿ\s.,&\-/]/g;
    const camposLetras = [
      "razao_social",
      "nome_representante_legal",
      "cargo_representante_legal",
      "tutor_aprendiz_empresa",
      "cargo_tutor",
      "nome_tutor",
      "endereco_aprendizagem_pratica",
      "endereco_residencial_vt",
      "servicos_meios_transporte",
      "nome_completo",
      "nome_social",
      "estado_natal",
      "naturalidade",
      "nacionalidade",
      "cor",
      "nome_mae",
      "naturalidade_mae",
      "estado_civil_mae",
      "logradouro",
      "bairro",
      "cidade",
      "estado_endereco",
      "pais",
      "grau_instrucao",
      "curso_escolaridade",
      "instituicao_ensino",
      "conclusao",
      "orgao_emissor_rg",
      "estado_rg",
      "orgao_expedicao",
      "situacao_militar",
      "banco_pagamento",
      "risco_exposto",
      "nome_declarante_ir",
      "estado_civil_ir",
      "dependente_1_nome",
      "dependente_2_nome",
      "dependente_3_nome",
      "dependente_1_grau_parentesco",
      "dependente_2_grau_parentesco",
      "dependente_3_grau_parentesco",
      "dependente_1_naturalidade",
      "dependente_2_naturalidade",
      "dependente_3_naturalidade",
      "observacoes_ajuste_contrato",
    ];
    if (camposLetras.includes(name)) {
      newValue = newValue.replace(regexLetras, "");
    }

    const regexNumeros = /[^0-9]/g;
    const camposNumerosPuros = [
      "pis",
      "titulo_eleitor",
      "zona",
      "secao",
      "numero_certificado_reservista",
      "agencia",
      "div1",
      "div2",
      "conta",
      "qtd_dia_pratica",
      "qtd_dia_teorica",
    ];
    if (camposNumerosPuros.includes(name)) {
      newValue = newValue.replace(regexNumeros, "");
    }
    const updates = { [name]: newValue };

    if (name === "endereco_vt_uf") {
      updates["estado_endereco"] = newValue;
      setTcaFormValue("estado_endereco", newValue);
    }

    setFormData((prev) => ({ ...prev, ...updates }));
  };

  const buildReviewData = () => {
    const cpfLimpo = (formData.cpf || "").replace(/\D/g, "");

    const empregadorFields = [
      {
        label: "Nome do representante legal",
        value: formData.nome_representante_legal,
        complete: !!formData.nome_representante_legal?.trim(),
      },
      {
        label: "Cargo",
        value: formData.cargo_representante_legal,
        complete: !!formData.cargo_representante_legal?.trim(),
      },
      {
        label: "Data início contrato",
        value: formatDateBR(formData.data_inicio_contrato),
        complete: !!formData.data_inicio_contrato,
      },
      {
        label: "Salário",
        value: formData.salario,
        complete: !!formData.salario && formData.salario !== "R$ 0,00",
      },
    ];

    if (formData.telefone_empresa?.trim()) {
      empregadorFields.push({
        label: "Telefone Empresa",
        value: formData.telefone_empresa,
        complete: true,
      });
    }
    if (formData.email_empresa?.trim()) {
      empregadorFields.push({
        label: "E-mail Empresa",
        value: formData.email_empresa,
        complete: true,
      });
    }
    if (
      formData.nome_tutor?.trim() ||
      formData.tutor_aprendiz_empresa?.trim()
    ) {
      empregadorFields.push({
        label: "Tutor do Aprendiz",
        value: formData.nome_tutor || formData.tutor_aprendiz_empresa,
        complete: true,
      });
    }
    if (formData.email_tutor?.trim()) {
      empregadorFields.push({
        label: "E-mail do Tutor",
        value: formData.email_tutor,
        complete: true,
      });
    }

    const aprendizFields = [
      {
        label: "Curso",
        value: formData.curso,
        complete: !!formData.curso?.trim(),
      },
      {
        label: "Nome completo",
        value: formData.nome_completo,
        complete: !!formData.nome_completo?.trim(),
      },
      {
        label: "CPF (11 dígitos)",
        value: formData.cpf,
        complete: cpfLimpo.length === 11,
      },
      {
        label: "Data de nascimento",
        value: formatDateBR(formData.data_nascimento),
        complete: !!formData.data_nascimento,
      },
      // Nome da mãe: responsabilidade do estudante — não exibir no review
      // para não mostrar "Não preenchido" para a empresa.
    ];

    if (formData.rg?.trim()) {
      aprendizFields.push({ label: "RG", value: formData.rg, complete: true });
    }
    if (formData.pis?.trim()) {
      aprendizFields.push({
        label: "PIS",
        value: formData.pis,
        complete: true,
      });
    }
    if (formData.telefone_01?.trim()) {
      aprendizFields.push({
        label: "Telefone do Aprendiz",
        value: formData.telefone_01,
        complete: true,
      });
    }
    if (formData.email_pessoal?.trim()) {
      aprendizFields.push({
        label: "E-mail Pessoal",
        value: formData.email_pessoal,
        complete: true,
      });
    }
    if (formData.cep?.trim()) {
      aprendizFields.push({
        label: "CEP",
        value: formData.cep,
        complete: true,
      });
    }
    if (formData.logradouro?.trim()) {
      const endCompleto = `${formData.logradouro}, ${formData.numero_endereco || "S/N"}${formData.complemento ? " (" + formData.complemento + ")" : ""} - ${formData.bairro || ""}, ${formData.cidade || ""}/${formData.estado_endereco || ""}`;
      aprendizFields.push({
        label: "Endereço",
        value: endCompleto,
        complete: true,
      });
    }
    if (formData.grau_instrucao?.trim()) {
      aprendizFields.push({
        label: "Escolaridade",
        value: formData.grau_instrucao,
        complete: true,
      });
    }
    if (formData.curso_escolaridade?.trim()) {
      aprendizFields.push({
        label: "Curso Escolaridade",
        value: formData.curso_escolaridade,
        complete: true,
      });
    }
    if (formData.instituicao_ensino?.trim()) {
      aprendizFields.push({
        label: "Instituição de Ensino",
        value: formData.instituicao_ensino,
        complete: true,
      });
    }

    return [
      {
        id: "empregador",
        section: "Dados do Empregador",
        fields: empregadorFields,
      },
      {
        id: "aprendiz",
        section: "Dados do Aprendiz",
        fields: aprendizFields,
      },
      {
        id: "local",
        section: "Local de Atividade",
        fields: [
          {
            label: "Local de realização das atividades",
            value:
              localAtividade === "FILIAL"
                ? "Filial"
                : localAtividade || "MATRIZ",
            complete: !mostrarFiliais || !!localAtividade,
          },
        ],
      },
      ...(mostrarFiliais && localAtividade && localAtividade !== "MATRIZ"
        ? [
            {
              id: "filial",
              section: "Informações da Filial",
              fields: [
                {
                  label: "Nome da Filial",
                  value: formData.nome_filial,
                  complete: !!formData.nome_filial?.trim(),
                },
                {
                  label: "CPF/CNPJ",
                  value: formData.cpfCnpj,
                  complete: !!formData.cpfCnpj?.trim(),
                },
                {
                  label: "Município",
                  value: formData.enderecoFilial_municipio,
                  complete: !!formData.enderecoFilial_municipio?.trim(),
                },
                {
                  label: "UF",
                  value: formData.enderecoFilial_uf,
                  complete: !!formData.enderecoFilial_uf?.trim(),
                },
                {
                  label: "Telefone 1",
                  value: formData.telefones,
                  complete: !!formData.telefones?.trim(),
                },
                {
                  label: "Telefone 2",
                  value: formData.telefones2,
                  complete: true, // Opcional
                },
                {
                  label: "E-mail Contrato",
                  value: formData.emailContratos,
                  complete: !!formData.emailContratos?.trim(),
                },
                {
                  label: "E-mail Financeiro",
                  value: formData.emailFinanceiro,
                  complete: !!formData.emailFinanceiro?.trim(),
                },
                {
                  label: "Representante por",
                  value: formData.representadaPor,
                  complete: !!formData.representadaPor?.trim(),
                },
                {
                  label: "Cargo do Representante",
                  value: formData.cargoRepresentante,
                  complete: !!formData.cargoRepresentante?.trim(),
                },
                {
                  label: "E-mail do Representante",
                  value: formData.emailRepresentante,
                  complete: !!formData.emailRepresentante?.trim(),
                },
                {
                  label: "Supervisor do Estágio",
                  value: formData.responsavelSupervisor,
                  complete: !!formData.responsavelSupervisor?.trim(),
                },
                {
                  label: "Cargo do Supervisor",
                  value: formData.cargoSupervisor,
                  complete: !!formData.cargoSupervisor?.trim(),
                },
                {
                  label: "E-mail do Supervisor",
                  value: formData.emailSupervisor,
                  complete: !!formData.emailSupervisor?.trim(),
                },
              ],
            },
          ]
        : []),
      ...(formData.banco_pagamento || formData.conta
        ? [
            {
              id: "bancario",
              section: "Dados Bancários",
              fields: [
                ...(formData.banco_pagamento
                  ? [
                      {
                        label: "Banco",
                        value: formData.banco_pagamento,
                        complete: true,
                      },
                    ]
                  : []),
                ...(formData.agencia
                  ? [
                      {
                        label: "Agência",
                        value: `${formData.agencia}${formData.div1 ? "-" + formData.div1 : ""}`,
                        complete: true,
                      },
                    ]
                  : []),
                ...(formData.conta
                  ? [
                      {
                        label: "Conta",
                        value: `${formData.conta}${formData.div2 ? "-" + formData.div2 : ""}`,
                        complete: true,
                      },
                    ]
                  : []),
              ],
            },
          ]
        : []),
      ...(formData.endereco_residencial_vt || formData.servicos_meios_transporte
        ? [
            {
              id: "vt",
              section: "Vale Transporte",
              fields: [
                ...(formData.endereco_residencial_vt
                  ? [
                      {
                        label: "Endereço Residencial VT",
                        value: formData.endereco_residencial_vt,
                        complete: true,
                      },
                    ]
                  : []),
                ...(formData.servicos_meios_transporte
                  ? [
                      {
                        label: "Meios de Transporte",
                        value: formData.servicos_meios_transporte,
                        complete: true,
                      },
                    ]
                  : []),
                ...(formData.linha_pratica
                  ? [
                      {
                        label: "Linha Prática",
                        value: formData.linha_pratica,
                        complete: true,
                      },
                    ]
                  : []),
                ...(formData.tarifa_pratica
                  ? [
                      {
                        label: "Tarifa Prática",
                        value: formData.tarifa_pratica,
                        complete: true,
                      },
                    ]
                  : []),
              ],
            },
          ]
        : []),
      ...(formData.dependente_1_nome ||
      formData.dependente_2_nome ||
      formData.dependente_3_nome
        ? [
            {
              id: "dependentes",
              section: "Dependentes para IR",
              fields: [
                ...(formData.dependente_1_nome
                  ? [
                      {
                        label: "Dependente 1",
                        value: formData.dependente_1_nome,
                        complete: true,
                      },
                      {
                        label: "CPF Dep 1",
                        value: formData.dependente_1_cpf || "Não informado",
                        complete: true,
                      },
                    ]
                  : []),
                ...(formData.dependente_2_nome
                  ? [
                      {
                        label: "Dependente 2",
                        value: formData.dependente_2_nome,
                        complete: true,
                      },
                      {
                        label: "CPF Dep 2",
                        value: formData.dependente_2_cpf || "Não informado",
                        complete: true,
                      },
                    ]
                  : []),
                ...(formData.dependente_3_nome
                  ? [
                      {
                        label: "Dependente 3",
                        value: formData.dependente_3_nome,
                        complete: true,
                      },
                      {
                        label: "CPF Dep 3",
                        value: formData.dependente_3_cpf || "Não informado",
                        complete: true,
                      },
                    ]
                  : []),
              ],
            },
          ]
        : []),
    ];
  };

  const openReview = (role) => (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (e && e.stopPropagation) e.stopPropagation();

    if (role === "empresa") {
      const missingFields = buildMissingFields();
      if (missingFields.length > 0) {
        setMissingFieldsAlert(missingFields);
        setShowReview(false);
        return;
      }
    }


    const anexosFaltando = getAnexosObrigatoriosFaltandoEmpregador();
    if (anexosFaltando.length > 0) {
      setAnexosObrigatoriosDestacar(anexosFaltando.map((d) => d.id));
      setMissingFieldsAlert(
        anexosFaltando.map((d) => ({ id: d.id, label: d.label })),
      );
      toastWarning(
        `Anexos obrigatórios pendentes: ${anexosFaltando
          .map((d) => d.label)
          .join(", ")}.`,
      );
      setShowReview(false);
      return;
    }

    setAnexosObrigatoriosDestacar([]);
    setReviewRole(role);
    setMissingFieldsAlert([]);
    setShowReview(true);
  };

  const buildMissingFields = () => {
    const items = [];
    if (!formData.nome_representante_legal?.trim())
      items.push({
        id: "nome_representante_legal",
        label: "Nome do representante legal",
      });
    if (!formData.cargo_representante_legal?.trim())
      items.push({ id: "cargo_representante_legal", label: "Cargo" });
    if (!formData.data_inicio_contrato)
      items.push({ id: "data_inicio_contrato", label: "Data início contrato" });
    if (!formData.salario || formData.salario === "R$ 0,00")
      items.push({ id: "salario", label: "Salário" });
    if (!formData.curso?.trim()) items.push({ id: "curso", label: "Curso" });
    if (!formData.nome_completo?.trim())
      items.push({ id: "nome_completo", label: "Nome completo do aprendiz" });
    if (!formData.cpf || formData.cpf.replace(/\D/g, "").length !== 11)
      items.push({ id: "cpf", label: "CPF do aprendiz (11 dígitos)" });
    if (!formData.data_nascimento)
      items.push({ id: "data_nascimento", label: "Data de nascimento" });

    if (mostrarFiliais && !localAtividade)
      items.push({
        id: "localAtividade",
        label: "Local de realização das atividades",
      });
    return items;
  };

  const handleMissingFieldClick = (fieldId) => {
    setMissingFieldsAlert([]);
    setTimeout(() => {
      if (typeof fieldId === "string" && fieldId.startsWith("doc_")) {
        const el = document.getElementById(`file-input-${fieldId}`);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          if (typeof el.focus === "function") {
            try {
              el.focus({ preventScroll: true });
            } catch (_) {
              el.focus();
            }
          }
        }
        return;
      }

      const el =
        document.getElementById(fieldId) ||
        document.querySelector(`[name="${fieldId}"]`);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        if (typeof el.focus === "function") {
          try {
            el.focus({ preventScroll: true });
          } catch (_) {
            el.focus();
          }
        }
      }
    }, 150);
  };

  const handleEditSection = (sectionId) => {
    setShowReview(false);
    setTimeout(() => {
      const el = document.getElementById(`tca-section-${sectionId}`);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 200);
  };

  const handleConfirmSubmit = async () => {
    setShowReview(false);
    if (reviewRole === "estudante") {
      await submeterValidacaoEstudante();
    } else {
      await handleSubmitEmpregador();
    }
  };

  const handleSubmitEmpregador = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (e && e.stopPropagation) {
      e.stopPropagation();
    }

    if (submittingRef.current) return;

    submittingRef.current = true;

    const erros = [];
    if (!formData.nome_representante_legal?.trim())
      erros.push("Nome do representante legal");
    if (!formData.cargo_representante_legal?.trim()) erros.push("Cargo");
    if (!formData.data_inicio_contrato) erros.push("Data início contrato");
    if (!formData.salario || formData.salario === "R$ 0,00")
      erros.push("Salário");
    if (!formData.curso?.trim()) erros.push("Curso");
    if (!formData.nome_completo?.trim())
      erros.push("Nome completo do aprendiz");
    if (!formData.cpf || formData.cpf.replace(/\D/g, "").length !== 11)
      erros.push("CPF do aprendiz (11 dígitos)");
    if (!formData.data_nascimento) erros.push("Data de nascimento");
    if (mostrarFiliais && !localAtividade)
      erros.push("Local de realização das atividades");

    if (erros.length > 0) {
      const missingFields = buildMissingFields();
      setMissingFieldsAlert(missingFields);
      submittingRef.current = false;
      return;
    }

    const erroHorario =
      typeof validarHorarioAprendizagem === "function"
        ? validarHorarioAprendizagem()
        : null;
    if (erroHorario) {
      toastError(erroHorario);
      submittingRef.current = false;
      return;
    }

    let horasDiarias = 0;
    const chd = String(formData.carga_horaria_diaria || "").replace(/\D/g, "");
    if (chd === "4" || formData.carga_horaria_diaria === "4 horas diárias") {
      horasDiarias = 4;
    } else if (
      chd === "6" ||
      formData.carga_horaria_diaria === "6 horas diárias"
    ) {
      horasDiarias = 6;
    } else if (formData.curso && cursosFiltrados.length > 0) {
      const cursoObj = cursosFiltrados.find(
        (c) => c.valorObj.curso === formData.curso,
      );
      if (cursoObj && cursoObj.valorObj.carga_horaria) {
        const ch = String(cursoObj.valorObj.carga_horaria).replace(/\D/g, "");
        if (ch === "4" || ch === "1936" || ch === "1900") horasDiarias = 4;
        else if (ch === "6" || ch === "2230" || ch === "2000") horasDiarias = 6;
      }
    }

    if (horasDiarias === 4 || horasDiarias === 6) {
      const valorHora = Math.round((salarioMinimoVigente / 220) * 100) / 100;
      const horasSemanais = horasDiarias * 5;
      const valorSemanal = valorHora * horasSemanais;
      const salarioMinimoCalculado =
        Math.round(((valorSemanal * 4.4285 * 7) / 6) * 100) / 100;

      const salarioInformado = parseSalario(formData.salario);
      if (salarioInformado < salarioMinimoCalculado) {
        toastError(
          `O salário informado (R$ ${salarioInformado.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}) é inferior ao salário mínimo vigente de R$ ${salarioMinimoCalculado.toLocaleString("pt-BR", { minimumFractionDigits: 2 })} para a carga horária de ${horasDiarias} horas.`,
        );
        submittingRef.current = false;
        return;
      }
    }

    setSubmitting(true);

    try {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user"));

      const isEdicao = !!formData.id;
      const payloadBase = { ...formData };

      delete payloadBase.linha_pratica;
      delete payloadBase.tarifa_pratica;
      delete payloadBase.linha_teorica;
      delete payloadBase.tarifa_teorica;
      delete payloadBase.transportes_pratica_ida;
      delete payloadBase.transportes_pratica_volta;
      delete payloadBase.transportes_teoria_ida;
      delete payloadBase.transportes_teoria_volta;

      if (Number(user?.acesso_autorizacao) === 0) {
        CAMPOS_APRENDIZ_BLOQUEADOS_EMPRESA.forEach((k) => {
          delete payloadBase[k];
        });
        payloadBase.nome_mae = formData.nome_mae || "";
        payloadBase.bairro = formData.bairro || "";
      }

      const parseTarifa = (val) =>
        val ? parseFloat(String(val).replace(",", ".")) || null : null;

      const payload = {
        ...payloadBase,
        linha_pratica_ida_1:
          formData.transportes_pratica_ida?.[0]?.linha || null,
        tarifa_pratica_ida_1: parseTarifa(
          formData.transportes_pratica_ida?.[0]?.tarifa,
        ),
        linha_pratica_ida_2:
          formData.transportes_pratica_ida?.[1]?.linha || null,
        tarifa_pratica_ida_2: parseTarifa(
          formData.transportes_pratica_ida?.[1]?.tarifa,
        ),
        linha_pratica_volta_1:
          formData.transportes_pratica_volta?.[0]?.linha || null,
        tarifa_pratica_volta_1: parseTarifa(
          formData.transportes_pratica_volta?.[0]?.tarifa,
        ),
        linha_pratica_volta_2:
          formData.transportes_pratica_volta?.[1]?.linha || null,
        tarifa_pratica_volta_2: parseTarifa(
          formData.transportes_pratica_volta?.[1]?.tarifa,
        ),
        linha_teorica_ida__1:
          formData.transportes_teoria_ida?.[0]?.linha || null,
        tarifa_teorica_ida_1: parseTarifa(
          formData.transportes_teoria_ida?.[0]?.tarifa,
        ),
        linha_teorica_ida_2:
          formData.transportes_teoria_ida?.[1]?.linha || null,
        tarifa_teorica_ida_2: parseTarifa(
          formData.transportes_teoria_ida?.[1]?.tarifa,
        ),
        linha_teorica_volta_1:
          formData.transportes_teoria_volta?.[0]?.linha || null,
        tarifa_teorica_volta_1: parseTarifa(
          formData.transportes_teoria_volta?.[0]?.tarifa,
        ),
        linha_teorica_volta_2:
          formData.transportes_teoria_volta?.[1]?.linha || null,
        tarifa_teorica_volta_2: parseTarifa(
          formData.transportes_teoria_volta?.[1]?.tarifa,
        ),
        ...(() => {
          const out = {};
          const hIni = formData.horario_inicio_horas;
          const mIni = formData.horario_inicio_minutos;
          if (hIni && mIni) {
            out.horario_pratica_inicio = `${hIni}:${mIni}`;
          }
          const hFim = formData.horario_fim_horas;
          const mFim = formData.horario_fim_minutos;
          if (hFim && mFim) {
            out.horario_pratica_fim = `${hFim}:${mFim}`;
          }
          return out;
        })(),
        cidade: formData.cidade,
        email_contrato: formData.emailContratos,
        email_financeiro: formData.emailFinanceiro,
        cnpj_ou_cpf_filial: formData.cpfCnpj,
        nomecontato: formData.representadaPor,
        cargo: formData.cargoRepresentante,
        email: formData.emailRepresentante,
        nomecontato2: formData.responsavelSupervisor,
        cargo2: formData.cargoSupervisor,
        email1: formData.emailSupervisor,
        empresa_id: user.empresa_id,
        tipo_programa: 2,
        tipo_autorizacao:
          autorizacaoTca?.tipoAutorizacao || autorizacaoTca?.tipo,
        local_realizacao_atividades: localAtividade || "MATRIZ",
        local_execucao_diferente: formData.local_execucao_diferente ? 1 : 0,
        fumante: formData.fumante ? 1 : 0,
        deseja_vale_transporte: formData.deseja_vale_transporte ? 1 : 0,
        trabalhou_ambiente_insalubre: formData.trabalhou_ambiente_insalubre
          ? 1
          : 0,
        anexos_obrigatorios_ids: buildAnexosObrigatoriosIds({
          isEstudante,
          schema: ANEXOS_SCHEMA_TCA_EMPREGADOR,
        }),
        ...buildAnexosObrigatoriosBodyPatch({
          schema: ANEXOS_SCHEMA_TCA_EMPREGADOR,
          anexosFiles,
        }),
      };
      const response = isEdicao
        ? await axios.put(
            `${API_BASE_URL}/tca-empregador/${formData.id}`,
            payload,
            { headers: { Authorization: `Bearer ${token}` } },
          )
        : await axios.post(`${API_BASE_URL}/tca-empregador`, payload, {
            headers: { Authorization: `Bearer ${token}` },
          });


      invalidarCacheListaAcompanhamento();

      const filialIdNum = Number(localAtividade);
      const filialPayload = {
        nome_filial: formData.nome_filial,
        cnpj: formData.cpfCnpj,
        cep: formData.cepFilial,
        endereco: formData.enderecoFilial,
        telefone_1: formData.telefones,
        telefone_2: formData.telefones2,
        bairro: formData.enderecoFilial_bairro,
        cidade: formData.enderecoFilial_municipio,
        uf: formData.enderecoFilial_uf,
        email_contratos: formData.emailContratos,
        email_financeiro: formData.emailFinanceiro,
        representante_nome: formData.representadaPor,
        representante_cargo: formData.cargoRepresentante,
        representante_email: formData.emailRepresentante,
        supervisor_nome: formData.responsavelSupervisor,
        supervisor_cargo: formData.cargoSupervisor,
        supervisor_email: formData.emailSupervisor,
      };
      console.log(
        "[Filial][PUT] localAtividade =",
        localAtividade,
        "filialIdNum =",
        filialIdNum,
        "isNaN =",
        isNaN(filialIdNum),
      );
      if (
        localAtividade &&
        localAtividade !== "MATRIZ" &&
        !isNaN(filialIdNum)
      ) {
        try {
          console.log(
            "[Filial][PUT] enviando PUT /filiais/" + filialIdNum,
            filialPayload,
          );
          const filialResp = await axios.put(
            API_ENDPOINTS.filial_update(filialIdNum),
            filialPayload,
            { headers: { Authorization: `Bearer ${token}` } },
          );
          console.log(
            "[Filial][PUT] resposta:",
            filialResp.status,
            filialResp.data,
          );
          toastSuccess("Dados da filial atualizados.");
        } catch (filialErr) {
          console.warn(
            "Falha ao persistir filial (PUT /filiais/:id):",
            filialErr,
            filialErr?.response?.data,
          );
          const status = filialErr.response?.status;
          const backendMsg =
            filialErr.response?.data?.message ||
            filialErr.response?.data?.erro ||
            filialErr.response?.data?.error ||
            filialErr.message ||
            "Erro ao atualizar dados da filial";
          if (status === 403) {
            const acessos = filialErr.response?.data?.acessos_necessarios;
            const acessoTxt = Array.isArray(acessos)
              ? ` (níveis necessários: ${acessos.join(", ")})`
              : "";
            toastError(
              `Sem permissão para atualizar a filial${acessoTxt}. Contate o administrador do sistema.`,
            );
          } else if (status === 401) {
            toastError(
              "Sessão expirada. Faça login novamente para atualizar a filial.",
            );
          } else if (status === 404) {
            toastError("Filial não encontrada no servidor.");
          } else if (status >= 500) {
            toastError(`Erro no servidor ao atualizar filial: ${backendMsg}`);
          } else {
            toastError(backendMsg);
          }
        }
      } else {
        console.warn(
          "[Filial][PUT] NÃO enviado — localAtividade =",
          localAtividade,
          "filialIdNum =",
          filialIdNum,
        );
      }

      const novoTcaId = response.data?.id || response.data?.tcaId || "?";

      const isEmpresa = user?.tipo === "empresa" || user?.tipo_programa === 0;
      setSuccessModalData({
        isOpen: true,
        tceId: novoTcaId,
        role: isEmpresa ? "empresa" : "estagiario",
      });
    } catch (error) {
      console.error("ERRO AO SALVAR TCA CIEEMG:", error);

      if (error.response?.status === 400) {
        const data = error.response.data;
        const { anexosObrigatorios, camposFaltando } =
          parseAnexosObrigatoriosFromError(data);

        // Atualiza destaque visual dos cards no DocumentUploadForm
        setAnexosObrigatoriosDestacar(
          anexosObrigatorios.map(a => a.id).filter(Boolean),
        );

        const msgAnexos = anexosObrigatorios
          .map(a => a.label)
          .filter(Boolean)
          .join(", ");
        const msgCampos = camposFaltando.join(", ");
        const msgParts = [];
        if (msgAnexos) msgParts.push(`Anexos pendentes: ${msgAnexos}`);
        if (msgCampos) msgParts.push(`Campos pendentes: ${msgCampos}`);

        if (anexosObrigatorios.length > 0 || camposFaltando.length > 0) {
          const items = [
            ...anexosObrigatorios.map(a => ({ id: a.id, label: a.label })),
            ...camposFaltando.map(c => ({ id: c, label: c })),
          ];
          setMissingFieldsAlert(items);
        }

        if (msgParts.length > 0) {
          toastWarning(
            `Preencha os dados obrigatórios para enviar:\n${msgParts.join("\n")}`,
          );
          return;
        }
      }

      toastError(
        error.response?.data?.errors?.[0] ||
          error.response?.data?.message ||
          "Erro ao salvar TCA CIEEMG",
      );
    } finally {
      setSubmitting(false);

      submittingRef.current = false;
    }
  };

  const aprovarTcaEmpregador = async () => {
    const ok = await confirm({
      title: "Aprovar TCA",
      message:
        "Tem certeza que deseja APROVAR este TCA?\nEsta ação não pode ser desfeita.",
      confirmText: "Sim, aprovar",
      cancelText: "Cancelar",
      variant: "success",
    });
    if (!ok) return;
    const tcaId = formData.id;
    if (!tcaId) {
      toastError("ID do TCA não encontrado.");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${API_BASE_URL}/tca-empregador/${tcaId}/aprovar`,
        { observacao: "Aprovado por SECEX" },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      toastSuccess("TCA aprovado com sucesso!");
      if (carregarTcaExistente) carregarTcaExistente(tcaId);
    } catch (err) {
      console.error("Erro ao aprovar:", err);
      toastError(
        err.response?.data?.errors?.[0] || err.message || "Erro ao aprovar",
      );
    }
  };

  const submeterValidacaoEstudante = async () => {
    const tcaId = formData.id;
    if (!tcaId) {
      toastError("ID do TCA não encontrado.");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const payloadAtualizacao = {
        ...formData,
        anexos_obrigatorios_ids: buildAnexosObrigatoriosIds({
          isEstudante,
          schema: ANEXOS_SCHEMA_TCA_EMPREGADOR,
        }),
        ...buildAnexosObrigatoriosBodyPatch({
          schema: ANEXOS_SCHEMA_TCA_EMPREGADOR,
          anexosFiles,
        }),
      };
      await axios.put(
        `${API_BASE_URL}/tca-empregador/${tcaId}`,
        payloadAtualizacao,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      await axios.post(
        `${API_BASE_URL}/tca-empregador/${tcaId}/submeter-validacao-estudante`,
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      );
      setSuccessModalData({
        isOpen: true,
        tceId: tcaId,
        role: "estagiario",
      });
      if (carregarTcaExistente) carregarTcaExistente(tcaId);
    } catch (err) {
      console.error("Erro ao submeter validação do estudante:", err);

      if (err.response?.status === 400) {
        const data = err.response.data;
        const { anexosObrigatorios, camposFaltando } =
          parseAnexosObrigatoriosFromError(data);

        setAnexosObrigatoriosDestacar(
          anexosObrigatorios.map(a => a.id).filter(Boolean),
        );

        if (anexosObrigatorios.length > 0 || camposFaltando.length > 0) {
          const items = [
            ...anexosObrigatorios.map(a => ({ id: a.id, label: a.label })),
            ...camposFaltando.map(c => ({ id: c, label: c })),
          ];
          setMissingFieldsAlert(items);
          return;
        }
      }

      toastError(
        err.response?.data?.errors?.[0] ||
          err.message ||
          "Erro ao submeter para validação",
      );
    }
  };

  const recusarTcaEmpregador = async () => {
    const obs = await promptUser({
      title: "Recusar TCA",
      message: "Informe o motivo da recusa:",
      inputPlaceholder: "Ex: documentos incompletos...",
      confirmText: "Recusar TCA",
      cancelText: "Cancelar",
      variant: "danger",
    });
    if (!obs) return;
    const tcaId = formData.id;
    if (!tcaId) {
      toastError("ID do TCA não encontrado.");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${API_BASE_URL}/tca-empregador/${tcaId}/reprovar`,
        { observacao: obs },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      toastSuccess("TCA recusado!");
      if (carregarTcaExistente) carregarTcaExistente(tcaId);
    } catch (err) {
      console.error("Erro ao recusar:", err);
      toastError(
        err.response?.data?.errors?.[0] || err.message || "Erro ao recusar",
      );
    }
  };

  if (loading)
    return (
      <div className="tca-container tca-py-5 tca-text-center">Carregando…</div>
    );

  const carregarTcaExistente = async (id) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_BASE_URL}/tca-empregador/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const dados = { ...response.data };
      const camposData = [
        "data_emissao_rg",
        "data_emissao_titulo",
        "data_emissao_certificado",
        "data_nascimento",
        "data_nascimento_mae",
        "dependente_1_data_nascimento",
        "dependente_2_data_nascimento",
        "dependente_3_data_nascimento",
        "data_inicio_contrato",
      ];

      camposData.forEach((campo) => {
        if (dados[campo]) {
          dados[campo] = toDateInputValue(dados[campo]);
        }
      });

      if (
        dados.local_execucao_diferente !== undefined &&
        dados.local_execucao_diferente !== null
      ) {
        dados.local_execucao_diferente = Boolean(
          Number(dados.local_execucao_diferente),
        );
      }

      if (
        dados.salario !== null &&
        dados.salario !== undefined &&
        dados.salario !== ""
      ) {
        const num =
          typeof dados.salario === "string"
            ? parseFloat(dados.salario)
            : dados.salario;
        if (!isNaN(num)) {
          dados.salario = num.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          });
        }
      }
      setTcaStatus(dados.status);
      setFormData((prev) => {
        const merged = { ...prev, ...dados };
        const splitHHMM = (val) => {
          if (!val || typeof val !== "string" || !val.includes(":")) return null;
          const [h, m] = val.split(":");
          if (!h || !m) return null;
          return { h: String(h).padStart(2, "0"), m: String(m).padStart(2, "0") };
        };
        const iniParts =
          (dados.horario_inicio_horas || dados.horario_inicio_minutos
            ? {
                h: dados.horario_inicio_horas || "",
                m: dados.horario_inicio_minutos || "",
              }
            : null) || splitHHMM(dados.horario_pratica_inicio);
        const fimParts =
          (dados.horario_fim_horas || dados.horario_fim_minutos
            ? {
                h: dados.horario_fim_horas || "",
                m: dados.horario_fim_minutos || "",
              }
            : null) || splitHHMM(dados.horario_pratica_fim);
        if (iniParts) {
          merged.horario_inicio_horas = iniParts.h;
          merged.horario_inicio_minutos = iniParts.m;
          if (iniParts.h && iniParts.m) {
            merged.horario_pratica_inicio = `${iniParts.h}:${iniParts.m}`;
          }
        }
        if (fimParts) {
          merged.horario_fim_horas = fimParts.h;
          merged.horario_fim_minutos = fimParts.m;
          if (fimParts.h && fimParts.m) {
            merged.horario_pratica_fim = `${fimParts.h}:${fimParts.m}`;
          }
        }
        return merged;
      });

      tcaCarregadoEmRef.current = Date.now();

      setHorario((prev) => {
        let entrada = prev.fixo.entrada;
        let saida = prev.fixo.saida;
        if (
          dados.horario_inicio_horas &&
          dados.horario_inicio_minutos
        ) {
          entrada = `${dados.horario_inicio_horas}:${dados.horario_inicio_minutos}`;
        } else if (dados.horario_pratica_inicio) {
          entrada = dados.horario_pratica_inicio;
        }
        if (dados.horario_fim_horas && dados.horario_fim_minutos) {
          saida = `${dados.horario_fim_horas}:${dados.horario_fim_minutos}`;
        } else if (dados.horario_pratica_fim) {
          saida = dados.horario_pratica_fim;
        }
        return {
          ...prev,
          fixo: { ...prev.fixo, entrada, saida },
        };
      });
      if ([3, 4].includes(Number(user?.acesso_autorizacao))) {
        setTcaHistorico(dados.historico || []);
      } else {
        setTcaHistorico([]);
      }

      setAnexosFiles((prevFiles) =>
        hydrateAnexosFilesFromPayload({
          schema: ANEXOS_SCHEMA_TCA_EMPREGADOR,
          payload: dados,
          prev: prevFiles,
        }),
      );
    } catch (err) {
      console.error("Erro ao carregar TCA:", err);
      const status = err?.response?.status;
      const backendMsg =
        err?.response?.data?.errors?.[0] ||
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Erro ao carregar TCA existente.";
      toastError(
        status
          ? `Erro ${status} ao carregar TCA: ${backendMsg}`
          : `Erro ao carregar TCA: ${backendMsg}`,
      );
    }
  };

  carregarTcaExistenteRef.current = carregarTcaExistente;

  const aprovar = async () => {
    if (!tcaId) return;
    const observacao = prompt("Observação da aprovação (opcional):");
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${API_BASE_URL}/tca-empregador/${tcaId}/aprovar-validacao`,
        { observacao: observacao || "Aprovado" },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      toastSuccess("TCA Empregador aprovado!");
      carregarTcaExistente(tcaId);
    } catch (err) {
      toastError(err.response?.data?.errors?.[0] || "Erro ao aprovar");
    }
  };

  const recusar = async () => {
    if (!tcaId) return;
    const observacao = prompt("Motivo da recusa:");
    if (!observacao) return;
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${API_BASE_URL}/tca-empregador/${tcaId}/reprovar-validacao`,
        { observacao },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      toastWarning("TCA Empregador reprovado!");
      carregarTcaExistente(tcaId);
    } catch (err) {
      toastError(err.response?.data?.errors?.[0] || "Erro ao reprovar");
    }
  };

  const getStatusCor = (status) => {
    const s = String(status || "").toUpperCase();

    if (s === "INÍCIO" || s === "INICIO") return "#005ac2";
    if (s.includes("APROVADO") || s.includes("APROVAR")) return "#16a34a";
    if (
      s.includes("REJEITADO") ||
      s.includes("REPROVADO") ||
      s.includes("RECUSADO") ||
      s.includes("REJEITAR") ||
      s.includes("REPROVAR")
    )
      return "#dc2626";
    if (
      s.includes("PENDENTE") ||
      s.includes("AGUARDANDO") ||
      s.includes("EM_VALIDACAO") ||
      s.includes("CONTRATO_CONFECCIONADO") ||
      s.includes("DISPONIBILIZADO")
    )
      return "#eab308";

    return "#3b82f6";
  };

  const formatHorarioTeoricoLabel = (h) => {
    const inicio = h?.horario_inicio;
    const fim = h?.horario_fim;
    if (!inicio || !fim) return "";
    return `${inicio} às ${fim}`;
  };

  const adicionarTransporte = (tipo, sentido) => {
    if (isCampoBloqueadoParaEmpresa("deseja_vale_transporte")) {
      toastWarning("Apenas o estudante pode alterar essas informações.");
      return;
    }
    const key = `transportes_${tipo}_${sentido}`;
    setFormData((prev) => ({
      ...prev,
      [key]: [...(prev[key] || []), { id: Date.now(), linha: "", tarifa: "" }],
    }));
  };

  const removerTransporte = (tipo, sentido, idToRemove) => {
    if (isCampoBloqueadoParaEmpresa("deseja_vale_transporte")) {
      toastWarning("Apenas o estudante pode alterar essas informações.");
      return;
    }
    const key = `transportes_${tipo}_${sentido}`;
    setFormData((prev) => ({
      ...prev,
      [key]: (prev[key] || []).filter((item) => item.id !== idToRemove),
    }));
  };

  const handleChangeTransporte = (tipo, sentido, idToEdit, field, value) => {
    if (isCampoBloqueadoParaEmpresa("deseja_vale_transporte")) return;
    const key = `transportes_${tipo}_${sentido}`;
    setFormData((prev) => ({
      ...prev,
      [key]: (prev[key] || []).map((item) =>
        item.id === idToEdit ? { ...item, [field]: value } : item,
      ),
    }));
  };

  const renderTabelaSentido = (tipo, sentido) => {
    const key = `transportes_${tipo}_${sentido}`;
    const lista = formData[key] || [];
    const bloqueado = isCampoBloqueadoParaEmpresa("deseja_vale_transporte");

    if (lista.length === 0) {
      return (
        <div
          style={{
            color: "#94a3b8",
            fontSize: "0.9rem",
            padding: "1rem",
            textAlign: "center",
            border: "1px dashed rgba(255,255,255,0.2)",
            borderRadius: "4px",
          }}
        >
          Nenhum transporte cadastrado
        </div>
      );
    }

    return (
      <div
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderRadius: "6px",
          overflow: "hidden",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "0.9rem",
            color: "#333",
          }}
        >
          <thead>
            <tr
              style={{
                borderBottom: "2px solid #e2e8f0",
                backgroundColor: "#f8fafc",
              }}
            >
              <th
                style={{ padding: "0.75rem", textAlign: "left", width: "15%" }}
              >
                Sentido
              </th>
              <th
                style={{ padding: "0.75rem", textAlign: "left", width: "50%" }}
              >
                Linha / Transporte utilizado
              </th>
              <th
                style={{ padding: "0.75rem", textAlign: "left", width: "20%" }}
              >
                Tarifa (R$)
              </th>
              <th
                style={{
                  padding: "0.75rem",
                  textAlign: "center",
                  width: "15%",
                }}
              >
                Ações
              </th>
            </tr>
          </thead>
          <tbody>
            {lista.map((item) => (
              <tr key={item.id} style={{ borderBottom: "1px solid #e2e8f0" }}>
                <td
                  style={{
                    padding: "0.5rem 0.75rem",
                    textTransform: "capitalize",
                  }}
                >
                  {sentido}
                </td>
                <td style={{ padding: "0.5rem 0.75rem" }}>
                  <input
                    type="text"
                    value={item.linha}
                    onChange={(e) =>
                      handleChangeTransporte(
                        tipo,
                        sentido,
                        item.id,
                        "linha",
                        e.target.value,
                      )
                    }
                    disabled={bloqueado}
                    style={{
                      width: "100%",
                      border: "1px solid #cbd5e1",
                      borderRadius: "4px",
                      padding: "0.4rem",
                      fontSize: "0.9rem",
                    }}
                    placeholder="Ex: Ônibus 450"
                  />
                </td>
                <td style={{ padding: "0.5rem 0.75rem" }}>
                  <input
                    type="text"
                    value={item.tarifa}
                    onChange={(e) =>
                      handleChangeTransporte(
                        tipo,
                        sentido,
                        item.id,
                        "tarifa",
                        e.target.value,
                      )
                    }
                    disabled={bloqueado}
                    style={{
                      width: "100%",
                      border: "1px solid #cbd5e1",
                      borderRadius: "4px",
                      padding: "0.4rem",
                      fontSize: "0.9rem",
                    }}
                    placeholder="0,00"
                  />
                </td>
                <td style={{ padding: "0.5rem 0.75rem", textAlign: "center" }}>
                  <button
                    type="button"
                    onClick={() => removerTransporte(tipo, sentido, item.id)}
                    disabled={bloqueado}
                    style={{
                      background: "transparent",
                      border: "1px solid #ef4444",
                      color: "#ef4444",
                      borderRadius: "4px",
                      padding: "0.3rem 0.5rem",
                      cursor: bloqueado ? "not-allowed" : "pointer",
                      opacity: bloqueado ? 0.5 : 1,
                    }}
                    title="Remover"
                  >
                    🗑️
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const renderTabelaTransporte = (tipo, titulo, subtitulo, icone) => {
    const colorCode = tipo === "pratica" ? "#10b981" : "#3b82f6";
    const bgTranslucent =
      tipo === "pratica"
        ? "rgba(16, 185, 129, 0.1)"
        : "rgba(59, 130, 246, 0.1)";
    const bloqueado = isCampoBloqueadoParaEmpresa("deseja_vale_transporte");

    return (
      <div
        className="tca-mb-4"
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.05)",
          padding: "1.5rem",
          borderRadius: "8px",
          border: "1px solid rgba(255, 255, 255, 0.1)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            marginBottom: "1rem",
          }}
        >
          <div
            style={{
              backgroundColor: colorCode,
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "1.5rem",
              color: "#fff",
              flexShrink: 0,
            }}
          >
            {icone}
          </div>
          <div>
            <h5
              style={{
                color: colorCode,
                fontWeight: "bold",
                margin: 0,
                textTransform: "uppercase",
              }}
            >
              {titulo}
            </h5>
            <p style={{ color: "#e2e8f0", margin: 0, fontSize: "0.9rem" }}>
              {subtitulo}
            </p>
          </div>
        </div>

        <div className="tca-row">
          <div className="tca-col-md-6">
            <h6
              style={{
                color: colorCode,
                fontWeight: "bold",
                textTransform: "uppercase",
                marginBottom: "1rem",
              }}
            >
              IDA{" "}
              <span style={{ fontSize: "0.85rem", opacity: 0.8 }}>
                (residência ➔ {tipo === "pratica" ? "empresa" : "CIEE/MG"})
              </span>
            </h6>
            {renderTabelaSentido(tipo, "ida")}
            <button
              type="button"
              onClick={() => adicionarTransporte(tipo, "ida")}
              disabled={bloqueado}
              style={{
                background: bgTranslucent,
                border: `1px solid ${colorCode}`,
                color: colorCode,
                padding: "0.5rem 1rem",
                borderRadius: "4px",
                fontSize: "0.9rem",
                fontWeight: "600",
                cursor: bloqueado ? "not-allowed" : "pointer",
                marginTop: "1rem",
                opacity: bloqueado ? 0.5 : 1,
              }}
            >
              + Adicionar outro transporte
            </button>
          </div>

          <div className="tca-col-md-6 mt-4 mt-md-0">
            <h6
              style={{
                color: colorCode,
                fontWeight: "bold",
                textTransform: "uppercase",
                marginBottom: "1rem",
              }}
            >
              VOLTA{" "}
              <span style={{ fontSize: "0.85rem", opacity: 0.8 }}>
                ({tipo === "pratica" ? "empresa" : "CIEE/MG"} ➔ residência)
              </span>
            </h6>
            {renderTabelaSentido(tipo, "volta")}
            <button
              type="button"
              onClick={() => adicionarTransporte(tipo, "volta")}
              disabled={bloqueado}
              style={{
                background: bgTranslucent,
                border: `1px solid ${colorCode}`,
                color: colorCode,
                padding: "0.5rem 1rem",
                borderRadius: "4px",
                fontSize: "0.9rem",
                fontWeight: "600",
                cursor: bloqueado ? "not-allowed" : "pointer",
                marginTop: "1rem",
                opacity: bloqueado ? 0.5 : 1,
              }}
            >
              + Adicionar outro transporte
            </button>
          </div>
        </div>
      </div>
    );
  };

  const adicionarDependente = () => {
    if (dependentesList.length < 10) {
      setDependentesList((prev) => {
        let proximo = 1;
        while (prev.includes(proximo)) {
          proximo++;
        }
        return [...prev, proximo];
      });
    } else {
      toastWarning("Máximo de 10 dependentes permitido.");
    }
  };

  const removerDependente = (numero) => {
    setDependentesList(dependentesList.filter((n) => n !== numero));
    setFormData((prev) => ({
      ...prev,
      [`dependente_${numero}_nome`]: "",
      [`dependente_${numero}_cpf`]: "",
      [`dependente_${numero}_data_nascimento`]: "",
      [`dependente_${numero}_idade`]: "",
      [`dependente_${numero}_sexo`]: "",
      [`dependente_${numero}_grau_parentesco`]: "",
      [`dependente_${numero}_naturalidade`]: "",
    }));
  };

  const renderDependente = (numero, onRemover) => {
    const bloqueado = isCampoBloqueadoParaEmpresa(`dependente_${numero}_nome`);
    return (
      <div className="tca-card tca-mb-4">
        <div
          className="div-dados-empresa-title"
          style={{
            margin: "0",
            borderRadius: "12px 12px 0 0",
            position: "relative",
          }}
        >
          <span style={{ fontSize: "1.05rem", fontWeight: "700" }}>
            DEPENDENTE {numero}
          </span>
          {!bloqueado && (
            <button
              type="button"
              onClick={onRemover}
              title="Remover dependente"
              style={{
                position: "absolute",
                right: "1.5rem",
                top: "50%",
                transform: "translateY(-50%)",
                background: "rgba(239, 68, 68, 0.15)",
                border: "1px solid rgba(239, 68, 68, 0.3)",
                color: "#ef4444",
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#ef4444";
                e.currentTarget.style.color = "white";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor =
                  "rgba(239, 68, 68, 0.15)";
                e.currentTarget.style.color = "#ef4444";
              }}
            >
              <Trash2 size={18} />
            </button>
          )}
        </div>
        <div className="tca-row" style={{ padding: "1.5rem" }}>
          <div className="tca-col-md-5 tca-mb-3">
            <label>Nome</label>
            <input
              className="tca-form-control"
              name={`dependente_${numero}_nome`}
              value={formData[`dependente_${numero}_nome`] || ""}
              onChange={handleChange}
              readOnly={bloqueado}
            />
          </div>
          <div className="tca-col-md-3 tca-mb-3">
            <label>CPF</label>
            <InputMask
              mask="999.999.999-99"
              maskChar=" "
              className="tca-form-control"
              name={`dependente_${numero}_cpf`}
              value={formData[`dependente_${numero}_cpf`] || ""}
              onChange={handleChange}
              disabled={bloqueado}
            />
          </div>
          <div className="tca-col-md-4 tca-mb-3">
            <label>Data de Nascimento</label>
            <input
              type="date"
              className="tca-form-control"
              name={`dependente_${numero}_data_nascimento`}
              value={formData[`dependente_${numero}_data_nascimento`] || ""}
              onChange={handleChange}
              readOnly={bloqueado}
            />
          </div>
          <div className="tca-col-md-2 tca-mb-3">
            <label>Idade</label>
            <input
              className="tca-form-control"
              name={`dependente_${numero}_idade`}
              value={formData[`dependente_${numero}_idade`] || ""}
              onChange={handleChange}
              readOnly={bloqueado}
            />
          </div>
          <div className="tca-col-md-3 tca-mb-3">
            <label>Sexo</label>
            <select
              className="tca-form-control"
              name={`dependente_${numero}_sexo`}
              value={formData[`dependente_${numero}_sexo`] || ""}
              onChange={handleChange}
              disabled={bloqueado}
            >
              <option value="">Selecione</option>
              <option value="M">Masculino</option>
              <option value="F">Feminino</option>
            </select>
          </div>
          <div className="tca-col-md-3 tca-mb-3">
            <label>Grau de Parentesco</label>
            <input
              className="tca-form-control"
              name={`dependente_${numero}_grau_parentesco`}
              value={formData[`dependente_${numero}_grau_parentesco`] || ""}
              onChange={handleChange}
              readOnly={bloqueado}
            />
          </div>
          <div className="tca-col-md-4 tca-mb-3">
            <label>Naturalidade</label>
            <input
              className="tca-form-control"
              name={`dependente_${numero}_naturalidade`}
              value={formData[`dependente_${numero}_naturalidade`] || ""}
              onChange={handleChange}
              readOnly={bloqueado}
            />
          </div>
        </div>
      </div>
    );
  };

  const cidadeAtualEmpregador = formData.cidade;

  const horariosTeoricosDisponiveis = horariosTeoricos.filter((h) => {
    const lista = Array.isArray(h.municipios) ? h.municipios : [];
    if (lista.length === 0) return true;

    if (!cidadeAtualEmpregador) return true;

    const cidadeNorm = String(cidadeAtualEmpregador).trim().toUpperCase();
    return lista.some((m) => String(m).trim().toUpperCase() === cidadeNorm);
  });

  return (
    <div className="tca-container tca-py-4 tca-ci-eemg-page tca-ci-eemg-page-fade">
      <h2 className="tca-h2">TCA — Programa Aprendiz CIEE/MG Empregador</h2>
      {success && (
        <div className="tca-alert tca-alert-success">
          <p>
            <strong>✅ TCA CIEEMG enviado com sucesso!</strong>
          </p>
          <p>
            O processo seguirá para validação do CIEEMG. Acompanhe pelo menu
            Acompanhamento.
          </p>
        </div>
      )}

      {error && <div className="tca-alert tca-alert-danger">{error}</div>}

      <form className="tca-ci-eemg-form" onSubmit={(e) => e.preventDefault()}>
        <section className="tca-card tca-mb-4" id="tca-section-empregador">
          <div className="tca-card-header">
            1. Dados da Empresa + Representante + Aprendizagem
          </div>
          <div className="tca-card-body">
            <div className="tca-row">
              <div className="tca-col-md-8 tca-mb-3">
                <label>Razão Social</label>
                <input
                  className="tca-form-control"
                  name="razao_social"
                  value={formData.razao_social}
                  onChange={handleChange}
                  readOnly={isEmpresaReadOnly}
                  required
                />
              </div>

              <div className="tca-col-md-4 tca-mb-3">
                <label>CNPJ/CPF</label>
                <input
                  className="tca-form-control"
                  name="cnpj_ou_cpf"
                  value={formData.cnpj_ou_cpf}
                  onChange={handleChange}
                  readOnly={isEmpresaReadOnly}
                  required
                />
              </div>

              <div className="tca-col-md-4 tca-mb-3">
                <label>Telefone</label>
                <input
                  className="tca-form-control"
                  name="telefone_empresa"
                  value={formData.telefone_empresa}
                  onChange={handleChange}
                  readOnly={isEmpresaReadOnly}
                />
              </div>

              <div className="tca-col-md-8 tca-mb-3">
                <label>E-mail</label>
                <input
                  type="email"
                  className="tca-form-control"
                  name="email_empresa"
                  value={formData.email_empresa}
                  onChange={handleChange}
                  readOnly={isEmpresaReadOnly}
                />
              </div>

              {permissao?.podeEditarEmpresa === true && (
                <>
                  <div
                    className="tca-col-md-12 tca-mb-3"
                    id="tca-section-local"
                  >
                    <label>Unidade</label>
                    <select
                      className="tca-form-control"
                      name="local_realizacao_atividades"
                      value={formData.local_realizacao_atividades}
                      onChange={(e) => {
                        const val = e.target.value;
                        console.log("[Filial] Unidade mudou para:", val);
                        handleChange(e);
                        // Ao trocar para FILIAL, auto-seleciona a primeira filial
                        // disponível para disparar o carregamento via GET /filiais/:id.
                        if (val === "FILIAL") {
                          if (
                            !localAtividade ||
                            localAtividade === "" ||
                            localAtividade === "MATRIZ"
                          ) {
                            const primeiraFilial = filiais.find(
                              (f) =>
                                f.id !== 0 &&
                                f.id !== undefined &&
                                f.id !== null,
                            );
                            if (primeiraFilial) {
                              const id = String(primeiraFilial.id);
                              console.log(
                                "[Filial] auto-selecionando primeira filial:",
                                id,
                              );
                              setLocalAtividade(id);
                            }
                          }
                        } else if (val === "MATRIZ") {
                          setLocalAtividade("MATRIZ");
                        }
                      }}
                    >
                      <option value="" disabled>
                        Selecione
                      </option>
                      <option value="MATRIZ">Matriz</option>
                      {mostrarFiliais && <option value="FILIAL">Filial</option>}
                    </select>
                  </div>

                  <div className="tca-col-md-12 tca-mb-3">
                    <div className="div-local-execucao-pergunta">
                      <label>
                        O local de execução das atividades práticas é diferente
                        do CNPJ informado acima?
                      </label>
                      <div className="tca-radio-group">
                        <label className="tca-form-check tca-form-check-inline">
                          <input
                            type="radio"
                            name="local_execucao_diferente"
                            value="1"
                            checked={
                              formData.local_execucao_diferente === true ||
                              formData.local_execucao_diferente === 1
                            }
                            onChange={() =>
                              setFormData((prev) => ({
                                ...prev,
                                local_execucao_diferente: true,
                              }))
                            }
                          />
                          <span>Sim</span>
                        </label>
                        <label className="tca-form-check tca-form-check-inline">
                          <input
                            type="radio"
                            name="local_execucao_diferente"
                            value="0"
                            checked={
                              formData.local_execucao_diferente === false ||
                              formData.local_execucao_diferente === 0
                            }
                            onChange={() =>
                              setFormData((prev) => ({
                                ...prev,
                                local_execucao_diferente: false,
                                emp_local_razao_social: "",
                                emp_local_cnpj: "",
                                emp_local_telefone: "",
                                emp_local_email: "",
                                emp_local_endereco: "",
                                emp_local_bairro: "",
                                emp_local_cidade: "",
                                emp_local_uf: "",
                                emp_local_cep: "",
                                emp_local_rep_nome: "",
                                emp_local_rep_cargo: "",
                                emp_local_rep_telefone: "",
                                emp_local_rep_email: "",
                                resp_admin_nome: "",
                                resp_admin_cargo: "",
                                resp_admin_telefone: "",
                                resp_admin_email: "",
                              }))
                            }
                          />
                          <span>Não</span>
                        </label>
                      </div>
                    </div>
                  </div>

                  {Boolean(formData.local_execucao_diferente) && (
                    <div
                      className="tca-col-md-12"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "1.5rem",
                        padding: "0 15px",
                        marginBottom: "2rem",
                      }}
                    >
                      {/* Card 1: Dados da Empresa */}
                      <div
                        style={{
                          background: "rgba(255, 255, 255, 0.04)",
                          border: "1px solid rgba(255, 255, 255, 0.15)",
                          borderRadius: "12px",
                          padding: "1.5rem",
                        }}
                      >
                        <div
                          style={{
                            marginBottom: "1.5rem",
                            borderBottom: "1px solid rgba(255,255,255,0.1)",
                            paddingBottom: "0.5rem",
                          }}
                        >
                          <h4
                            style={{
                              color: "#fff",
                              fontSize: "1.1rem",
                              fontWeight: "bold",
                              margin: 0,
                            }}
                          >
                            1. Dados da Empresa Contratante (Local de Execução
                            das Atividades Práticas)
                          </h4>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            margin: "0 -0.5rem",
                          }}
                        >
                          <div
                            className="tca-col-md-12"
                            style={{
                              padding: "0 0.5rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <label
                              style={{
                                color: "#fff",
                                marginBottom: "0.25rem",
                                display: "block",
                              }}
                            >
                              Razão Social:
                            </label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="emp_local_razao_social"
                              disabled={!permissao.podeEditarEmpresa}
                              maxLength={200}
                              onChange={handleChange}
                              value={formData.emp_local_razao_social || ""}
                              style={{ borderRadius: "20px" }}
                            />
                          </div>
                          <div
                            className="tca-col-md-4"
                            style={{
                              padding: "0 0.5rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <label
                              style={{
                                color: "#fff",
                                marginBottom: "0.25rem",
                                display: "block",
                              }}
                            >
                              CNPJ:
                            </label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="emp_local_cnpj"
                              disabled={!permissao.podeEditarEmpresa}
                              maxLength={18}
                              onChange={handleChange}
                              value={
                                formatarCnpjCpf(formData.emp_local_cnpj) || ""
                              }
                              style={{ borderRadius: "20px" }}
                            />
                          </div>
                          <div
                            className="tca-col-md-4"
                            style={{
                              padding: "0 0.5rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <label
                              style={{
                                color: "#fff",
                                marginBottom: "0.25rem",
                                display: "block",
                              }}
                            >
                              Telefone:
                            </label>
                            <InputMask
                              mask="(99)99999-9999"
                              maskChar=" "
                              type="text"
                              className="tca-form-control"
                              name="emp_local_telefone"
                              autoComplete="off"
                              disabled={!permissao.podeEditarEmpresa}
                              onChange={handleChange}
                              value={formData.emp_local_telefone || ""}
                              style={{ borderRadius: "20px" }}
                            />
                          </div>
                          <div
                            className="tca-col-md-4"
                            style={{
                              padding: "0 0.5rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <label
                              style={{
                                color: "#fff",
                                marginBottom: "0.25rem",
                                display: "block",
                              }}
                            >
                              E-mail:
                            </label>
                            <input
                              type="email"
                              className="tca-form-control"
                              name="emp_local_email"
                              disabled={!permissao.podeEditarEmpresa}
                              maxLength={80}
                              onChange={handleChange}
                              value={formData.emp_local_email || ""}
                              style={{ borderRadius: "20px" }}
                            />
                          </div>
                          <div
                            className="tca-col-md-8"
                            style={{
                              padding: "0 0.5rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <label
                              style={{
                                color: "#fff",
                                marginBottom: "0.25rem",
                                display: "block",
                              }}
                            >
                              Endereço:
                            </label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="emp_local_endereco"
                              disabled={!permissao.podeEditarEmpresa}
                              maxLength={200}
                              onChange={handleChange}
                              value={formData.emp_local_endereco || ""}
                              style={{ borderRadius: "20px" }}
                            />
                          </div>
                          <div
                            className="tca-col-md-4"
                            style={{
                              padding: "0 0.5rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <label
                              style={{
                                color: "#fff",
                                marginBottom: "0.25rem",
                                display: "block",
                              }}
                            >
                              Bairro:
                            </label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="emp_local_bairro"
                              disabled={!permissao.podeEditarEmpresa}
                              maxLength={100}
                              onChange={handleChange}
                              value={formData.emp_local_bairro || ""}
                              style={{ borderRadius: "20px" }}
                            />
                          </div>
                          <div
                            className="tca-col-md-6"
                            style={{
                              padding: "0 0.5rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <label
                              style={{
                                color: "#fff",
                                marginBottom: "0.25rem",
                                display: "block",
                              }}
                            >
                              Cidade:
                            </label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="emp_local_cidade"
                              disabled={!permissao.podeEditarEmpresa}
                              maxLength={100}
                              onChange={handleChange}
                              value={formData.emp_local_cidade || ""}
                              style={{ borderRadius: "20px" }}
                            />
                          </div>
                          <div
                            className="tca-col-md-2"
                            style={{
                              padding: "0 0.5rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <label
                              style={{
                                color: "#fff",
                                marginBottom: "0.25rem",
                                display: "block",
                              }}
                            >
                              UF:
                            </label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="emp_local_uf"
                              disabled={!permissao.podeEditarEmpresa}
                              maxLength={2}
                              onChange={handleChange}
                              value={formData.emp_local_uf || ""}
                              style={{ borderRadius: "20px" }}
                            />
                          </div>
                          <div
                            className="tca-col-md-4"
                            style={{
                              padding: "0 0.5rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <label
                              style={{
                                color: "#fff",
                                marginBottom: "0.25rem",
                                display: "block",
                              }}
                            >
                              CEP:
                            </label>
                            <InputMask
                              mask="99999-999"
                              maskChar=" "
                              type="text"
                              className="tca-form-control"
                              name="emp_local_cep"
                              autoComplete="off"
                              disabled={!permissao.podeEditarEmpresa}
                              onChange={handleChange}
                              value={formData.emp_local_cep || ""}
                              style={{ borderRadius: "20px" }}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Card 2: Representante Legal */}
                      <div
                        style={{
                          background: "rgba(255, 255, 255, 0.04)",
                          border: "1px solid rgba(255, 255, 255, 0.15)",
                          borderRadius: "12px",
                          padding: "1.5rem",
                        }}
                      >
                        <div
                          style={{
                            marginBottom: "1.5rem",
                            borderBottom: "1px solid rgba(255,255,255,0.1)",
                            paddingBottom: "0.5rem",
                          }}
                        >
                          <h4
                            style={{
                              color: "#fff",
                              fontSize: "1.05rem",
                              fontWeight: "bold",
                              margin: 0,
                            }}
                          >
                            2.Representante Legal
                          </h4>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            margin: "0 -0.5rem",
                          }}
                        >
                          <div
                            className="tca-col-md-6"
                            style={{
                              padding: "0 0.5rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <label
                              style={{
                                color: "#fff",
                                marginBottom: "0.25rem",
                                display: "block",
                              }}
                            >
                              Nome:
                            </label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="emp_local_rep_nome"
                              disabled={!permissao.podeEditarEmpresa}
                              maxLength={100}
                              onChange={handleChange}
                              value={formData.emp_local_rep_nome || ""}
                              style={{ borderRadius: "20px" }}
                            />
                          </div>
                          <div
                            className="tca-col-md-6"
                            style={{
                              padding: "0 0.5rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <label
                              style={{
                                color: "#fff",
                                marginBottom: "0.25rem",
                                display: "block",
                              }}
                            >
                              Cargo:
                            </label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="emp_local_rep_cargo"
                              disabled={!permissao.podeEditarEmpresa}
                              maxLength={100}
                              onChange={handleChange}
                              value={formData.emp_local_rep_cargo || ""}
                              style={{ borderRadius: "20px" }}
                            />
                          </div>
                          <div
                            className="tca-col-md-6"
                            style={{
                              padding: "0 0.5rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <label
                              style={{
                                color: "#fff",
                                marginBottom: "0.25rem",
                                display: "block",
                              }}
                            >
                              Telefone:
                            </label>
                            <InputMask
                              mask="(99)99999-9999"
                              maskChar=" "
                              type="text"
                              className="tca-form-control"
                              name="emp_local_rep_telefone"
                              autoComplete="off"
                              disabled={!permissao.podeEditarEmpresa}
                              onChange={handleChange}
                              value={formData.emp_local_rep_telefone || ""}
                              style={{ borderRadius: "20px" }}
                            />
                          </div>
                          <div
                            className="tca-col-md-6"
                            style={{
                              padding: "0 0.5rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <label
                              style={{
                                color: "#fff",
                                marginBottom: "0.25rem",
                                display: "block",
                              }}
                            >
                              E-mail:
                            </label>
                            <input
                              type="email"
                              className="tca-form-control"
                              name="emp_local_rep_email"
                              disabled={!permissao.podeEditarEmpresa}
                              maxLength={100}
                              onChange={handleChange}
                              value={formData.emp_local_rep_email || ""}
                              style={{ borderRadius: "20px" }}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Card 3: Responsável Administrativo */}
                      <div
                        style={{
                          background: "rgba(255, 255, 255, 0.04)",
                          border: "1px solid rgba(255, 255, 255, 0.15)",
                          borderRadius: "12px",
                          padding: "1.5rem",
                        }}
                      >
                        <div
                          style={{
                            marginBottom: "1.5rem",
                            borderBottom: "1px solid rgba(255,255,255,0.1)",
                            paddingBottom: "0.5rem",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <h4
                            style={{
                              color: "#fff",
                              fontSize: "1.05rem",
                              fontWeight: "bold",
                              margin: 0,
                            }}
                          >
                            3. Responsável Administrativo
                          </h4>
                          <small
                            style={{
                              color: "rgba(255,255,255,0.6)",
                              fontSize: "0.85rem",
                            }}
                          >
                            DocuSign Envelope ID:
                            8F16BC02-BBEC-44BB-99A7-17EA297088F1
                          </small>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            margin: "0 -0.5rem",
                          }}
                        >
                          <div
                            className="tca-col-md-6"
                            style={{
                              padding: "0 0.5rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <label
                              style={{
                                color: "#fff",
                                marginBottom: "0.25rem",
                                display: "block",
                              }}
                            >
                              Nome:
                            </label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="resp_admin_nome"
                              disabled={!permissao.podeEditarEmpresa}
                              maxLength={100}
                              onChange={handleChange}
                              value={formData.resp_admin_nome || ""}
                              style={{ borderRadius: "20px" }}
                            />
                          </div>
                          <div
                            className="tca-col-md-6"
                            style={{
                              padding: "0 0.5rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <label
                              style={{
                                color: "#fff",
                                marginBottom: "0.25rem",
                                display: "block",
                              }}
                            >
                              Cargo:
                            </label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="resp_admin_cargo"
                              disabled={!permissao.podeEditarEmpresa}
                              maxLength={100}
                              onChange={handleChange}
                              value={formData.resp_admin_cargo || ""}
                              style={{ borderRadius: "20px" }}
                            />
                          </div>
                          <div
                            className="tca-col-md-6"
                            style={{
                              padding: "0 0.5rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <label
                              style={{
                                color: "#fff",
                                marginBottom: "0.25rem",
                                display: "block",
                              }}
                            >
                              Telefone:
                            </label>
                            <InputMask
                              mask="(99)99999-9999"
                              maskChar=" "
                              type="text"
                              className="tca-form-control"
                              name="resp_admin_telefone"
                              autoComplete="off"
                              disabled={!permissao.podeEditarEmpresa}
                              onChange={handleChange}
                              value={formData.resp_admin_telefone || ""}
                              style={{ borderRadius: "20px" }}
                            />
                          </div>
                          <div
                            className="tca-col-md-6"
                            style={{
                              padding: "0 0.5rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <label
                              style={{
                                color: "#fff",
                                marginBottom: "0.25rem",
                                display: "block",
                              }}
                            >
                              E-mail:
                            </label>
                            <input
                              type="email"
                              className="tca-form-control"
                              name="resp_admin_email"
                              disabled={!permissao.podeEditarEmpresa}
                              maxLength={100}
                              onChange={handleChange}
                              value={formData.resp_admin_email || ""}
                              style={{ borderRadius: "20px" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {mostrarFiliais &&
                    formData.local_realizacao_atividades === "FILIAL" && (
                      <>
                        <div id="tca-section-filial" />
                        <hr className="tca-hr" />
                        <div className="tca-row">
                          <div
                            className="tca-col-md-12 tca-mb-3"
                            id="filial-info"
                          >
                            <label>
                              <h3>Informações da Filial</h3>
                            </label>
                          </div>

                          <div className="tca-col-md-12 tca-mb-3">
                            <label>
                              Selecione a Filial Específica (Auto-preenchimento)
                            </label>
                            <select
                              className="tca-form-control"
                              value={localAtividade}
                              onChange={(e) =>
                                setLocalAtividade(e.target.value)
                              }
                            >
                              <option value="">Selecione a filial...</option>
                              {filiais
                                .filter(
                                  (f) =>
                                    f.id !== 0 &&
                                    f.id !== undefined &&
                                    f.id !== null,
                                )
                                .map((f) => (
                                  <option key={f.id} value={f.id}>
                                    {f.nome_filial ||
                                      f.razao_social ||
                                      f.nome ||
                                      `Filial (ID: ${f.id})`}
                                  </option>
                                ))}
                            </select>
                          </div>

                          <div className="tca-col-md-4 tca-mb-3">
                            <label>Nome da Filial</label>
                            <input
                              className="tca-form-control"
                              name="nome_filial"
                              value={formData.nome_filial}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="tca-col-md-4 tca-mb-3">
                            <label>CPF/CNPJ</label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="cpfCnpj"
                              value={formData.cpfCnpj}
                              onChange={handleChange}
                            />
                          </div>

                          <div
                            className="tca-col-md-4 tca-mb-3"
                            // style={{ width: "100%" }}
                          >
                            <label>CEP</label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="cepFilial"
                              value={formData.cepFilial || ""}
                              onChange={handleChange}
                              onBlur={handleCepFilialBlur}
                              maxLength={9}
                              placeholder="Apenas números"
                            />
                          </div>

                          <div
                            className="tca-col-md-4 tca-mb-3"
                            // style={{ width: "100%" }}
                          >
                            <label>Endereço</label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="enderecoFilial"
                              value={formData.enderecoFilial || ""}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="tca-col-md-4 tca-mb-3">
                            <label>Bairro/Distrito</label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="enderecoFilial_bairro"
                              value={formData.enderecoFilial_bairro}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="tca-col-md-4 tca-mb-3">
                            <label>Municipio</label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="enderecoFilial_municipio"
                              value={formData.enderecoFilial_municipio}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="tca-col-md-4 tca-mb-3">
                            <label>UF</label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="enderecoFilial_uf"
                              value={formData.enderecoFilial_uf}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="tca-col-md-4 tca-mb-3">
                            <label>Telefone 1</label>
                            <InputMask
                              mask="(99)99999-9999"
                              maskChar=" "
                              className="tca-form-control"
                              name="telefones"
                              value={formData.telefones}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="tca-col-md-4 tca-mb-3">
                            <label>Telefone 2</label>
                            <InputMask
                              mask="(99)99999-9999"
                              maskChar=" "
                              className="tca-form-control"
                              name="telefones2"
                              value={formData.telefones2}
                              onChange={handleChange}
                            />
                          </div>

                          <div
                            className="tca-col-md-4 tca-mb-3"
                            // style={{ width: "100%" }}
                          >
                            <label>E-mail Contrato</label>
                            <input
                              type="email"
                              className="tca-form-control"
                              name="emailContratos"
                              value={formData.emailContratos}
                              onChange={handleChange}
                            />
                          </div>

                          <div
                            className="tca-col-md-4 tca-mb-3"
                            // style={{ width: "100%" }}
                          >
                            <label>E-mail Financeiro</label>
                            <input
                              type="email"
                              className="tca-form-control"
                              name="emailFinanceiro"
                              value={formData.emailFinanceiro}
                              onChange={handleChange}
                            />
                          </div>

                          <div
                            className="tca-col-md-12 tca-mb-3"
                            id="filial-info"
                          >
                            <label>
                              <h3>Representante da Filial</h3>
                            </label>
                          </div>

                          <div className="tca-col-md-4 tca-mb-3">
                            <label>Representante Por</label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="representadaPor"
                              value={formData.representadaPor}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="tca-col-md-4 tca-mb-3">
                            <label>Cargo</label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="cargoRepresentante"
                              value={formData.cargoRepresentante}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="tca-col-md-4 tca-mb-3">
                            <label>E-mail</label>
                            <input
                              type="email"
                              className="tca-form-control"
                              name="emailRepresentante"
                              value={formData.emailRepresentante}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="tca-col-md-4 tca-mb-3">
                            <label>Responsvel/Supervisor do Estágio</label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="responsavelSupervisor"
                              value={formData.responsavelSupervisor}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="tca-col-md-4 tca-mb-3">
                            <label>Cargo</label>
                            <input
                              type="text"
                              className="tca-form-control"
                              name="cargoSupervisor"
                              value={formData.cargoSupervisor}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="tca-col-md-4 tca-mb-3">
                            <label>E-mail</label>
                            <input
                              type="email"
                              className="tca-form-control"
                              name="emailSupervisor"
                              value={formData.emailSupervisor}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        {filialLoading && (
                          <div
                            className="tca-col-md-12 tca-mb-3"
                            style={{
                              color: "#475569",
                              fontStyle: "italic",
                              fontSize: "0.875rem",
                            }}
                          >
                            Carregando dados da filial…
                          </div>
                        )}
                      </>
                    )}
                </>
              )}
            </div>

            <hr className="tca-hr" />
            <h6 className="tca-h6">
              Representante Legal (quem assina o contrato)
            </h6>
            <div className="tca-row">
              <div className="tca-col-md-6 tca-mb-3">
                <label>Nome</label>
                <input
                  className="tca-form-control"
                  name="nome_representante_legal"
                  value={formData.nome_representante_legal}
                  onChange={handleChange}
                  maxLength={100}
                />
              </div>

              <div className="tca-col-md-6 tca-mb-3">
                <label>Cargo</label>
                <input
                  className="tca-form-control"
                  name="cargo_representante_legal"
                  value={formData.cargo_representante_legal}
                  onChange={handleChange}
                />
              </div>

              <div className="tca-col-md-6 tca-mb-3">
                <label>Telefone</label>
                <InputMask
                  mask="(99)99999-9999"
                  maskChar=" "
                  className="tca-form-control"
                  name="telefone_representante_legal"
                  value={formData.telefone_representante_legal}
                  onChange={handleChange}
                />
              </div>

              <div className="tca-col-md-6 tca-mb-3">
                <label>E-mail</label>
                <input
                  type="email"
                  className="tca-form-control"
                  name="email_representante_legal"
                  value={formData.email_representante_legal}
                  onChange={handleChange}
                />
              </div>
            </div>

            <hr className="tca-hr" />
            <h6 className="tca-h6">Dados da Aprendizagem</h6>
            <div className="tca-row">
              <div className="tca-col-md-4 tca-mb-3">
                <label className="all-label" htmlFor="data_inicio_contrato">
                  Data do início do contrato:
                </label>
                <select
                  className="tca-form-control"
                  name="data_inicio_contrato"
                  id="data_inicio_contrato"
                  disabled={!permissao?.podeEditarEmpresa}
                  value={formData.data_inicio_contrato || ""}
                  onChange={(e) => {
                    const inicio = e.target.value;
                    // Auto-preencher Vigência Final = data de início + 2 anos - 1 dia (regra da aprendizagem)
                    let fimAuto = "";
                    if (inicio) {
                      const [y, m, d] = inicio.split("-").map(Number);
                      const dtInicio = new Date(y, (m || 1) - 1, d || 1);
                      if (!isNaN(dtInicio.getTime())) {
                        const dtFim = new Date(
                          dtInicio.getFullYear() + 2,
                          dtInicio.getMonth(),
                          dtInicio.getDate() - 1,
                        );
                        const yy = dtFim.getFullYear();
                        const mm = String(dtFim.getMonth() + 1).padStart(
                          2,
                          "0",
                        );
                        const dd = String(dtFim.getDate()).padStart(2, "0");
                        fimAuto = `${yy}-${mm}-${dd}`;
                      }
                    }
                    setFormData((prev) => ({
                      ...prev,
                      data_inicio_contrato: inicio,
                      data_fim_contrato: fimAuto,
                    }));
                  }}
                >
                  <option value="" disabled>
                    Selecione
                  </option>
                  {datasVigenciaFuturas.map((d) => (
                    <option key={d.id} value={d.valorObj.data}>
                      {new Date(
                        d.valorObj.data + "T00:00:00",
                      ).toLocaleDateString("pt-BR")}
                    </option>
                  ))}
                </select>
              </div>

              <div className="tca-col-md-4 tca-mb-3">
                <label className="all-label" htmlFor="data_fim_contrato">
                  Vigência Final:
                </label>
                <input
                  type="date"
                  className="tca-form-control"
                  name="data_fim_contrato"
                  id="data_fim_contrato"
                  value={formData.data_fim_contrato || ""}
                  onChange={(e) => {
                    const novaData = e.target.value;
                    if (novaData && formData.data_nascimento) {
                      const novaParts = novaData.split("-");
                      const nascParts = formData.data_nascimento
                        .substring(0, 10)
                        .split("-");
                      if (novaParts.length === 3 && nascParts.length === 3) {
                        const dtNova = new Date(
                          parseInt(novaParts[0], 10),
                          parseInt(novaParts[1], 10) - 1,
                          parseInt(novaParts[2], 10),
                        );
                        const limiteIdade = new Date(
                          parseInt(nascParts[0], 10) + 24,
                          parseInt(nascParts[1], 10) - 1,
                          parseInt(nascParts[2], 10),
                        );
                        limiteIdade.setDate(limiteIdade.getDate() - 1);
                        if (dtNova > limiteIdade) {
                          toastError(
                            "A vigência deve terminar antes de o aprendiz completar 24 anos.",
                          );
                          setFormData({ ...formData, data_fim_contrato: "" });
                          return;
                        }
                      }
                    }
                    setFormData({ ...formData, data_fim_contrato: novaData });
                  }}
                  readOnly={!permissao?.podeEditarTudo}
                  disabled={submittingRef.current}
                />
              </div>

              <div className="horario-pratica tca-col-md-4 tca-mb-3">
                <label className="all-label">
                  Horário da aprendizagem prática:
                </label>
                <div className="horario-box">
                  <input
                    type="text"
                    name="horario_inicio_horas"
                    maxLength={2}
                    value={formData.horario_inicio_horas || ""}
                    readOnly={horariosReadOnly}
                    disabled={horariosDisabled}
                    onChange={(e) => {
                      const { valor, bloqueado } = filtrarHorarioParcial(
                        "horario_inicio_horas",
                        formData.horario_inicio_horas,
                        e.target.value,
                      );
                      setFormData((prev) => ({
                        ...prev,
                        horario_inicio_horas: valor,
                      }));
                      if (bloqueado) {
                        setHorarioBloqueado((prev) => ({
                          ...prev,
                          horario_inicio_horas: true,
                        }));
                        toastWarning(
                          "Horário Invalido! Exemplo: 07:30–11:30 ou 13:30–17:30.",
                        );
                      }
                    }}
                    onFocus={() =>
                      setHorarioBloqueado((prev) => ({
                        ...prev,
                        horario_inicio_horas: false,
                      }))
                    }
                  />
                  {horarioBloqueado.horario_inicio_horas && (
                    <span
                      className="horario-bloqueado-icon"
                      title="Horário bloqueado"
                      aria-label="Horário bloqueado"
                    >
                      🔒
                    </span>
                  )}
                  <span>:</span>
                  <input
                    type="text"
                    name="horario_inicio_minutos"
                    maxLength={2}
                    value={formData.horario_inicio_minutos || ""}
                    readOnly={horariosReadOnly}
                    disabled={horariosDisabled}
                    onChange={(e) => {
                      const { valor, bloqueado } = filtrarHorarioParcial(
                        "horario_inicio_minutos",
                        formData.horario_inicio_minutos,
                        e.target.value,
                      );
                      setFormData((prev) => ({
                        ...prev,
                        horario_inicio_minutos: valor,
                      }));
                      if (bloqueado) {
                        setHorarioBloqueado((prev) => ({
                          ...prev,
                          horario_inicio_minutos: true,
                        }));
                        toastWarning(
                          "Horário bloqueado! Use apenas 07:30–11:30 ou 13:30–17:30.",
                        );
                      }
                    }}
                    onFocus={() =>
                      setHorarioBloqueado((prev) => ({
                        ...prev,
                        horario_inicio_minutos: false,
                      }))
                    }
                  />
                  {horarioBloqueado.horario_inicio_minutos && (
                    <span
                      className="horario-bloqueado-icon"
                      title="Horário bloqueado"
                      aria-label="Horário bloqueado"
                    >
                      🔒
                    </span>
                  )}
                  <span>às</span>
                  <input
                    type="text"
                    name="horario_fim_horas"
                    maxLength={2}
                    value={formData.horario_fim_horas || ""}
                    readOnly={horariosReadOnly}
                    disabled={horariosDisabled}
                    onChange={(e) => {
                      const { valor, bloqueado } = filtrarHorarioParcial(
                        "horario_fim_horas",
                        formData.horario_fim_horas,
                        e.target.value,
                      );
                      setFormData((prev) => ({
                        ...prev,
                        horario_fim_horas: valor,
                      }));
                      if (bloqueado) {
                        setHorarioBloqueado((prev) => ({
                          ...prev,
                          horario_fim_horas: true,
                        }));
                        toastWarning(
                          "Horário bloqueado! Use apenas 07:30–11:30 ou 13:30–17:30.",
                        );
                      }
                    }}
                    onFocus={() =>
                      setHorarioBloqueado((prev) => ({
                        ...prev,
                        horario_fim_horas: false,
                      }))
                    }
                  />
                  {horarioBloqueado.horario_fim_horas && (
                    <span
                      className="horario-bloqueado-icon"
                      title="Horário bloqueado"
                      aria-label="Horário bloqueado"
                    >
                      🔒
                    </span>
                  )}
                  <span>:</span>
                  <input
                    type="text"
                    name="horario_fim_minutos"
                    maxLength={2}
                    value={formData.horario_fim_minutos || ""}
                    readOnly={horariosReadOnly}
                    disabled={horariosDisabled}
                    onChange={(e) => {
                      const { valor, bloqueado } = filtrarHorarioParcial(
                        "horario_fim_minutos",
                        formData.horario_fim_minutos,
                        e.target.value,
                      );
                      setFormData((prev) => ({
                        ...prev,
                        horario_fim_minutos: valor,
                      }));
                      if (bloqueado) {
                        setHorarioBloqueado((prev) => ({
                          ...prev,
                          horario_fim_minutos: true,
                        }));
                        toastWarning(
                          "Horário bloqueado! Use apenas 07:30–11:30 ou 13:30–17:30.",
                        );
                      }
                    }}
                    onFocus={() =>
                      setHorarioBloqueado((prev) => ({
                        ...prev,
                        horario_fim_minutos: false,
                      }))
                    }
                  />
                  {horarioBloqueado.horario_fim_minutos && (
                    <span
                      className="horario-bloqueado-icon"
                      title="Horário bloqueado"
                      aria-label="Horário bloqueado"
                    >
                      🔒
                    </span>
                  )}
                </div>

                {horario.tipo === "fixo" && (
                  <div className="horario-card moderno">
                    <h4>
                      Horário Fixo{" "}
                      <small>(mesmo horário todos os dias selecionados)</small>
                    </h4>
                    <div className="horario-grid">
                      <div className="dias-semana">
                        <label>Dias da semana de atuação *</label>
                        {[
                          "Segunda",
                          "Terça",
                          "Quarta",
                          "Quinta",
                          "Sexta",
                          "Sábado",
                          "Domingo",
                        ].map((dia) => {
                          const key = dia
                            .toLowerCase()
                            .replace("ç", "c")
                            .replace("á", "a")
                            .replace("ã", "a");
                          return (
                            <label key={dia} className="checkbox-dia">
                              <input
                                type="checkbox"
                                checked={horario.diasSelecionados.includes(dia)}
                                onChange={(e) => {
                                  const novos = e.target.checked
                                    ? [...horario.diasSelecionados, dia]
                                    : horario.diasSelecionados.filter(
                                        (d) => d !== dia,
                                      );
                                  setHorario((prev) => ({
                                    ...prev,
                                    diasSelecionados: novos,
                                  }));
                                }}
                              />
                              {dia}
                            </label>
                          );
                        })}
                      </div>

                      <div className="horarios">
                        <div>
                          <label>Horário de entrada *</label>
                          <input
                            type="time"
                            value={horario.fixo.entrada}
                            onChange={(e) =>
                              setHorario((prev) => ({
                                ...prev,
                                fixo: { ...prev.fixo, entrada: e.target.value },
                              }))
                            }
                            required
                          />
                        </div>
                        <div>
                          <label>Horário de saída *</label>
                          <input
                            type="time"
                            value={horario.fixo.saida}
                            onChange={(e) =>
                              setHorario((prev) => ({
                                ...prev,
                                fixo: { ...prev.fixo, saida: e.target.value },
                              }))
                            }
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {horario.tipo === "alternado" && (
                  <div className="horario-card moderno">
                    <h4>
                      Horário Alternado{" "}
                      <small>(horários diferentes por dia)</small>
                    </h4>
                    <table className="horario-grade">
                      <thead>
                        <tr>
                          <th>Dia da semana</th>
                          <th>Entrada</th>
                          <th>Saída</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[
                          { key: "segunda", label: "Segunda" },
                          { key: "terca", label: "Terça" },
                          { key: "quarta", label: "Quarta" },
                          { key: "quinta", label: "Quinta" },
                          { key: "sexta", label: "Sexta" },
                          { key: "sabado", label: "Sábado" },
                          { key: "domingo", label: "Domingo" },
                        ].map((dia) => (
                          <tr key={dia.key}>
                            <td>{dia.label}</td>
                            <td>
                              <input
                                type="time"
                                value={horario.alternado[dia.key].entrada}
                                onChange={(e) =>
                                  setHorario((prev) => ({
                                    ...prev,
                                    alternado: {
                                      ...prev.alternado,
                                      [dia.key]: {
                                        ...prev.alternado[dia.key],
                                        entrada: e.target.value,
                                      },
                                    },
                                  }))
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="time"
                                value={horario.alternado[dia.key].saida}
                                onChange={(e) =>
                                  setHorario((prev) => ({
                                    ...prev,
                                    alternado: {
                                      ...prev.alternado,
                                      [dia.key]: {
                                        ...prev.alternado[dia.key],
                                        saida: e.target.value,
                                      },
                                    },
                                  }))
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {horario.tipo &&
                  (() => {
                    const { errors } = validarHorarios(horario);
                    if (errors.length === 0) return null;
                    return (
                      <div className="carga-horaria-info">
                        <ul className="horario-errors">
                          {errors.map((err, i) => (
                            <li key={i}>⚠️ {err}</li>
                          ))}
                        </ul>
                      </div>
                    );
                  })()}

                {erroHorarioAprendizagem && (
                  <div
                    className="erro-horario-aprendizagem"
                    style={{
                      color: "#000",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      marginTop: "5px",
                    }}
                  >
                    <AlertCircle size={16} />
                    <span>{erroHorarioAprendizagem}</span>
                  </div>
                )}
              </div>

              <div className="tca-col-md-6 tca-mb-3">
                <label className="all-label">
                  Horário Aprendizagem Teórica
                  {cidadeAtualEmpregador ? (
                    <span className="aprendizagem-municipio-tag">
                      {" "}
                      ({cidadeAtualEmpregador})
                    </span>
                  ) : null}
                  :
                </label>
                <select
                  className="tca-form-control"
                  name="horario_teorico_id"
                  value={formData.horario_teorico_id || ""}
                  disabled={horariosDisabled}
                  onChange={(e) => {
                    const id = e.target.value;
                    const horario = horariosTeoricos.find(
                      (h) => String(h.id) === String(id),
                    );
                    setFormData({
                      ...formData,
                      horario_teorico_id: id,
                      horario_teorica_inicio: horario?.horario_inicio || "",
                      horario_teorica_fim: horario?.horario_fim || "",
                    });
                  }}
                >
                  <option value="">Selecione</option>
                  {horariosTeoricosDisponiveis.map((h) => (
                    <option key={h.id} value={h.id}>
                      {formatHorarioTeoricoLabel(h)}
                    </option>
                  ))}
                </select>
                {horariosTeoricosDisponiveis.length === 0 && (
                  <small
                    style={{
                      display: "block",
                      marginTop: "4px",
                      color: "#b45309",
                    }}
                  >
                    Nenhum horário cadastrado para o município da empresa.
                  </small>
                )}
              </div>

              <div className="tca-col-md-6 tca-mb-3">
                <label>Curso</label>
                <select
                  className="tca-form-control"
                  name="curso"
                  disabled={!permissao.podeEditarEmpresa}
                  value={formData.curso || ""}
                  onChange={(e) => {
                    handleChange(e);
                    const limite = getLimiteHorasAprendizagem(
                      cursosFiltrados,
                      e.target.value,
                    );
                    if (limite) {
                      setFormData((prev) => ({
                        ...prev,
                        carga_horaria_diaria: `${limite} horas diárias`,
                      }));
                    } else {
                      setFormData((prev) => ({
                        ...prev,
                        carga_horaria_diaria: "",
                      }));
                    }
                  }}
                >
                  <option value="">Selecione</option>
                  {cursosFiltrados.map((c) => {
                    const valorUnico = `${c.valorObj.curso} — ${c.valorObj.carga_horaria} (${c.valorObj.modalidade})`;
                    return (
                      <option key={c.id} value={valorUnico}>
                        {valorUnico}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="tca-col-md-6 tca-mb-3">
                <label>Carga Horária Diária</label>
                <input
                  type="text"
                  className="tca-form-control"
                  name="carga_horaria_diaria"
                  readOnly={
                    !permissao?.podeEditarEmpresa &&
                    !permissao?.podeEditarTudo
                  }
                  disabled={
                    !permissao?.podeEditarEmpresa &&
                    !permissao?.podeEditarTudo
                  }
                  value={formData.carga_horaria_diaria || ""}
                />
              </div>

              <div className="tca-col-md-6 tca-mb-3">
                <label>Salário</label>
                <NumericFormat
                  className="tca-form-control"
                  name="salario"
                  value={formData.salario}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale={true}
                  prefix="R$ "
                  disabled={!permissao.podeEditarEmpresa}
                  onValueChange={(values) => {
                    setFormData((prev) => ({
                      ...prev,
                      salario: values.floatValue ?? 0,
                    }));
                  }}
                />
              </div>

              <br />
              <br />

              <h6
                className="tca-h6"
                style={{ textAlign: "center", width: "100%" }}
              >
                Resposavel pelas Avaliações
              </h6>
              <br />
              <br />

              <div className="tca-col-md-4 tca-mb-3">
                <label>Nome do responsável para receber avaliações</label>
                <input
                  className="tca-form-control"
                  name="nome_tutor"
                  value={formData.nome_tutor || ""}
                  onChange={handleChange}
                  disabled={!permissao.podeEditarEmpresa}
                  maxLength={70}
                />
              </div>

              <div className="tca-col-md-4 tca-mb-3">
                <label>Cargo do(a) Tutor(a)</label>
                <input
                  className="tca-form-control"
                  name="cargo_tutor"
                  value={formData.cargo_tutor || ""}
                  onChange={handleChange}
                  disabled={!permissao.podeEditarEmpresa}
                  maxLength={70}
                />
              </div>

              <div className="tca-col-md-4 tca-mb-3">
                <label>E-mail do responsável para receber avaliações</label>
                <input
                  type="email"
                  className="tca-form-control"
                  name="email_tutor"
                  value={formData.email_tutor || ""}
                  onChange={handleChange}
                  disabled={!permissao.podeEditarEmpresa}
                  maxLength={100}
                />
              </div>

              <br />
              <br />
              <h6
                className="tca-h6"
                style={{ textAlign: "center", width: "100%" }}
              >
                Endereço da Aprendizagem Teórica e Prática
              </h6>
              <br />
              <br />

              <div className="tca-col-md-6 tca-mb-3">
                <label>Endereço Completo da Aprendizagem Prática</label>
                <input
                  type="text"
                  className="tca-form-control"
                  name="endereco_aprendizagem_pratica"
                  value={formData.endereco_aprendizagem_pratica || ""}
                  onChange={handleChange}
                  disabled={!permissao.podeEditarEmpresa}
                  maxLength={200}
                />
              </div>

              <div className="tca-col-md-6 tca-mb-3">
                <label>Endereço da Aprendizagem Teórica</label>
                <input
                  type="text"
                  name="endereco_aprendizagem_teorica"
                  className="tca-form-control bg-white-important"
                  readOnly={
                    ![2, 3, 4].includes(Number(user?.acesso_autorizacao))
                  }
                  onChange={handleChange}
                  value={formData.endereco_aprendizagem_teorica || ""}
                />
              </div>

              <div className="tca-col-md-12 tca-mb-3">
                <label>Atividades do aprendiz na empresa:</label>
                <select
                  className="tca-form-control"
                  name="atividades_aprendiz"
                  disabled={
                    !permissao?.podeEditarEmpresa &&
                    !permissao?.podeEditarTudo
                  }
                  value={formData.atividades_aprendiz || ""}
                  onChange={handleChange}
                  required
                >
                  <option value="">
                    {formData.curso
                      ? "Selecione uma atividade"
                      : "Selecione um curso primeiro"}
                  </option>
                  {atividadesFiltradas.map((a) => (
                    <option key={a.id} value={a.atividade}>
                      {a.atividade}
                    </option>
                  ))}
                </select>
              </div>

              <div className="tca-col-md-12 tca-mb-3">
                <label>Horário Aprendizagem Teórica:</label>
                <select
                  className="tca-form-control"
                  name="horario_teorico_id"
                  value={formData.horario_teorico_id || ""}
                  disabled={horariosDisabled}
                  onChange={(e) => {
                    const id = e.target.value;
                    const horario = horariosTeoricos.find(
                      (h) => String(h.id) === String(id),
                    );
                    setFormData({
                      ...formData,
                      horario_teorico_id: id,
                      horario_teorica_inicio: horario?.horario_inicio || "",
                      horario_teorica_fim: horario?.horario_fim || "",
                    });
                  }}
                >
                  <option value="">Selecione</option>
                  {horariosTeoricosDisponiveis.map((h) => (
                    <option key={h.id} value={h.id}>
                      {formatHorarioTeoricoLabel(h)}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* O campo "Unidade *" redundante foi removido daqui para evitar duplicação. */}
        </section>

        <section className="tca-card tca-mb-4" id="tca-section-dados-aprendiz">
          <div className="tca-card-header" style={{ position: "relative" }}>
            Dados do(a) Aprendiz
            {idadeCalculada !== null && (
              <span
                style={{
                  position: "absolute",
                  right: "16px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  fontSize: "0.80rem",
                  padding: "4px 10px",
                  borderRadius: "12px",
                  backgroundColor: idadeCalculada >= 18 ? "#dcfce7" : "#fef08a",
                  color: idadeCalculada >= 18 ? "#166534" : "#854d0e",
                  fontWeight: "700",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.15)",
                }}
              >
                {idadeCalculada >= 18 ? "Maior de Idade" : "Menor de Idade"}
              </span>
            )}
          </div>
          <div className="tca-card-body">
            {estudanteNaoEncontrado && (
              <div
                style={{
                  backgroundColor: "#fef2f2",
                  border: "1px solid #f87171",
                  borderLeft: "4px solid #ef4444",
                  boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                  color: "#991b1b",
                  padding: "1rem 1.25rem",
                  borderRadius: "8px",
                  marginBottom: "1.5rem",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "12px",
                  lineHeight: "1.5",
                }}
              >
                <AlertCircle
                  size={22}
                  style={{ flexShrink: 0, marginTop: "2px", color: "#ef4444" }}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <span style={{ fontWeight: "700", fontSize: "0.95rem" }}>
                    Aprendiz não encontrado
                  </span>
                  <span style={{ fontSize: "0.9rem", color: "#7f1d1d" }}>
                    O contrato não poderá ser validado enquanto o cadastro do(a)
                    aprendiz não for realizado no sistema.
                  </span>
                </div>
              </div>
            )}

            <div className="tca-row">
              <div className="tca-col-md-6 tca-mb-3">
                <label>CPF do Aprendiz:</label>
                <input
                  type="text"
                  className="tca-form-control"
                  name="cpf"
                  maxLength={14}
                  onChange={handleChange}
                  value={formData.cpf || ""}
                />
              </div>

              <div className="tca-col-md-6 tca-mb-3">
                <label>Nome Completo:</label>
                <input
                  type="text"
                  className="tca-form-control"
                  name="nome_completo"
                  maxLength={100}
                  onChange={handleChange}
                  value={formData.nome_completo || ""}
                />
              </div>

              <div className="tca-col-md-6 tca-mb-3">
                <label>Telefone/Informações adicionais de contato:</label>
                <InputMask
                  mask="(99)99999-9999"
                  maskChar=" "
                  type="text"
                  className="tca-form-control"
                  name="telefone_01"
                  autoComplete="off"
                  onChange={handleChange}
                  value={formData.telefone_01 || ""}
                />
              </div>

              <div className="tca-col-md-6 tca-mb-3">
                <label>E-mail:</label>
                <input
                  type="email"
                  className="tca-form-control"
                  name="email_pessoal"
                  maxLength={100}
                  onChange={handleChange}
                  value={formData.email_pessoal || ""}
                />
              </div>
            </div>

            {estudanteNaoEncontrado && (
              <div
                style={{
                  backgroundColor: "#ffffff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  padding: "1.25rem 1.5rem",
                  marginBottom: "1.5rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "24px",
                  boxShadow:
                    "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "6px",
                    flex: "1 1 300px",
                  }}
                >
                  <span
                    style={{
                      fontWeight: "700",
                      color: "#1e293b",
                      fontSize: "0.95rem",
                    }}
                  >
                    Precisa de ajuda com o cadastro?
                  </span>
                  <span
                    style={{
                      fontSize: "0.85rem",
                      color: "#475569",
                      lineHeight: "1.5",
                    }}
                  >
                    Em caso de dúvida entre em contato com nossa empresa
                    através.
                    <br />
                    Telefone/Whatsapp: <strong>(31) 3428100</strong> ; E-mail:{" "}
                    <a
                      href="mailto:atendimento@cieemg.org.br"
                      style={{
                        color: "#185fa5",
                        textDecoration: "none",
                        fontWeight: "600",
                      }}
                    >
                      atendimento@cieemg.org.br
                    </a>
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <button
                    type="button"
                    onClick={() => setCienteCadastro(true)}
                    disabled={cienteCadastro}
                    style={{
                      backgroundColor: cienteCadastro ? "#dcfce7" : "#f1f5f9",
                      color: cienteCadastro ? "#166534" : "#475569",
                      border: cienteCadastro
                        ? "1px solid #bbf7d0"
                        : "1px solid #cbd5e1",
                      borderRadius: "8px",
                      padding: "0.75rem 1.25rem",
                      fontWeight: "600",
                      fontSize: "0.95rem",
                      cursor: cienteCadastro ? "default" : "pointer",
                      transition: "all 0.2s ease",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    {cienteCadastro ? (
                      <>
                        <Check size={18} />
                        Ciente
                      </>
                    ) : (
                      "Estou Ciente da Situação"
                    )}
                  </button>

                  <button
                    type="button"
                    disabled={!cienteCadastro}
                    onClick={() =>
                      window.open(
                        "https://appcadastro.cieemg.org.br/",
                        "_blank",
                      )
                    }
                    style={{
                      backgroundColor: cienteCadastro ? "#185fa5" : "#94a3b8",
                      color: "#ffffff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "0.75rem 1.75rem",
                      fontWeight: "600",
                      fontSize: "0.95rem",
                      cursor: cienteCadastro ? "pointer" : "not-allowed",
                      boxShadow: cienteCadastro
                        ? "0 4px 6px rgba(24, 95, 165, 0.2)"
                        : "none",
                      transition: "all 0.2s ease",
                      whiteSpace: "nowrap",
                      flexShrink: 0,
                      opacity: cienteCadastro ? 1 : 0.7,
                    }}
                    onMouseOver={(e) => {
                      if (!cienteCadastro) return;
                      e.target.style.backgroundColor = "#10477e";
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow =
                        "0 6px 8px rgba(24, 95, 165, 0.3)";
                    }}
                    onMouseOut={(e) => {
                      if (!cienteCadastro) return;
                      e.target.style.backgroundColor = "#185fa5";
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow =
                        "0 4px 6px rgba(24, 95, 165, 0.2)";
                    }}
                  >
                    Fazer Cadastro do Aprendiz
                  </button>
                </div>
              </div>
            )}

            <div
              style={{
                backgroundColor: "#1e528a",
                color: "#fff",
                padding: "1rem",
                borderRadius: "8px",
                marginTop: "1rem",
              }}
            >
              <span style={{ fontWeight: "bold" }}>Observações:</span>
              <br />
              1) É de suma importância a inscrição do jovem em nosso site com
              antecedência.
              <br />
              2) Observar se o horário escolar é contrário ao horário de
              aprendizagem.
              <br />
              3) O início da aprendizagem só pode ocorrer após assinatura do
              contrato.
            </div>
          </div>
        </section>

        {idadeCalculada !== null && idadeCalculada < 18 && (
          <section className="tca-card tca-mb-4 responsavel-aprendiz-section">
            <div className="tca-card-header responsavel-aprendiz-header">
              <span className="responsavel-aprendiz-icon" aria-hidden="true">
                ⚖️
              </span>
              Responsável Legal do Aprendiz
              <small
                style={{
                  marginLeft: "0.75rem",
                  fontWeight: 500,
                  fontSize: "0.85rem",
                  opacity: 0.85,
                }}
              >
                (Aprendiz menor de idade — {idadeCalculada} anos)
              </small>
            </div>
            <div className="tca-card-body">
              <div className="tca-row">
                <div className="tca-col-md-6 tca-mb-3">
                  <label>Nome</label>
                  <input
                    className="tca-form-control"
                    name="nome_aprendiz_menor_idade"
                    value={formData.nome_aprendiz_menor_idade || ""}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="tca-col-md-3 tca-mb-3">
                  <label>Telefone</label>
                  <InputMask
                    mask="(99)99999-9999"
                    maskChar=" "
                    className="tca-form-control"
                    name="telefone_aprendiz_menor_idade"
                    value={formData.telefone_aprendiz_menor_idade || ""}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="tca-col-md-3 tca-mb-3">
                  <label>CPF</label>
                  <InputMask
                    mask="999.999.999-99"
                    maskChar=" "
                    className="tca-form-control"
                    name="cpf_aprendiz_menor_idade"
                    value={formData.cpf_aprendiz_menor_idade || ""}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="tca-col-md-6 tca-mb-3">
                  <label>E-mail</label>
                  <input
                    type="email"
                    className="tca-form-control"
                    name="email_aprendiz_menor_idade"
                    value={formData.email_aprendiz_menor_idade || ""}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="tca-col-md-4 tca-mb-3">
                  <label>RG</label>
                  <input
                    type="text"
                    className="tca-form-control"
                    name="rg_aprendiz_menor_idade"
                    value={formData.rg_aprendiz_menor_idade || ""}
                    onChange={handleChange}
                    maxLength={20}
                    required
                  />
                </div>
                <div className="tca-col-md-4 tca-mb-3">
                  <label>Órgão Emissor</label>
                  <input
                    type="text"
                    className="tca-form-control"
                    name="orgao_emissor_aprendiz_menor_idade"
                    value={formData.orgao_emissor_aprendiz_menor_idade || ""}
                    onChange={handleChange}
                    maxLength={20}
                    required
                  />
                </div>
                <div className="tca-col-md-4 tca-mb-3">
                  <label>Profissão</label>
                  <input
                    type="text"
                    className="tca-form-control"
                    name="profissao_aprendiz_menor_idade"
                    value={formData.profissao_aprendiz_menor_idade || ""}
                    onChange={handleChange}
                    maxLength={100}
                    required
                  />
                </div>
              </div>
            </div>
          </section>
        )}

        <section className="tca-card tca-mb-4" id="tca-section-aprendiz">
          <div className="tca-card-header">
            2. Identificação Pessoal do Aprendiz
          </div>
          <div className="tca-card-body">
            <div className="tca-row">
              <div className="tca-col-md-4 tca-mb-3">
                <label>Nome Social</label>
                <input
                  className="tca-form-control"
                  name="nome_social"
                  value={formData.nome_social}
                  onChange={handleChange}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>Estado Natal</label>
                <input
                  className="tca-form-control"
                  name="estado_natal"
                  value={formData.estado_natal}
                  onChange={handleChange}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>Naturalidade</label>
                <input
                  className="tca-form-control"
                  name="naturalidade"
                  value={formData.naturalidade}
                  onChange={handleChange}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>Nacionalidade</label>
                <input
                  className="tca-form-control"
                  name="nacionalidade"
                  value={formData.nacionalidade}
                  onChange={handleChange}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>Data de Nascimento</label>
                <input
                  type="date"
                  className="tca-form-control"
                  name="data_nascimento"
                  value={formData.data_nascimento}
                  onChange={handleChange}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>Sexo</label>
                <select
                  className="tca-form-control"
                  name="sexo"
                  value={formData.sexo}
                  onChange={handleChange}
                  required
                >
                  <option value="">Selecione</option>
                  <option value="M">Masculino</option>
                  <option value="F">Feminino</option>
                </select>
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>Tipo Sanguíneo</label>
                <select
                  className="tca-form-control"
                  name="tipo_sanguineo"
                  value={formData.tipo_sanguineo}
                  onChange={handleChange}
                >
                  <option value="">Selecione</option>
                  <option>A</option>
                  <option>B</option>
                  <option>AB</option>
                  <option>O</option>
                </select>
              </div>

              <div className="tca-col-md-4 tca-mb-3">
                <label>Cor</label>
                <input
                  className="tca-form-control"
                  name="cor"
                  value={formData.cor}
                  onChange={handleChange}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>Fumante?</label>
                <select
                  className="tca-form-control"
                  name="fumante"
                  value={formData.fumante}
                  onChange={handleChange}
                >
                  <option value={false}>Não</option>
                  <option value={true}>Sim</option>
                </select>
              </div>

              <div className="tca-col-md-4 tca-mb-3">
                <label>Estado Civil</label>
                <select
                  className="tca-form-control"
                  name="estado_civil"
                  value={formData.estado_civil}
                  onChange={handleChange}
                >
                  <option value="">Selecione</option>
                  <option>Solteiro(a)</option>
                  <option>Casado(a)</option>
                  <option>Divorciado(a)</option>
                  <option>Viúvo(a)</option>
                  <option>União Estável</option>
                </select>
              </div>
            </div>
          </div>
        </section>

        <section className="tca-card tca-mb-4" id="tca-section-mae">
          <div className="tca-card-header">3. Dados da Mãe</div>
          <div className="tca-card-body">
            <div className="tca-row">
              <div className="tca-col-md-8 tca-mb-3">
                <label>Nome</label>
                <input
                  className="tca-form-control"
                  name="nome_mae"
                  value={formData.nome_mae}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("nome_mae")}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>CPF</label>
                <InputMask
                  mask="999.999.999-99"
                  maskChar=" "
                  className="tca-form-control"
                  name="cpf_mae"
                  value={formData.cpf_mae}
                  onChange={handleChange}
                  disabled={isCampoBloqueadoParaEmpresa("cpf_mae")}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>Telefone</label>
                <InputMask
                  mask="(99)99999-9999"
                  maskChar=" "
                  className="tca-form-control"
                  name="telefone_mae"
                  value={formData.telefone_mae}
                  onChange={handleChange}
                  disabled={isCampoBloqueadoParaEmpresa("telefone_mae")}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>E-mail</label>
                <input
                  type="email"
                  className="tca-form-control"
                  name="email_mae"
                  value={formData.email_mae}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("email_mae")}
                />
              </div>
              <div className="tca-col-md-4 tcfa-mb-3">
                <label>Data de Nascimento</label>
                <input
                  type="date"
                  className="tca-form-control"
                  name="data_nascimento_mae"
                  value={formData.data_nascimento_mae}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("data_nascimento_mae")}
                />
              </div>
              <div className="tca-col-md-6 tca-mb-3">
                <label>Naturalidade</label>
                <input
                  className="tca-form-control"
                  name="naturalidade_mae"
                  value={formData.naturalidade_mae}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("naturalidade_mae")}
                />
              </div>
              <div className="tca-col-md-6 tca-mb-3">
                <label>Estado Civil</label>
                <input
                  className="tca-form-control"
                  name="estado_civil_mae"
                  value={formData.estado_civil_mae}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("estado_civil_mae")}
                />
              </div>
            </div>
          </div>
        </section>

        <section
          className="tca-card tca-mb-4"
          id="tca-section-endereco-aprendiz"
        >
          <div className="tca-card-header">
            4. Endereço Principal do Aprendiz
          </div>
          <div className="tca-card-body">
            <div className="tca-row">
              <div className="tca-col-md-8 tca-mb-3">
                <label>Logradouro</label>
                <input
                  className="tca-form-control"
                  name="logradouro"
                  value={formData.logradouro}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("logradouro")}
                />
              </div>
              <div className="tca-col-md-2 tca-mb-3">
                <label>Nº</label>
                <input
                  className="tca-form-control"
                  name="numero_endereco"
                  value={formData.numero_endereco}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("numero_endereco")}
                />
              </div>
              <div className="tca-col-md-2 tca-mb-3">
                <label>Compl.</label>
                <input
                  className="tca-form-control"
                  name="complemento"
                  value={formData.complemento}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("complemento")}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>Bairro</label>
                <input
                  className="tca-form-control"
                  name="bairro"
                  value={formData.bairro}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("bairro")}
                />
              </div>
              <div className="tca-col-md-3 tca-mb-3">
                <label>CEP</label>
                <InputMask
                  mask="99999-999"
                  maskChar=" "
                  className="tca-form-control"
                  name="cep"
                  value={formData.cep}
                  onChange={handleChange}
                  onBlur={handleCepAprendizBlur}
                  readOnly={isCampoBloqueadoParaEmpresa("cep")}
                />
              </div>
              <div className="tca-col-md-3 tca-mb-3">
                <label>Cidade</label>
                <input
                  className="tca-form-control"
                  name="cidade"
                  value={formData.cidade}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("cidade")}
                />
              </div>
              <div className="tca-col-md-2 tca-mb-3">
                <label>UF</label>
                <select
                  className="tca-form-control"
                  name="estado_endereco"
                  value={formData.estado_endereco}
                  onChange={handleChange}
                  disabled={isCampoBloqueadoParaEmpresa("estado_endereco")}
                >
                  <option value="">UF</option>
                  <option value="AC">AC</option>
                  <option value="AL">AL</option>
                  <option value="AP">AP</option>
                  <option value="AM">AM</option>
                  <option value="BA">BA</option>
                  <option value="CE">CE</option>
                  <option value="DF">DF</option>
                  <option value="ES">ES</option>
                  <option value="GO">GO</option>
                  <option value="MA">MA</option>
                  <option value="MT">MT</option>
                  <option value="MS">MS</option>
                  <option value="MG">MG</option>
                  <option value="PA">PA</option>
                  <option value="PB">PB</option>
                  <option value="PR">PR</option>
                  <option value="PE">PE</option>
                  <option value="PI">PI</option>
                  <option value="RJ">RJ</option>
                  <option value="RN">RN</option>
                  <option value="RS">RS</option>
                  <option value="RO">RO</option>
                  <option value="RR">RR</option>
                  <option value="SC">SC</option>
                  <option value="SP">SP</option>
                  <option value="SE">SE</option>
                  <option value="TO">TO</option>
                </select>
              </div>

              <div className="tca-col-md-3 tca-mb-3">
                <label>Telefone 02</label>
                <InputMask
                  mask="(99)99999-9999"
                  maskChar=" "
                  className="tca-form-control"
                  name="telefone_02"
                  value={formData.telefone_02}
                  onChange={handleChange}
                  disabled={isCampoBloqueadoParaEmpresa("telefone_02")}
                />
              </div>
            </div>
          </div>
        </section>

        <section className="tca-card tca-mb-4">
          <div className="tca-card-header">5. Escolaridade</div>
          <div className="tca-card-body">
            <div className="tca-row">
              <div className="tca-col-md-4 tca-mb-3">
                <label>Grau de Instrução</label>
                <input
                  className="tca-form-control"
                  name="grau_instrucao"
                  value={formData.grau_instrucao}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("grau_instrucao")}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>Curso</label>
                <input
                  className="tca-form-control"
                  name="curso_escolaridade"
                  value={formData.curso_escolaridade}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("curso_escolaridade")}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>Instituição</label>
                <input
                  className="tca-form-control"
                  name="instituicao_ensino"
                  value={formData.instituicao_ensino}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("instituicao_ensino")}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>Conclusão (ou previsão)</label>
                <input
                  className="tca-form-control"
                  name="conclusao"
                  value={formData.conclusao}
                  onChange={handleChange}
                  placeholder="Ex: 12/2026"
                  readOnly={isCampoBloqueadoParaEmpresa("conclusao")}
                />
              </div>
            </div>
          </div>
        </section>

        <section className="tca-card tca-mb-4">
          <div className="tca-card-header">6. Documentos</div>
          <div className="tca-card-body">
            <div className="tca-row">
              <div className="tca-col-md-4 tca-mb-3">
                <label>PIS</label>
                <InputMask
                  mask="999.99999.99-9"
                  maskChar=" "
                  className="tca-form-control"
                  name="pis"
                  value={formData.pis}
                  onChange={handleChange}
                  disabled={isCampoBloqueadoParaEmpresa("pis")}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>RG</label>
                <InputMask
                  mask="99.999.999-9"
                  maskChar=" "
                  className="tca-form-control"
                  name="rg"
                  value={formData.rg}
                  onChange={handleChange}
                  disabled={isCampoBloqueadoParaEmpresa("rg")}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>Data Emissão RG</label>
                <input
                  type="date"
                  className="tca-form-control"
                  name="data_emissao_rg"
                  value={formData.data_emissao_rg}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("data_emissao_rg")}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>Órgão Emissor RG</label>
                <input
                  className="tca-form-control"
                  name="orgao_emissor_rg"
                  value={formData.orgao_emissor_rg}
                  onChange={handleChange}
                  placeholder="SSP/MG"
                  readOnly={isCampoBloqueadoParaEmpresa("orgao_emissor_rg")}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>Estado RG</label>
                <input
                  className="tca-form-control"
                  name="estado_rg"
                  value={formData.estado_rg}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("estado_rg")}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>Título de Eleitor</label>
                <input
                  className="tca-form-control"
                  name="titulo_eleitor"
                  value={formData.titulo_eleitor}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("titulo_eleitor")}
                />
              </div>
              <div className="tca-col-md-2 tca-mb-3">
                <label>Zona</label>
                <input
                  className="tca-form-control"
                  name="zona"
                  value={formData.zona}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("zona")}
                />
              </div>
              <div className="tca-col-md-2 tca-mb-3">
                <label>Seção</label>
                <input
                  className="tca-form-control"
                  name="secao"
                  value={formData.secao}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("secao")}
                />
              </div>
              <div className="tca-col-md-4 tca-mb-3">
                <label>Data Emissão Título</label>
                <input
                  type="date"
                  className="tca-form-control"
                  name="data_emissao_titulo"
                  value={formData.data_emissao_titulo}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("data_emissao_titulo")}
                />
              </div>
            </div>
          </div>
        </section>

        {formData.sexo === "M" &&
          idadeCalculada !== null &&
          idadeCalculada > 18 && (
            <section className="tca-card tca-mb-4">
              <div className="tca-card-header">
                7. Situação Militar{" "}
                <small className="tca-text-muted">(homens &gt; 18 anos)</small>
              </div>
              <div className="tca-card-body">
                <div className="tca-row">
                  <div className="tca-col-md-6 tca-mb-3">
                    <label>Nº Certificado de Reservista</label>
                    <input
                      className="tca-form-control"
                      name="numero_certificado_reservista"
                      value={formData.numero_certificado_reservista}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="tca-col-md-3 tca-mb-3">
                    <label>Data Emissão</label>
                    <input
                      type="date"
                      className="tca-form-control"
                      name="data_emissao_certificado"
                      value={formData.data_emissao_certificado}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="tca-col-md-3 tca-mb-3">
                    <label>Órgão Expedição</label>
                    <input
                      className="tca-form-control"
                      name="orgao_expedicao"
                      value={formData.orgao_expedicao}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="tca-col-md-12 tca-mb-3">
                    <label>Situação Militar</label>
                    <input
                      className="tca-form-control"
                      name="situacao_militar"
                      value={formData.situacao_militar}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </section>
          )}

        <section className="tca-card tca-mb-4" id="tca-section-bancario">
          <div className="tca-card-header">
            8. Conta Bancária (Bradesco 237)
          </div>
          <div className="tca-card-body">
            <div className="tca-row">
              <div className="tca-col-md-4 tca-mb-3">
                <label>Banco</label>
                <input
                  className="tca-form-control"
                  name="banco_pagamento"
                  value={formData.banco_pagamento}
                  onChange={handleChange}
                  readOnly={isCampoBloqueadoParaEmpresa("banco_pagamento")}
                />
              </div>
              <div className="tca-col-md-3 tca-mb-3">
                <label>Agência</label>{" "}
                <input
                  className="tca-form-control"
                  name="agencia"
                  value={formData.agencia}
                  onChange={handleChange}
                  maxLength={6}
                  inputMode="numeric"
                  readOnly={isCampoBloqueadoParaEmpresa("agencia")}
                />
              </div>
              <div className="tca-col-md-1 tca-mb-3">
                <label>DIV</label>{" "}
                <input
                  className="tca-form-control"
                  name="div1"
                  value={formData.div1}
                  onChange={handleChange}
                  maxLength={1}
                  inputMode="numeric"
                  readOnly={isCampoBloqueadoParaEmpresa("div1")}
                />
              </div>
              <div className="tca-col-md-3 tca-mb-3">
                <label>Conta</label>{" "}
                <input
                  className="tca-form-control"
                  name="conta"
                  value={formData.conta}
                  onChange={handleChange}
                  maxLength={12}
                  inputMode="numeric"
                  readOnly={isCampoBloqueadoParaEmpresa("conta")}
                />
              </div>
              <div className="tca-col-md-1 tca-mb-3">
                <label>DIV</label>{" "}
                <input
                  className="tca-form-control"
                  name="div2"
                  value={formData.div2}
                  onChange={handleChange}
                  maxLength={1}
                  inputMode="numeric"
                  readOnly={isCampoBloqueadoParaEmpresa("div2")}
                />
              </div>
            </div>
          </div>
        </section>

        <section className="tca-card tca-mb-4">
          <div className="tca-card-header">9. Ambiente de Trabalho</div>
          <div className="tca-card-body">
            <div className="tca-row">
              <div className="tca-col-md-4 tca-mb-3">
                <label>Trabalhou em ambiente insalubre?</label>
                <select
                  className="tca-form-control"
                  name="trabalhou_ambiente_insalubre"
                  value={String(formData.trabalhou_ambiente_insalubre)}
                  disabled={isCampoBloqueadoParaEmpresa(
                    "trabalhou_ambiente_insalubre",
                  )}
                  onChange={(e) => {
                    if (
                      isCampoBloqueadoParaEmpresa(
                        "trabalhou_ambiente_insalubre",
                      )
                    ) {
                      toastWarning(
                        "Este campo é de responsabilidade do estudante.",
                      );
                      return;
                    }
                    const novoValor = e.target.value === "true";
                    setFormData((prev) => {
                      const novoState = {
                        ...prev,
                        trabalhou_ambiente_insalubre: novoValor,
                      };
                      if (!novoValor) {
                        novoState.risco_exposto = "";
                      }
                      return novoState;
                    });
                  }}
                >
                  <option value="false">Não</option>
                  <option value="true">Sim</option>
                </select>
              </div>
              {formData.trabalhou_ambiente_insalubre === true && (
                <div className="tca-col-md-8 tca-mb-3">
                  <label>A qual risco esteve exposto?</label>
                  <textarea
                    className="tca-form-control"
                    rows="2"
                    name="risco_exposto"
                    value={formData.risco_exposto}
                    readOnly={isCampoBloqueadoParaEmpresa("risco_exposto")}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        risco_exposto: e.target.value,
                      }))
                    }
                  ></textarea>
                </div>
              )}
            </div>
          </div>
        </section>

        <section className="tca-card tca-mb-4" id="tca-section-vt">
          <div className="tca-card-header">10. Vale-Transporte</div>
          <div className="tca-card-body">
            <div className="tca-card-orientacao">
              <div className="icone-info">i</div>
              <div className="texto-orietacao">
                <h5 className="tca-texto">
                  Orientações sobre o Vale-Transporte
                </h5>

                <div className="tca-paragrafos">
                  <p className="tca-p1">
                    O vale-transporte constitui um benefício que o empregador,
                    pessoa física ou jurídica, antecipará ao empregado para
                    utilização efetiva em despesas de deslocamento
                    residência-trabalho e vice-versa, através do sistema de
                    transporte coletivo público, urbano ou intermunicipal e ou
                    interestadual com características semelhantes ao urbano.
                  </p>
                  <p className="tca-p2">
                    Será custeado na parcela equivalente a 6% (seis por cento)
                    do seu salário base ou vencimento, excluindo quaisquer
                    vantagens ou adicionais.
                  </p>

                  <p className="tca-p3">
                    Para exercício do direito de receber o Vale Transporte o
                    empregado informará ao empregador, por escrito:
                  </p>

                  <div className="tca-list">
                    <ul className="tca-ul">
                      <li className="tca-li">Seu endereço residencial;</li>
                      <li className="tca-li">
                        Os serviços e meios de transporte mais adequados no seu
                        deslocamento residência-trabalho e vice-versa.
                      </li>
                    </ul>
                  </div>

                  <p className="tca-p4">
                    Parágrafo 1º - A informação de que trata este artigo será
                    atualizada anualmente ou sempre que ocorrer alterações das
                    circunstâncias mencionadas nos itens I e II, sob pena de
                    suspensão do benefício até o cumprimento dessa exigência
                  </p>

                  <p className="tca-p5">
                    Parágrafo 2º - O beneficiário firmará compromissos de
                    utilizar o vale-transporte exclusivamente para seu efetivo
                    deslocamento residência-trabalho e vice-versa.
                  </p>

                  <p className="tca-p6">
                    Parágrafo 3º - A declaração falsa ou o uso indevido do
                    vale-transporte constituem falta grave.
                  </p>

                  <p className="tca-p7">
                    ⚠️ PODERÁ O EMPREGADOR SUSPENDER O FORNECIMENTO DO
                    VALE-TRANSPORTE CASO O FUNCIONÁRIO UTILIZE DE MEIO PRÓPRIO
                    PARA SEU EFETIVO DESLOCAMENTO.
                  </p>
                </div>
              </div>
            </div>

            {/* ENDEREÇO RESIDENCIAL (bloco novo com CEP/ViaCEP) */}
            <div
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.05)",
                padding: "1.5rem",
                borderRadius: "8px",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                marginTop: "1.5rem",
                marginBottom: "1.5rem",
              }}
            >
              <h5
                style={{
                  color: "#3b82f6",
                  fontWeight: "700",
                  marginBottom: "1.2rem",
                  fontSize: "1.1rem",
                }}
              >
                I) Endereço residencial
              </h5>

              <div className="tca-row">
                <div className="tca-col-md-3 tca-mb-3">
                  <label>CEP</label>
                  <input
                    type="text"
                    className="tca-form-control"
                    name="endereco_vt_cep"
                    value={formData.endereco_vt_cep}
                    onChange={handleChange}
                    onBlur={handleCepVTBlur}
                    readOnly={isCampoBloqueadoParaEmpresa("endereco_vt_cep")}
                    placeholder="00000-000"
                  />
                </div>
                <div className="tca-col-md-5 tca-mb-3">
                  <label>Logradouro</label>
                  <input
                    type="text"
                    className="tca-form-control"
                    name="endereco_vt_logradouro"
                    value={formData.endereco_vt_logradouro}
                    onChange={handleChange}
                    readOnly={isCampoBloqueadoParaEmpresa(
                      "endereco_vt_logradouro",
                    )}
                    placeholder="Rua / Avenida"
                  />
                </div>
                <div className="tca-col-md-2 tca-mb-3">
                  <label>Nº</label>
                  <input
                    type="text"
                    className="tca-form-control"
                    name="endereco_vt_numero"
                    value={formData.endereco_vt_numero}
                    onChange={handleChange}
                    readOnly={isCampoBloqueadoParaEmpresa("endereco_vt_numero")}
                    placeholder="Número"
                  />
                </div>
                <div className="tca-col-md-2 tca-mb-3">
                  <label>Complemento</label>
                  <input
                    type="text"
                    className="tca-form-control"
                    name="endereco_vt_complemento"
                    value={formData.endereco_vt_complemento}
                    onChange={handleChange}
                    readOnly={isCampoBloqueadoParaEmpresa(
                      "endereco_vt_complemento",
                    )}
                    placeholder="Complemento"
                  />
                </div>
              </div>

              <div className="tca-row">
                <div className="tca-col-md-4 tca-mb-3">
                  <label>Bairro</label>
                  <input
                    type="text"
                    className="tca-form-control"
                    name="endereco_vt_bairro"
                    value={formData.endereco_vt_bairro}
                    onChange={handleChange}
                    readOnly={isCampoBloqueadoParaEmpresa("endereco_vt_bairro")}
                    placeholder="Bairro"
                  />
                </div>

                <div className="tca-col-md-3 tca-mb-3">
                  <label>Cidade</label>
                  <input
                    type="text"
                    className="tca-form-control"
                    name="endereco_vt_cidade"
                    value={formData.endereco_vt_cidade}
                    onChange={handleChange}
                    readOnly={isCampoBloqueadoParaEmpresa("endereco_vt_cidade")}
                    placeholder="Cidade"
                  />
                </div>
                <div className="tca-col-md-2 tca-mb-3">
                  <label>UF</label>
                  <select
                    className="tca-form-control"
                    name="endereco_vt_uf"
                    value={formData.endereco_vt_uf}
                    onChange={handleChange}
                    disabled={isCampoBloqueadoParaEmpresa("endereco_vt_uf")}
                  >
                    <option value="">UF</option>
                    <option value="AC">AC</option>
                    <option value="AL">AL</option>
                    <option value="AP">AP</option>
                    <option value="AM">AM</option>
                    <option value="BA">BA</option>
                    <option value="CE">CE</option>
                    <option value="DF">DF</option>
                    <option value="ES">ES</option>
                    <option value="GO">GO</option>
                    <option value="MA">MA</option>
                    <option value="MT">MT</option>
                    <option value="MS">MS</option>
                    <option value="MG">MG</option>
                    <option value="PA">PA</option>
                    <option value="PB">PB</option>
                    <option value="PR">PR</option>
                    <option value="PE">PE</option>
                    <option value="PI">PI</option>
                    <option value="RJ">RJ</option>
                    <option value="RN">RN</option>
                    <option value="RS">RS</option>
                    <option value="RO">RO</option>
                    <option value="RR">RR</option>
                    <option value="SC">SC</option>
                    <option value="SP">SP</option>
                    <option value="SE">SE</option>
                    <option value="TO">TO</option>
                  </select>
                </div>
              </div>
            </div>

            {/* CAMPO: DESEJA ADQUIRIR VALE-TRANSPORTE? */}
            <div
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.05)",
                padding: "1.5rem",
                borderRadius: "8px",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                marginTop: "1rem",
              }}
            >
              <label
                style={{
                  color: "#ffffff",
                  fontWeight: "700",
                  fontSize: "1.1rem",
                  marginBottom: "1rem",
                  display: "block",
                }}
              >
                Deseja adquirir Vale-Transporte?
              </label>

              <div
                style={{ display: "flex", gap: "2rem", marginBottom: "1.2rem" }}
              >
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    cursor: "pointer",
                    fontSize: "1rem",
                    color: "#ffffff",
                  }}
                >
                  <input
                    type="radio"
                    name="deseja_vale_transporte"
                    value={true}
                    checked={
                      formData.deseja_vale_transporte === true ||
                      formData.deseja_vale_transporte === 1
                    }
                    onChange={() =>
                      setFormData((prev) => ({
                        ...prev,
                        deseja_vale_transporte: true,
                      }))
                    }
                    style={{
                      width: "18px",
                      height: "18px",
                      cursor: "pointer",
                      accentColor: "#0ea5e9",
                    }}
                  />
                  Sim, desejo adquirir
                </label>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    cursor: "pointer",
                    fontSize: "1rem",
                    color: "#ffffff",
                  }}
                >
                  <input
                    type="radio"
                    name="deseja_vale_transporte"
                    value={false}
                    checked={
                      formData.deseja_vale_transporte === false ||
                      formData.deseja_vale_transporte === 0
                    }
                    onChange={() =>
                      setFormData((prev) => ({
                        ...prev,
                        deseja_vale_transporte: false,
                      }))
                    }
                    style={{
                      width: "18px",
                      height: "18px",
                      cursor: "pointer",
                      accentColor: "#0ea5e9",
                    }}
                  />
                  Não desejo adquirir
                </label>
              </div>

              <div
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  borderRadius: "6px",
                  padding: "1rem",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.8rem",
                  color: "#ffffff",
                  fontSize: "0.95rem",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    color: "#134b8b",
                    borderRadius: "50%",
                    width: "20px",
                    height: "20px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "12px",
                    fontWeight: "bold",
                    flexShrink: 0,
                  }}
                >
                  i
                </div>
                Ao selecionar "Sim", informe abaixo os meios de transporte
                utilizados no deslocamento.
              </div>
            </div>

            {(formData.deseja_vale_transporte === true ||
              formData.deseja_vale_transporte === 1) && (
              <div className="tca-fade-in" style={{ marginTop: "2rem" }}>
                {renderTabelaTransporte(
                  "pratica",
                  "PRÁTICA NA EMPRESA",
                  "Informe os meios de transporte utilizados no deslocamento entre sua residência e o local de prática.",
                  "🏢",
                )}

                {renderTabelaTransporte(
                  "teoria",
                  "TEORIA NO CIEE/MG",
                  "Informe os meios de transporte utilizados no deslocamento entre sua residência e o local de teoria (CIEE/MG).",
                  "📖",
                )}

                <div
                  style={{
                    backgroundColor: "rgba(255, 230, 150, 0.15)",
                    border: "1px solid rgba(255, 200, 50, 0.4)",
                    borderRadius: "8px",
                    padding: "1.5rem",
                    marginTop: "1rem",
                    display: "flex",
                    gap: "1.5rem",
                    alignItems: "center",
                  }}
                >
                  <div style={{ fontSize: "2.5rem", flexShrink: 0 }}>📝</div>
                  <div>
                    <h5
                      style={{
                        color: "#ffd24d",
                        fontWeight: "bold",
                        margin: "0 0 0.5rem 0",
                        fontSize: "1.1rem",
                      }}
                    >
                      Declaração
                    </h5>
                    <p
                      style={{
                        color: "#ffffff",
                        margin: 0,
                        fontSize: "0.95rem",
                        lineHeight: "1.5",
                      }}
                    >
                      Declaro, para os devidos fins, que as informações acima
                      são verdadeiras e que utilizarei o vale-transporte
                      exclusivamente para o meu deslocamento residência-trabalho
                      e vice-versa.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        <section className="tca-card tca-mb-4" id="tca-section-dependentes">
          <div className="tca-card-header">
            11. Declaração de Encargos da Família (Imposto de Renda)
          </div>

          <div className="tca-card-body">
            <div className="tca-row">
              <div className="tca-col-md-6 tca-mb-3">
                <label>Possui dependentes?</label>
                <select
                  className="tca-form-control"
                  name="possui_dependentes"
                  value={formData.possui_dependentes}
                  onChange={handleChange}
                  disabled={isCampoBloqueadoParaEmpresa("possui_dependentes")}
                >
                  <option value="">Selecione</option>
                  <option value="sim">Sim</option>
                  <option value="nao">Não</option>
                </select>
              </div>
              <div className="tca-col-md-6 tca-mb-3">
                <label>Nome do Declarante</label>
                <input
                  className="tca-form-control"
                  name="nome_declarante_ir"
                  value={formData.nome_declarante_ir}
                  onChange={handleChange}
                  disabled={
                    formData.possui_dependentes === "nao" ||
                    isCampoBloqueadoParaEmpresa("nome_declarante_ir")
                  }
                />
              </div>
              <div className="tca-col-md-3 tca-mb-3">
                <label>CPF</label>{" "}
                <InputMask
                  mask="999.999.999-99"
                  maskChar=" "
                  className="tca-form-control"
                  name="cpf_declarante_ir"
                  value={formData.cpf_declarante_ir}
                  onChange={handleChange}
                  disabled={
                    formData.possui_dependentes === "nao" ||
                    isCampoBloqueadoParaEmpresa("cpf_declarante_ir")
                  }
                />
              </div>
              <div className="tca-col-md-3 tca-mb-3">
                <label>Estado Civil</label>
                <input
                  className="tca-form-control"
                  name="estado_civil_ir"
                  value={formData.estado_civil_ir}
                  onChange={handleChange}
                  disabled={
                    formData.possui_dependentes === "nao" ||
                    isCampoBloqueadoParaEmpresa("estado_civil_ir")
                  }
                />
              </div>
            </div>
            {formData.possui_dependentes !== "nao" && (
              <>
                <hr className="tca-hr" />

                <h6 className="tca-h6">Dependentes</h6>

                {dependentesList.map((numero) => (
                  <div key={numero}>
                    {renderDependente(numero, () => removerDependente(numero))}
                  </div>
                ))}

                <div
                  style={{ display: "flex", gap: "10px", marginTop: "1rem" }}
                >
                  <button
                    type="button"
                    className="tca-btn tca-btn-outline-primary"
                    onClick={
                      isCampoBloqueadoParaEmpresa("dependente_1_nome")
                        ? undefined
                        : adicionarDependente
                    }
                    disabled={isCampoBloqueadoParaEmpresa("dependente_1_nome")}
                  >
                    + Adicionar dependente
                  </button>
                  <button
                    type="button"
                    className="tca-btn tca-btn-primary"
                    onClick={() => setMostrarDeclaracaoDependentes(true)}
                    disabled={isCampoBloqueadoParaEmpresa("dependente_1_nome")}
                  >
                    Salvar Dependentes
                  </button>
                </div>
              </>
            )}
          </div>
        </section>

        {mostrarDeclaracaoDependentes && (
          <div
            className="tca-modal-overlay"
            style={{
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(0,0,0,0.5)",
            }}
            onClick={(e) => {
              if (e.target === e.currentTarget)
                setMostrarDeclaracaoDependentes(false);
            }}
          >
            <div
              className="tca-modal-content"
              style={{
                maxWidth: "650px",
                padding: "24px",
                borderRadius: "12px",
                background: "#fff",
                boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
              }}
            >
              <h3
                style={{
                  marginTop: 0,
                  color: "#1e3a8a",
                  fontSize: "1.25rem",
                  fontWeight: "bold",
                  borderBottom: "1px solid #e2e8f0",
                  paddingBottom: "12px",
                  marginBottom: "16px",
                }}
              >
                Declaração
              </h3>
              <div
                style={{
                  fontSize: "0.95rem",
                  lineHeight: "1.6",
                  color: "#334155",
                  textAlign: "justify",
                }}
              >
                <p>
                  Declaro, sob penas da lei, que as informações aqui prestadas
                  são verdadeiras e de minha inteira responsabilidade, não
                  cabendo a V.Sas. (fonte pagadora) qualquer responsabilidade a
                  fiscalização.
                </p>
                <p>
                  Sempre que ocorrer alteração nesta declaração, a mesma deverá
                  ser renovada.
                </p>
                <p
                  style={{
                    fontSize: "0.85rem",
                    backgroundColor: "#f1f5f9",
                    padding: "12px",
                    borderRadius: "8px",
                    borderLeft: "4px solid #cbd5e1",
                  }}
                >
                  <strong>Obs.:</strong> São dependentes para fins do imposto de
                  renda: cônjuge ou companheiro com quem o contribuinte tenha
                  filho ou viva há mais de cinco anos. Filhos ou enteados de até
                  21 anos ou em qualquer idade quando incapacitado física ou
                  mentalmente para o trabalho ou de até 24 anos se ainda estiver
                  cursando ensino superior ou escola técnica de segundo grau.
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "24px",
                }}
              >
                <button
                  type="button"
                  className="tca-btn tca-btn-primary"
                  onClick={() => {
                    setMostrarDeclaracaoDependentes(false);
                    setCienteDeclaracaoDependentes(true);
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "10px 24px",
                    fontSize: "1rem",
                    fontWeight: "bold",
                  }}
                >
                  <CheckCircle2 size={18} /> Ciente
                </button>
              </div>
            </div>
          </div>
        )}

        <section className="tca-card tca-mb-4">
          <div className="tca-card-header">12. Documentos para Admissão</div>
          <div className="tca-card-body">
            <div
              className="tca-anexos-container"
              style={{
                display: "grid",
                gridTemplateColumns:
                  "repeat(auto-fit, minmax(min(100%, 280px), 1fr))",
                gap: 14,
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              {ANEXOS_SCHEMA_TCA_EMPREGADOR.map((doc) => {
                const name = doc.id;
                const label = doc.label;
                const file = anexosFiles[name];
                const progress = anexosProgress[name] || 0;
                const status = anexosStatus[name];
                const isRequiredDoc = !!doc.required;
                const isHighlighted =
                  Array.isArray(anexosObrigatoriosDestacar) &&
                  anexosObrigatoriosDestacar.includes(name);

                const isAttached = Boolean(file);
                const showProgress = status === "uploading" && !isAttached;
                const visualStatus =
                  status === "done" || isAttached ? "anexado" : "pendente";

                const statusConfig = {
                  anexado: {
                    icon: <CheckCircle2 size={16} color="#0f6e56" />,
                    label: file?.name || "Anexado",
                    color: "#0f6e56",
                    bg: "rgba(15, 110, 86, 0.08)",
                    border: "rgba(15, 110, 86, 0.35)",
                  },
                  pendente: {
                    icon: isRequiredDoc ? (
                      <AlertCircle size={16} color="#b45309" />
                    ) : (
                      <Circle size={16} color="#888780" />
                    ),
                    label: "Pendente",
                    color: "#7c2d12",
                    bg: isRequiredDoc
                      ? "rgba(180, 83, 9, 0.08)"
                      : "transparent",
                    border: isRequiredDoc
                      ? "rgba(180, 83, 9, 0.35)"
                      : "rgba(180, 180, 175, 0.6)",
                  },
                }[visualStatus];

                const highlightStyle = isHighlighted
                  ? {
                      border: "1px solid #dc2626",
                      background: "#fef2f2",
                      boxShadow: "0 0 0 2px rgba(220, 38, 38, 0.18)",
                    }
                  : {};

                const IconComponent =
                  {
                    doc_comprovante_endereco: Home,
                    doc_declaracao_escolar: GraduationCap,
                    doc_identificacao_documento_indetificacao: IdCard,
                    doc_titulo_eleitor: IdCard,
                    doc_certificado_reservista: IdCard,
                  }[name] || FileText;

                return (
                  <div
                    key={name}
                    style={{
                      position: "relative",
                      background: "#fff",
                      border: `1px solid ${statusConfig.border}`,
                      borderRadius: 9,
                      padding: "10px 10px",
                      display: "flex",
                      flexDirection: "column",
                      gap: 6,
                      minHeight: 130,
                      boxSizing: "border-box",
                      boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
                      ...highlightStyle,
                    }}
                    title={
                      isHighlighted
                        ? "Anexo pendente, conforme retorno do servidor."
                        : undefined
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        <input
                          type="checkbox"
                          id={name}
                          name={name}
                          checked={formData[name] || false}
                          onChange={handleChange}
                          disabled={isCampoBloqueadoParaEmpresa(name)}
                          style={{
                            cursor: isCampoBloqueadoParaEmpresa(name)
                              ? "not-allowed"
                              : "pointer",
                            width: 14,
                            height: 14,
                          }}
                        />
                        <div
                          style={{
                            width: 24,
                            height: 24,
                            borderRadius: 6,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: statusConfig.bg,
                          }}
                        >
                          <IconComponent size={14} color="#5f5e5a" />
                        </div>
                      </div>
                      <div>{statusConfig.icon}</div>
                    </div>

                    <div style={{ flex: 1, minWidth: 0 }}>
                      <span
                        style={{
                          fontWeight: 600,
                          fontSize: 12.5,
                          color: "#1c1917",
                          lineHeight: 1.25,
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {label}
                        {isRequiredDoc && !isAttached && (
                          <span
                            title="Campo obrigatório"
                            style={{
                              marginLeft: 6,
                              display: "inline-block",
                              padding: "1px 6px",
                              borderRadius: 999,
                              background: "rgba(180, 83, 9, 0.12)",
                              color: "#b45309",
                              fontSize: 10,
                              fontWeight: 700,
                              letterSpacing: 0.4,
                              textTransform: "uppercase",
                              lineHeight: 1.4,
                              verticalAlign: "middle",
                            }}
                          >
                            Obrigatório
                          </span>
                        )}
                      </span>
                      <p
                        style={{
                          fontSize: 10.5,
                          margin: "2px 0 0",
                          color: statusConfig.color,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          fontWeight: 500,
                        }}
                        title={statusConfig.label}
                      >
                        {showProgress ? "Enviando…" : statusConfig.label}
                      </p>
                    </div>

                    <label
                      htmlFor={`file-input-${name}`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 6,
                        padding: "6px 12px",
                        borderRadius: 8,
                        background: isAttached ? "#01336d" : "transparent",
                        border: "1px solid #01336d",
                        color: isAttached ? "#ffffff" : "#01336d",
                        fontSize: 11.5,
                        fontWeight: 600,
                        letterSpacing: 0.3,
                        cursor: isCampoBloqueadoParaEmpresa(name)
                          ? "not-allowed"
                          : "pointer",
                        opacity: isCampoBloqueadoParaEmpresa(name) ? 0.5 : 1,
                        pointerEvents: isCampoBloqueadoParaEmpresa(name)
                          ? "none"
                          : "auto",
                        transition: "background-color 0.2s ease",
                      }}
                    >
                      {isAttached ? (
                        <Paperclip size={12} />
                      ) : (
                        <Upload size={12} />
                      )}
                      {isAttached ? "Substituir" : "Anexar"}
                    </label>

                    <input
                      id={`file-input-${name}`}
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      style={{ display: "none" }}
                      onChange={handleAnexoChange(name)}
                      disabled={isCampoBloqueadoParaEmpresa(name)}
                    />
                  </div>
                );
              })}
            </div>

            <div className="tca-eight-5 tca-mt-3">
              <label>
                Observação: Gentileza anexar os documentos atualizados.
                Documentos ilegíveis ou vencidos podem atrasar a contratação.
              </label>
            </div>
          </div>
        </section>

        <section className="tca-card tca-mb-4" id="tca-section-obs">
          <div className="tca-card-header">
            13. Observações para ajuste na emissão do contrato (CIEE/MG)
          </div>
          <div className="tca-card-body tca-text-center">
            <div className="tca-toggle-group tca-mb-4">
              <button
                type="button"
                className={`tca-toggle-btn ${formData.inserir_observacoes ? "active" : ""}`}
                onClick={() =>
                  setFormData((p) => ({
                    ...p,
                    inserir_observacoes: true,
                    observacoes_ajuste_contrato: "",
                  }))
                }
              >
                {formData.inserir_observacoes
                  ? "✓ Inserir Particularidades para emissão do contrato"
                  : "Inserir Particularidades para emissão do contrato"}
              </button>
              <button
                type="button"
                className={`tca-toggle-btn ${!formData.inserir_observacoes ? "active" : ""}`}
                onClick={() =>
                  setFormData((p) => ({
                    ...p,
                    inserir_observacoes: false,
                    observacoes_ajuste_contrato: "",
                  }))
                }
              >
                {!formData.inserir_observacoes
                  ? "✓ Não Inserir Particularidades para emissão do contrato"
                  : "Não Inserir Particularidades para emissão do contrato"}
              </button>
            </div>
            {formData.inserir_observacoes && (
              <div className="tca-textarea-container tca-visible">
                <textarea
                  className="tca-form-control"
                  rows="4"
                  name="observacoes_ajuste_contrato"
                  value={formData.observacoes_ajuste_contrato}
                  onChange={handleChange}
                  placeholder="Digite aqui."
                ></textarea>
              </div>
            )}
          </div>
        </section>

        {podeAprovar &&
          tcaStatus &&
          [
            "PENDENTE",
            "AGUARDANDO_VALIDACAO",
            "EM_VALIDACAO",
            "EM_ANALISE",
          ].includes(tcaStatus) && (
            <div className="tca-card tca-mb-4">
              <div className="tca-card-header">Aprovação</div>
              <div className="tca-card-body">
                <p>Este TCA está aguardando aprovação.</p>
                <div className="tca-d-flex tca-gap-2">
                  <button
                    type="button"
                    className="tca-btn tca-btn-success"
                    onClick={aprovarTcaEmpregador}
                  >
                    ✅ Aprovar
                  </button>
                  <button
                    type="button"
                    className="tca-btn tca-btn-danger"
                    onClick={recusarTcaEmpregador}
                  >
                    ❌ Recusar
                  </button>
                </div>
              </div>
            </div>
        )}

        {modoEdicao &&
          tcaHistorico.length > 0 &&
          [3, 4].includes(Number(user?.acesso_autorizacao)) && (
          <div className="tca-card tca-mb-4">
            <div className="tca-card-header">Histórico de Transições</div>
            <div className="tca-card-body">
              <ul className="tca-historico-list">
                {tcaHistorico.map((h, i) => {
                  const corAnterior = getStatusCor(
                    h.status_anterior || "início",
                  );
                  const corNovo = getStatusCor(h.status_novo);

                  return (
                    <li key={i} className="tca-historico-item">
                      <div className="tca-historico-status">
                        <span
                          className="tca-historico-badge"
                          style={{ background: corAnterior, color: "#fff" }}
                        >
                          {h.status_anterior || "início"}
                        </span>
                        <span className="tca-historico-seta">→</span>
                        <span
                          className="tca-historico-badge"
                          style={{ background: corNovo, color: "#fff" }}
                        >
                          {h.status_novo}
                        </span>
                      </div>

                      <small className="tca-historico-info">
                        Por: {h.usuario_nome || h.usuario_id} ({h.usuario_tipo})
                      </small>
                      <small className="tca-historico-info">
                        {new Date(h.created_at).toLocaleString("pt-BR")}
                      </small>

                      {h.observacao && (
                        <div className="tca-historico-observacao">
                          {h.observacao}
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        )}

        <div
          className="tca-d-flex tca-mb-5"
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            marginTop: "2rem",
          }}
        >
          <button
            type="button"
            className="tca-btn tca-btn-secondary"
            onClick={() => navigate("/")}
          >
            Cancelar
          </button>

          {modoEdicao &&
          tcaStatus === "AGUARDANDO_ESTUDANTE" &&
          isEstudante ? (
            <button
              type="button"
              onClick={openReview("estudante")}
              className="tca-btn tca-btn-success"
              disabled={submitting}
            >
              {submitting ? "Enviando…" : "✅ Submeter para CIEEMG"}
            </button>
          ) : (
            <button
              type="button"
              onClick={openReview("empresa")}
              className="tca-btn tca-btn-primary"
              disabled={submitting}
            >
              {submitting ? "Enviando…" : "Revisar e Enviar TCA"}
            </button>
          )}
        </div>

        {missingFieldsAlert.length > 0 && (
          <MissingFieldsAlert
            missingFields={missingFieldsAlert}
            onFieldClick={handleMissingFieldClick}
            onClose={() => setMissingFieldsAlert([])}
          />
        )}

        {showReview && (
          <div
            className="tca-modal-overlay"
            onClick={(e) => {
              if (e.target === e.currentTarget) setShowReview(false);
            }}
            role="dialog"
            aria-modal="true"
          >
            <div className="tca-modal-content">
              <FormReview
                data={buildReviewData()}
                onEdit={handleEditSection}
                onSubmit={handleConfirmSubmit}
                confirmMessage="Tem certeza que deseja enviar o TCA CIEEMG Empregador?"
              />
            </div>
          </div>
        )}
      </form>

      <ToastContainer toasts={toasts} onRemove={removeToast} />
      {confirmDialogEmpregador}

      <SuccessSubmitModal
        isOpen={successModalData.isOpen}
        onClose={() => {
          setSuccessModalData({ ...successModalData, isOpen: false });
          window.location.reload();
        }}
        formId={successModalData.tceId}
        role={successModalData.role}
        formType="TCA"
      />
    </div>
  );
};

export default TcaCieemgEmpregador;
